export default {
    /** ********* 公用 begin ********* */
    upload_oss_file: {
        method: 'GET',
        url: '/peanut/common/file/generatePostSignature',
    },
    upload_file: {
        method: 'POST',
        url: '/peanut/common/resource/icon/upload',
    },
    download_file: {
        method: 'GET',
        url: '/peanut/common/resource/icon/image',
    },
    dictionary_get_lang: {
        method: 'POST',
        url: '/peanut/common/dic/queryTypeInfo',
        format: {
            response: {
                nationality: [],        // employer所属国家
                age: [],                // 年龄范围
                caringSkills: [],       // 照顾人的技能
                languageSkills: [],     // 语言技能
                cookingSkills: [],      // 烹饪技能
                otherSkills: [],        // 其他技能
                roomType: [],           // 房间类型
                religion: [],           // 宗教
                maritalStatus: [],      // 婚姻状态
                educationLevel: [],     // 教育水平
                haveChild: [],          // 是否有孩子
                apartmentType: [],      // 公寓类型
                haveCaregiverDiploma: [],   // 是否有证书 multiSelectString
                helperNationality: [],      // helper所属的国家
                workingExperienceIn: [],    // helper工作的国家
                currentStatus: [],      // helper状态
                race: [],               // 种族
                keyWord: [],            // helper关键词
                interviewStatus: [],    // 面试状态
                interviewResult: [],    // 面试结果
                label: [],              // helper标签
                employerStatus: [],     // 雇主状态
                workDuty: [],           // helper工作历史的workDuty
                residential: [],        // employer residential status
            },
        },
    },
    dictionary_get: {               // 查字典
        method: 'GET',
        url: '/peanut/common/dic/getTypeInfo',
        format: {
            request: {
                type: String,
            },
            response: {
                nationality: [],        // employer所属国家
                age: [],                // 年龄范围
                caringSkills: [],       // 照顾人的技能
                languageSkills: [],     // 语言技能
                cookingSkills: [],      // 烹饪技能
                otherSkills: [],        // 其他技能
                roomType: [],           // 房间类型
                religion: [],           // 宗教
                maritalStatus: [],      // 婚姻状态
                educationLevel: [],     // 教育水平
                haveChild: [],          // 是否有孩子
                apartmentType: [],      // 公寓类型
                haveCaregiverDiploma: [],   // 是否有证书 multiSelectString
                helperNationality: [],      // helper所属的国家
                workingExperienceIn: [],    // helper工作的国家
                currentStatus: [],      // helper状态
                race: [],               // 种族
                keyWord: [],            // helper关键词
                interviewStatus: [],    // 面试状态
                interviewResult: [],    // 面试结果
                label: [],              // helper标签
                employerStatus: [],     // 雇主状态
                workDuty: [],           // helper工作历史的workDuty
                residential: [],        // employer residential status
                workSkills: [],
                caringSkillsForFilter: [],
                workSkillsForFilter: [],
                otherSkillsForFilter: [],
            },
        },
    },
    common_map_get: {               // 获取各端通用map
        method: 'GET',
        url: '/peanut/common/dic/getCommonTxtDic',
        format: {
            request: {
                type: String,
            },
            response: {
                allergies: [],          // Any allergies
                foodHandling: [],       // Food Handling
                diet: [],               // Diet
                accommodationProvided: [],
                insurancePlanChosen: [],
                applicationType: [],
                applicationTo: [],
                incomeUse: [],
                relationship: [],
                incomeSupportingDocs: [],
                cleaningTypeWindow: [],
                contractType: [],
                idType: [],
                contractStatus: [],
                releasePaperPass: [],
            },
        },
    },
    company_dictionary_get: {               // 各个公司自己的字典
        method: 'GET',
        url: '/peanut/manage/agency/dictionary/getDictionaryInfo',
        format: {
            request: {
                type: String,
            },
            response: {
                agency: [],
            },
        },
    },
    support_country_list: {               // 查询支持的国家列表
        method: 'GET',
        url: '/peanut/common/dic/getSupportLoginCountry',
        format: {
            response: [],
        },
    },
    support_employerCountry_list: {
        method: 'GET',
        url: '/peanut/common/dic/getEmployerSupportCountry',
        format: {
            response: [],
        },
    },
    support_employerCountry_list_by_keyword: {
        method: 'GET',
        url: '/peanut/common/dic/employer/listCountryByKeyword',
        format: {
            response: [],
        },
    },
    manager_list: {                     // 查询所有的manager账号
        method: 'GET',
        url: '/peanut/manage/employer/getAllResponsibleSales',
        format: {
            response: [],
        },
    },
    /** ********* 公用 end ********* */


    /** ********* 登录注册 begin ********* */
    user_login_info: {       // 用户登录前获取信息
        method: 'POST',
        url: '/peanut/common/getIdentityOwner',
        format: {
            request: {
                name: String,
                licenseNo: String,
            },
            response: '',
        },
    },
    user_login: {       // 用户登录
        method: 'POST',
        url: '/zuul_server/login',
        format: {
            request: {
                userName: String,
                password: String,
                userSystem: String,
                identityOwner: String,
            },
            response: {},
        },
    },
    user_logout: {      // 退出登录
        method: 'GET',
        url: '/zuul_server/localLogout',
    },

    company_license_check: {      // 验证license no是否存在、是否已注册
        method: 'GET',
        url: '/peanut/common/agency/checkInfo',
    },

    create_company_account: {      // 创建中介账号
        method: 'POST',
        url: '/peanut/common/agency/createAgencyAccount',
        format: {
            request: {
                name: String,
                licenseNo: String,
                uen: String,
                phoneNumber: String,
                contactName: String,
                password: String,
                address: String,
            },
        },
    },
    /** ********* 登录注册 end ********* */


    /** ********* chat begin ********* */
    user_yunxin_info: {                 // 获取客服的云信信息
        method: 'POST',
        url: '/imserver/account/getMyAccountInfo',
        format: {
            request: {
                userName: String,
                userId: Number,
                userSystem: String,
                identityOwner: String,
                userType: String,
            },
            response: {},
        },
    },
    cs_yunxin_info: {                   // 获取cs群组id
        method: 'POST',
        url: '/imserver/account/customerServiceChat',
        format: {
            request: {
                userId: Number,
                userName: String,
                userSystem: String,
                identityOwner: String,
                userType: String,
            },
            response: {},
        },
    },
    chat_helper_search: {               // 搜索helper
        method: 'POST',
        url: '/imserver/account/getInfoByName',
        format: {
            request: {
                userName: String,
                userSystem: String,
                identityOwner: String,
                userType: String,
            },
            response: [],
        },
    },
    chat_contact_get: {                 // 获取群组信息
        method: 'POST',
        url: '/imserver/account/getTeamInfoByIds',
        format: {
            response: [],
        },
    },
    employer_chat_contact_get: {                 // 查询聊天记录具体信息
        method: 'POST',
        url: '/imserver/account/getInfoByIds',
        format: {},
    },
    /** ********* chat end ********* */


    /** ********* employer begin ********* */
    employer_search: {                    // 模糊查询employer
        method: 'GET',
        url: '/peanut/manage/interview/getEmployerInfoByInfo',
        format: {
            response: [],
        },
    },
    employer_list: {                    // 查询employer列表
        method: 'POST',
        url: '/peanut/manage/employer/viewEmployerList',
        format: {
            request: {
                page: Number,
                size: Number,
                info: String,
                sort: String,
                sortType: String,
                nationality: [Number],
                employerStatus: [Number],
                onlineStatus: [Number],
                race: [Number],
                dataSource: [String],
                preferType: [Number],
                preferredNationality: [Number], //
                keyWord: [Number],
                employerLabel: [Number],
                responsibleSales: [String],
                isPrime: Boolean,
            },
            response: {
                items: [{
                    simpleInfo: {
                        caring: [],
                        cooking: [],
                        language: [],
                        otherSkill: [],
                        preferNationalityIntId: [],
                        helperTypeInt: [],
                    },
                    remarkList: [],
                }],
                followUpCount: 0,
                total: 0,
            },
        },
    },
    employer_account_status: {          // 修改employer的active状态
        method: 'POST',
        url: '/peanut/manage/employer/changeHelperAccountStatus',
        format: {
            request: {
                id: Number,
                status: Number,
            },
        },
    },
    employer_delete: {                  // 删除employer
        method: 'GET',
        url: '/peanut/manage/employer/deleteEmployer',
        format: {
            request: {
                id: Number,
            },
        },
    },
    employer_create: {                  // 创建employer
        method: 'POST',
        url: '/peanut/manage/employer/createEmployerAccount',
        format: {
            request: {
                fullName: String,
                title: String,
                phoneNumber: String,
                emailAddress: String,
                fbAccount: String,
                weChatId: String,
                dataSource: String,
                responsibleSales: String,
            },
        },
    },
    employer_contactTime_set: {         // 修改employer的Next Contact Date
        method: 'POST',
        url: '/peanut/manage/employer/updateNextContactDate',
        format: {
            request: {
                id: Number,
                nextContactDate: Number,
            },
        },
    },
    employer_remark_get: {              // 查询employer的remark列表
        method: 'GET',
        url: '/peanut/manage/employer/viewRemark/{id}',
        format: {
            request: {
                id: Number,
            },
            response: [],
        },
    },
    employer_remark_set: {              // 给employer添加一条remark
        method: 'POST',
        url: '/peanut/manage/employer/updateRemark',
        format: {
            request: {
                id: Number,
                remark: String,
            },
        },
    },
    employer_detail_get: {              // 查询employer简要信息
        method: 'GET',
        url: '/peanut/manage/employer/getMainInfo/{id}',
        format: {
            request: {
                id: Number,
            },
            response: {},
        },
    },
    employer_avatar_set: {              // 设置employer头像路径
        method: 'POST',
        url: '/peanut/manage/employer/updateIconInfo',
        format: {
            request: {
                id: Number,
                picture: String,
            },
        },
    },
    employer_jobs_employerInfo_get: {   // 查询employer job的Employer Information
        method: 'GET',
        url: '/peanut/manage/employer/viewJobEmployerInfo/{id}',
        format: {
            request: {
                id: Number,
            },
            response: {},
        },
    },
    employer_jobs_jobSummary_get: {     // 查询job summary information
        method: 'GET',
        url: '/peanut/manage/employer/viewJobSummary/{id}',
    },
    employer_light_post: {
        method: 'POST',
        url: '/peanut/manage/employer/updateSellingPoint',
    },
    employer_jobs_employerInfo_set: {   // 修改employer job的Employer Information
        method: 'POST',
        url: '/peanut/manage/employer/updateJobEmployerInfo',
        format: {
            request: {
                employerId: Number,
                nationalityId: Number,
                residential: Number,
                race: Number,
                apartmentType: Number,
                roomCount: Number,
                peopleCount: Number,
                childCount: Number,
                childAges: Array,
                havePets: Number,
                petInfo: Array,
                postcode: String,
                contactLocation: String,
            },
        },
    },
    employer_jobs_requirements_get: {   // 查询employer job的Requirements
        method: 'GET',
        url: '/peanut/manage/employer/viewJobRequirement/{id}',
        format: {
            response: {
                preferNationalityIntId: [],
                helperTypeInt: [],
                maritalStatusInt: [],
                educationLevelInt: [],
                religionInt: [],
                experienceInt: [],
                caring: [],
                cooking: [],
                language: [],
                otherSkill: [],
            },
        },
    },
    employer_jobs_requirements_set: {   // 修改employer job的Requirements
        method: 'POST',
        url: '/peanut/manage/employer/addOrUpdateJobRequirement',
        format: {
            request: {
                id: Number,
                employerId: Number,
                helperTypeInt: Array,
                preferNationalityIntId: Array,
                religionInt: Array,
                startDate: Number,
                asapStart: Boolean,
                caring: Array,
                language: Array,
                cooking: Array,
                ageMin: Number,
                ageMax: Number,
                maritalStatusInt: Array,
                educationLevelInt: Array,
                experienceInt: Array,
                haveChild: Number,
                heightMin: Number,
                heightMax: Number,
                weightMin: Number,
                weightMax: Number,
                bmiMin: Number,
                bmiMax: Number,
                mainDuty: String,
            },
        },
    },
    employer_jobs_jobOffer_get: {       // 查询employer job的Job Offer
        method: 'GET',
        url: '/peanut/manage/employer/viewJobOffer/{id}',
        format: {
            response: {
                workEnvironment: [],
            },
        },
    },
    employer_jobs_jobOffer_set: {       // 修改employer job的Job Offer
        method: 'POST',
        url: '/peanut/manage/employer/addOrUpdateJobOffer',
        format: {
            request: {
                id: Number,
                employerId: Number,
                salaryMin: Number,
                salaryMax: Number,
                restDay: Number,
                holidayOff: Number,
                privateRoomInfo: String,
            },
        },
    },
    employer_jobs_child_done: {         // 保存child信息
        method: 'POST',
        url: '/peanut/manage/helper/viewProfile/profile/{helperId}',
    },
    employer_jobs_status: {             // 修改employer的job状态
        method: 'POST',
        url: '/peanut/manage/employer/changeJobOpened',
        format: {
            request: {
                id: Number,
                status: Number,
            },
        },
    },
    employer_status: {                  // 修改employer的online Status
        method: 'GET',
        url: '/peanut/manage/employer/updateEmployerStatus/{id}/{status}',
        format: {
            request: {
                id: Number,
                status: Number,
            },
        },
    },
    employer_settings_detail: {         // 查询employer的Account Settings
        method: 'GET',
        url: '/peanut/manage/employer/viewAccountInfo/{id}',
        format: {
            request: {
                id: Number,
            },
            response: {
                phoneNumber: '',
            },
        },
    },
    employer_settings_edit: {            // 修改employer的Account Settings
        method: 'POST',
        url: '/peanut/manage/employer/updateAccountInfo',
        format: {
            request: {
                id: Number,
                opened: Number,
                fullName: String,
                title: String,
                phoneNumber: String,
                password: String,
                emailAddress: String,
                responsibleSales: String,
                dataSource: String,
                fbAccount: String,
                weChatId: String,
                whatsApp: String,
            },
        },
    },
    employer_EANote_get: {              // 查询employer的EA Note
        method: 'GET',
        url: '/peanut/manage/employer/viewEANote/{id}',
        format: {
            request: {
                id: Number,
            },
            response: {
                originRemark: [],
            },
        },
    },
    employer_EANote_set: {              // 修改employer的EA Note
        method: 'POST',
        url: '/peanut/manage/employer/updateEANote',
        format: {
            request: {
                remark: String,
                keyWordA: Number,
                keyWordB: Number,
            },
        },
    },
    employer_match_helper_list: {       // 查询employer匹配的helper列表
        method: 'POST',
        url: '/peanut/manage/matchHelper/getEmployerAutoMatchList/{id}',
        format: {
            response: {
                items: [{
                    simpleInfo: {
                        skill: {
                            caringSkills: [],
                            cookingSkills: [],
                            languageSkills: [],
                            otherSkills: [],
                        },
                        experience: [{
                            workTime: '',
                        }],
                    },
                    remarkList: [],
                }],
            },
        },
    },
    employer_match_filter: {            // 查询employer匹配helper的条件
        method: 'GET',
        url: '/peanut/manage/matchHelper/getMatchCondition/{id}',
        format: {
            response: {
                preferNationalityIntId: [],
                helperTypeInt: [],
                maritalStatusInt: [],
                educationLevelInt: [],
                helperLabel: [],
                religionInt: [],
                experienceInt: [],
                caringSkills: [],
                cookingSkills: [],
                languageSkills: [],
            },
        },
    },
    employer_match_helper_like_change: {    // 修改employer对helper的like状态
        method: 'GET',
        url: '/peanut/manage/matchHelper/likeOrDisLike/{employerId}/{helperId}/{like}',
        format: {
            request: {
                employerId: Number,
                helperId: Number,
                like: Number,
            },
        },
    },
    employer_match_helper_bio_sent: {       // 标记是否已经给employer发送了helper的biod data
        method: 'GET',
        url: '/peanut/manage/matchHelper/changeBioSend/{employerId}/{helperId}/{status}',
        format: {
            request: {
                employerId: Number,
                helperId: Number,
                status: Number,
            },
        },
    },
    employer_prime_history: {       // 查询employer prime历史
        method: 'GET',
        url: '/peanut/manage/employer/getPrimeInfo/{id}',
        format: {
            response: [],
        },
    },
    /** ********* employer end ********* */


    /** ********* helper begin ********* */
    helper_search: {                      // 模糊查询helper
        method: 'GET',
        url: '/peanut/manage/interview/getHelperInfoByInfo',
        format: {
            response: [],
        },
    },
    helper_list: {                          // 查询helper列表
        method: 'POST',
        url: '/peanut/manage/helper/viewHelperList',
        format: {
            request: {
                page: Number,
                size: Number,
                info: String,
                sort: String,
                sortType: String,
                opened: [],
                helperType: [],
                keyWord: [],
                agency: [],
                helperLabel: [],
                haveChild: [],
                dataSource: [],
                currentStatus: [],
                accountCreateBy: [],
                nationality: [],
                religion: [],
                maritalStatus: [],
                educationLevel: [],
                workNationalityId: [],
                caringSkills: [],
                cookingSkills: [],
                otherSkills: [],
                languageSkills: [],
                ageMin: Number,
                ageMax: Number,
                salaryMin: Number,
                salaryMax: Number,
                requestOnlineDateStart: Number,
                requestOnlineDateEnd: Number,
                approveOnlineDateStart: Number,
                approveOnlineDateEnd: Number,
                turnOffOnlineDateStart: Number,
                turnOffOnlineDateEnd: Number,
                directHire: [],
            },
            response: {
                items: [{
                    remarkList: [],
                    targetAgencyList: [],
                    targetAgencyListForHk: [],
                    targetAgencyListForMo: [],
                    targetAgencyListForTw: [],
                    targetAgencyListForCn: [],
                    targetAgencyListForMy: [],
                    targetAgencyListForOm: [],
                    targetAgencyListForQa: [],
                    targetAgencyListForSa: [],
                }],
                pendingCount: 0,
                onlineNationalityCount: {
                    Filipino: 0,
                    Indonesia: 0,
                    Myanmar: 0,
                },
                onlineTypeCount: {
                    EX: 0,
                    New: 0,
                    Transfer: 0,
                },
                total: 0,
            },
        },
    },
    helper_simple_info: {
        method: 'GET',
        url: '/peanut/manage/helper/viewHelperSimpleInfo',
        format: {
            response: {
                skill: {
                    caringSkills: [],
                    cookingSkills: [],
                    languageSkills: [],
                    otherSkills: [],
                },
                experience: [{
                    workTime: '',
                }],
            },
        },
    },
    get_helper_lack_msg: {
        method: 'POST',
        url: '/peanut/manage/helper/viewHelperOnlineLackMsg',
        format: {
            response: {
            },
        },
    },
    helper_delete: {                        // 删除helper
        method: 'POST',
        url: '/peanut/manage/helper/deleteHelperAccount',
        format: {
            request: {
                id: Number,
            },
        },
    },
    helper_country_set: {
        method: 'POST',
        url: '/peanut/manage/helper/editTargetCountryAreaList',
    },
    helper_contactTime_set: {               // 修改helper的Next Contact Date
        method: 'POST',
        url: '/peanut/manage/helper/updateNextContactDate',
        format: {
            request: {
                id: Number,
                nextContactDate: Number,
            },
        },
    },
    helper_account_status: {                // 修改helper的Active status
        method: 'POST',
        url: '/peanut/manage/helper/changeHelperAccountStatus',
        format: {
            request: {
                id: Number,
                status: Number,
            },
        },
    },
    status_list_get: {
        method: 'GET',
        url: '/peanut/manage/helper/getStatusInfo',
        format: {
            response: [],
        },
    },
    statusCommon_list_get: {
        method: 'GET',
        url: '/peanut/common/helper/getStatusInfo',
        format: {
            response: [],
        },
    },
    employeeStatus_list_get: {
        method: 'GET',
        url: '/peanut/manage/employer/getStatusInfo',
        format: {
            response: [],
        },
    },
    supplier_list_get: {
        method: 'GET',
        url: '/peanut/manage/supplier/getSupplierList',
        format: {
            response: {
                agency: [],
            },
        },
    },
    agency_supplier_list: {
        method: 'POST',
        url: '/peanut/manage/supplier/pageQuerySupplier',
        format: {
            response: {
                items: [],
            },
        },
    },
    supplier_agency_list: {
        method: 'POST',
        url: '/peanut/manage/supplier/pageQueryAgency',
        format: {
            response: {
                items: [],
            },
        },
    },
    bind_agency_supplier: {
        method: 'GET',
        url: '/peanut/manage/company/queryCompanyByNo',
    },
    confirm_bind_set: {
        method: 'GET',
        url: '/peanut/manage/supplier/bindSupplier',
    },
    confirm_bindAgency_set: {
        method: 'GET',
        url: '/peanut/manage/supplier/bindAgency',
    },
    confirm_lineBindAgency_set: {
        method: 'GET',
        url: '/peanut/manage/supplier/bindAgencyByBindId',
    },
    confirm_lineBind_set: {
        method: 'GET',
        url: '/peanut/manage/supplier/bindSupplierByBindId',
    },
    create_agency_supplier: {
        method: 'POST',
        url: '/peanut/manage/supplier/createRelatedSupplier',
    },
    create_supplier_agency: {
        method: 'POST',
        url: '/peanut/manage/supplier/createRelatedAgency',
    },
    edit_agency_supplier: {
        method: 'POST',
        url: '/peanut/manage/supplier/editRelatedSupplier',
    },
    getSupplierAgencyDetail: {
        method: 'GET',
        url: '/peanut/manage/supplier/detailAgency',
        format: {
            response: {},
        },
    },
    get_invitation_list: {
        method: 'GET',
        url: '/peanut/manage/supplier/queryBindInviteList',
        format: {
            response: [],
        },
    },
    get_merge_list: {
        method: 'GET',
        url: '/peanut/manage/supplier/querySelfCreateCompanyList',
        format: {
            response: [],
        },
    },
    accept_merge_list: {
        method: 'GET',
        url: '/peanut/manage/supplier/acceptBindInviteAndMerge',
    },
    get_shop_code: {
        method: 'GET',
        url: '/peanut/manage/supplier/shop/getShopCodeByAgencyId',
    },
    get_agency_side_helper_shop_code: {
        method: 'GET',
        url: '/peanut/manage/supplier/shop/getShopCodeBySpecifiedAgencyId',
    },
    share_helper_list: {
        method: 'POST',
        url: '/peanut/manage/company/getHelperList/{shopCode}/{targetCountry}',
        format: {
            response: {
                items: [{
                    simpleInfo: {
                        skill: {
                            caringSkills: [],
                            cookingSkills: [],
                            languageSkills: [],
                            otherSkills: [],
                        },
                        experience: [{
                            workTime: '',
                        }],
                    },
                    remarkList: [],
                }],
                total: 0,
            },
        },
    },
    new_helper_list: {
        method: 'POST',
        url: '/peanut/manage/company/query/newHelperFromSupplier',
        format: {
            request: {
                onlineTimeStart: 'formatUTC+8',
                onlineTimeEnd: 'formatUTC+8',
                displayOnlineTimeStart: 'formatUTC+8',
                displayOnlineTimeEnd: 'formatUTC+8',
            },
            response: {
                items: [{
                    additionalInfo: {},
                    simpleInfo: {
                        skill: {
                            caringSkills: [],
                            cookingSkills: [],
                            languageSkills: [],
                            otherSkills: [],
                        },
                        experience: [{
                            workTime: '',
                        }],
                    },
                    remarkList: [],
                }],
                total: 0,
            },
        },
    },
    get_share_helper_count: {
        method: 'GET',
        url: '/peanut/manage/company/query/supplierShareHelperCount',
        format: {
            response: {
                onlineNationalityCount: {
                    Filipino: 0,
                    Indonesia: 0,
                    Myanmar: 0,
                },
                onlineTypeCount: {
                    EX: 0,
                    New: 0,
                    Transfer: 0,
                },
            },
        },
    },
    get_new_helper_count: {
        method: 'GET',
        url: '/peanut/manage/company/query/newHelperFromSupplierCount',
        format: {
            response: {
                onlineNationalityCount: {
                    Filipino: 0,
                    Indonesia: 0,
                    Myanmar: 0,
                },
                onlineTypeCount: {
                    EX: 0,
                    New: 0,
                    Transfer: 0,
                },
            },
        },
    },
    check_earliestSync_notification: {
        method: 'POST',
        url: '/peanut/manage/company/checkEarliestSyncNotification',
    },
    confirm_check_notification: {
        method: 'POST',
        url: '/peanut/manage/company/confirmCheckSyncNotification',
    },
    get_notification_list: {
        method: 'GET',
        url: '/peanut/manage/company/getSyncNotificationCount',
        format: {
            response: {},
        },
    },
    confirm_ignore_set: {
        method: 'GET',
        url: '/peanut/manage/company/ignoreSyncNotification',
    },
    sync_notification_operation: {
        method: 'POST',
        url: '/peanut/manage/company/operateSyncNotification',
    },
    edit_supplier_agency: {
        method: 'POST',
        url: '/peanut/manage/supplier/editRelatedAgency',
    },
    get_pic_contact_list: {
        method: 'GET',
        url: '/peanut/manage/supplier/getPicContactList',
    },
    helper_create: {                        // 创建helper
        method: 'POST',
        url: '/peanut/manage/helper/createHelperAccount',
        format: {
            request: {
                phoneNumber: String,
                fullName: String,
                dataSource: String,
                agency: Number,
                agencyName: String,
                agencyCode: String,
                nationalityId: Number,
            },
        },
    },
    helper_status_set: {                // 修改helper的status
        method: 'GET',
        url: '/peanut/manage/helper/changeHelperCurrentStatus/{id}/{currentStatus}',
        format: {
            request: {
                id: Number,
                currentStatus: Number,
            },
        },
    },
    helper_column_setting: {
        method: 'POST',
        url: '/peanut/manage/agency/saveManagerSetting',
    },
    helper_light_post: {
        method: 'POST',
        url: '/peanut/manage/helper/updateSellingPoint',
    },
    helper_column_get: {
        method: 'GET',
        url: '/peanut/manage/agency/getCurrentAgencyInfo',
        format: {
            response: {
                userSetting: {
                    alwaysUpdate: true,
                },
            },
        },
    },
    helper_resume_open: {               // 修改helper的Online Status
        method: 'POST',
        url: '/peanut/manage/helper/resumeOpenDeal',
        format: {
            request: {
                id: Number,
                status: Number,
            },
        },
    },
    helper_remark_get: {                // 获取helper的remark列表
        method: 'GET',
        url: '/peanut/manage/helper/viewRemark/{id}',
        format: {
            request: {
                id: Number,
            },
            response: [],
        },
    },
    helper_resume_check: {
        method: 'GET',
        url: '/peanut/manage/helper/checkBeforeResumeOpenDeal/{id}/{opened}',
    },
    employer_resume_check: {
        method: 'GET',
        url: '/peanut/manage/employer/checkBeforeChangeJobOpened/{id}/{opened}',
    },
    helper_remark_set: {                // 给helper添加一条remark
        method: 'POST',
        url: '/peanut/manage/helper/updateRemark',
        format: {
            request: {
                id: Number,
                remark: String,
            },
        },
    },
    interview_remark_set: {
        method: 'POST',
        url: '/peanut/manage/interview/updateRemark',
    },
    hepler_momInfo_get: {
        method: 'GET',
        url: '/peanut/manage/helper/viewMOMInfo/{helperId}',
        format: {
            response: {},
        },
    },
    helper_mom_delete: {
        method: 'POST',
        url: '/peanut/manage/helper/deleteMOMPdfFile',
    },
    helper_detail_get: {                // 查询helper简要信息
        method: 'GET',
        url: '/peanut/manage/helper/getMainInfo/{id}',
        format: {
            request: {
                id: Number,
            },
            response: {
                targetCountryIdList: [],
            },
        },
    },
    get_history_feedback: {
        method: 'GET',
        url: '/peanut/manage/helper/viewEmploymentHistoryInfo/{helperId}',
        format: {
            response: {},
        },
    },
    save_history_feedback: {
        method: 'POST',
        url: '/peanut/manage/helper/updateEmploymentHistoryInfo',
    },
    helper_profile_get: {               // 查询helper的Profile
        method: 'GET',
        url: '/peanut/manage/helper/viewProfile/profile/{id}',
        format: {
            request: {
                id: Number,
            },
            response: {
                anyOtherRemarkList: [],
            },
        },
    },
    contract_profile_get: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/viewContractHelperProfile',
        format: {
            response: {
                anyOtherRemarkList: [],
            },
        },
    },
    helper_child_done: {
        method: 'POST',
        url: '/peanut/manage/helper/saveChildren/{id}',
    },
    contactLocationList_get: {
        method: 'GET',
        url: '/peanut/common/dic/getAirportByNationalityId/{nationalityId}',
        format: {
            response: [],
        },
    },
    contract_profile_set: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/updateContractHelperProfile',
    },
    helper_profile_set: {               // 修改helper的Profile
        method: 'POST',
        url: '/peanut/manage/helper/updateProfile/profile',
        format: {
            request: {
                helperId: Number,
                birthday: Number,
                fullName: String,
                birthPlace: String,
                religion: Number,
                maritalStatus: Number,
                educationLevel: Number,
                childCount: Number,
                childAges: Array,
                siblingCount: Number,
                siblingPosition: Number,
                allergiesInfo: String,
                foodPreferencesInfo: String,
                diet: String,
                height: Number,
                weight: Number,
                photo: String,
                nationalityId: Number,
                contactLocation: String,
                telephoneNumber: String,
                residentialAddress: String,
            },
        },
    },
    helper_introduction_get: {          // 查询helper的Self Introduction
        method: 'GET',
        url: '/peanut/manage/helper/viewProfile/selfDesc/{id}',
        format: {
            request: {
                id: Number,
            },
            response: {},
        },
    },
    helper_introduction_set: {          // 修改helper的Self Introduction
        method: 'POST',
        url: '/peanut/manage/helper/updateProfile/selfDesc',
        format: {
            request: {
                helperId: Number,
                selfDesc: String,
            },
        },
    },
    helper_history_get: {               // 查询helper的Employment History
        method: 'GET',
        url: '/peanut/manage/helper/viewEP/history/{id}',
        format: {
            request: {
                id: Number,
            },
            response: {
                workExperiences: [{
                    workTime: '',
                }],
            },
        },
    },
    contract_history_get: {               // 查询helper的Employment History
        method: 'POST',
        url: '/peanut/manage/contract/pdf/history',
        format: {
            request: {
                id: Number,
            },
            response: {
                workExperiences: [{
                    workTime: '',
                }],
            },
        },
    },
    helper_historySingle_set: {
        method: 'POST',
        url: '/peanut/manage/helper/updateOrAddSingleExperienceInfo',
    },
    contract_historySingle_set: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/dealContractHelperExperience',
    },
    helper_houseType_get: {
        method: 'GET',
        url: '/peanut/common/dic/getExperienceHouseTypeInfo',
        format: {
            response: [],
        },
    },
    helper_history_set: {               // 修改helper的Employment History
        method: 'POST',
        url: '/peanut/manage/helper/addOrUpdateExperienceInfo',
        format: {
            request: {
                helperId: Number,
                epList: [{
                    helperId: Number,
                    id: Number,
                    workTime: String,
                    workNationalityId: Number,
                    employerNationalityId: Number,
                    offReason: String,
                    workDutyLabelInt: [Number],
                    workDuty: String,
                    offRefer: String,
                }],
            },
        },
    },
    helper_history_delete: {            // 删除一条Employment History
        method: 'POST',
        url: '/peanut/manage/helper/delWorkEpx',
    },
    contract_history_delete: {            // 删除一条Employment History
        method: 'POST',
        url: '/peanut/manage/contract/pdf/delWorkEpx',
    },
    helper_skill_get: {                 // 查询helper的skill
        method: 'GET',
        url: '/peanut/manage/helper/viewEP/skill/{id}',
        format: {
            request: {
                id: Number,
            },
            response: {
                specialFood: '',
                caringSkills: [],
                cookingSkills: [],
                languageSkills: [],
                otherSkills: [],
            },
        },
    },
    contract_skill_get: {                 // 查询helper的skill
        method: 'POST',
        url: '/peanut/manage/contract/pdf/viewSkill',
        format: {
            request: {
                id: Number,
            },
            response: {
                specialFood: '',
                caringSkills: [],
                cookingSkills: [],
                languageSkills: [],
                otherSkills: [],
            },
        },
    },
    helper_skill_set: {                 // 修改helper的skill
        method: 'POST',
        url: '/peanut/manage/helper/updateSkillInfo',
        format: {
            request: {
                helperId: Number,
                specialFood: String,
                careDiploma: String,
                skills: [{
                    skillName: Number,
                    skillType: Number,
                    experience: Number,
                    level: Number,
                    observation: String,
                    dealMonth: Number,
                    originLevel: Number,
                    computeLevel: Number,
                    originExperience: Number,
                    computeExperience: Number,
                    pointByManager: Boolean,
                }],
            },
        },
    },
    contract_skill_set: {                 // 修改helper的skill
        method: 'POST',
        url: '/peanut/manage/contract/pdf/updateSkillInfo',
        format: {
            request: {
                specialFood: String,
                careDiploma: String,
                skills: [{
                    skillName: Number,
                    skillType: Number,
                    experience: Number,
                    level: Number,
                    observation: String,
                    dealMonth: Number,
                    originLevel: Number,
                    computeLevel: Number,
                    originExperience: Number,
                    computeExperience: Number,
                    pointByManager: Boolean,
                }],
            },
        },
    },
    helper_file_parseFile: {
        method: 'POST',
        url: '/peanut/manage/helper/parseMomFile',
    },
    helper_decode_confirm: {
        method: 'POST',
        url: '/peanut/manage/helper/insertDifFromMomPdf',
    },
    helper_file_edit: {                 // 修改helper的MOM文件
        method: 'POST',
        url: '/peanut/manage/helper/updateMOMPdfFile',
        format: {
            request: {
                id: Number,
                employmentPdf: String,
                employmentPdfName: String,
                newType: Boolean,
            },
        },
    },
    helper_video_edit: {                // 修改helper的自我介绍视频
        method: 'POST',
        url: '/peanut/manage/helper/updateVideoInfo',
        format: {
            request: {
                id: Number,
                selfDescVideo: String,
                selfDescVideoName: String,
            },
        },
    },
    helper_tailorVideo_edit: {
        method: 'POST',
        url: '/peanut/manage/helper/profile/updateTailorMadeVideo',
    },
    helper_video_delete: {              // 删除helper的自我介绍视频
        method: 'GET',
        url: '/peanut/manage/helper/deleteVideoInfo/{id}',
        format: {
            request: {
                id: Number,
            },
        },
    },
    contract_identity_detail: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/viewIdentityInfo',
        format: {
            response: {
                nationalIdPhoto: [],
                passportIssueDate: 'formatUTC+8',
                passportExpiry: 'formatUTC+8',
            },
        },
    },
    contract_identity_edit: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/updateIdentityInfo',
        format: {
            request: {
                helperId: Number,
                id: Number,
                finNumber: String,
                passportNumber: String,
                passportPicture: String,
                workPermitNumber: String,
                workPermitExpire: Number,
                cardSerialNo: String,
                workPermitPicture: String,
                passportIssueDate: 'formatUTC+8',
                passportExpiry: 'formatUTC+8',

            },
        },
    },
    helper_id_detail: {           // 查询helper的ID and Supporting Doc页面下的ID模块
        method: 'GET',
        url: '/peanut/manage/helper/idAndSupportingDocs/viewIdInfo',
        format: {
            response: {
                nationalIdPhoto: [],
                passportIssueDate: 'formatUTC+8',
                passportExpiry: 'formatUTC+8',

            },
        },
    },
    helper_id_edit: {             // 修改helper的ID and Supporting Doc页面下的ID模块
        method: 'POST',
        url: '/peanut/manage/helper/idAndSupportingDocs/updateIdInfo',
        format: {
            request: {
                helperId: Number,
                id: Number,
                finNumber: String,
                passportNumber: String,
                passportPicture: String,
                workPermitNumber: String,
                workPermitExpire: Number,
                cardSerialNo: String,
                workPermitPicture: String,
                passportIssueDate: 'formatUTC+8',
                passportExpiry: 'formatUTC+8',
            },
        },
    },
    helper_supportingDocs_detail: {           // 查询helper的ID and Supporting Doc页面下的Supporting Docs模块
        method: 'GET',
        url: '/peanut/manage/helper/idAndSupportingDocs/viewSupportingDocInfo',
        format: {
            response: {
                otherDocuments: [],
                medicalReportDocuments: [],
                tesdaCertificateDocuments: [],
            },
        },
    },
    helper_supportingDocs_edit: {             // 修改helper的ID and Supporting Doc页面下的Supporting Docs模块
        method: 'POST',
        url: '/peanut/manage/helper/idAndSupportingDocs/updateSupportingDocInfo',
        format: {
            request: {
                helperId: Number,
                id: Number,
                passportExpiry: Number,
                finNumber: String,
                passportNumber: String,
                passportPicture: String,
                workPermitNumber: String,
                workPermitExpire: Number,
                cardSerialNo: String,
                workPermitPicture: String,
            },
        },
    },
    helper_jobStatus_detail: {          // 查询helper的Job Status
        method: 'GET',
        url: '/peanut/manage/helper/viewJobStatus',
        format: {
            request: {
                id: Number,
            },
            response: {
                interviewType: [],
                targetAgencyList: [],
                targetAgencyListForHk: [],
                targetAgencyListForMo: [],
                targetAgencyListForTw: [],
                targetAgencyListForCn: [],
                targetAgencyListForMy: [],
                targetAgencyListForOm: [],
                targetAgencyListForQa: [],
                targetAgencyListForSa: [],
            },
        },
    },
    contract_jobStatus_detail: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/viewJobStatus',
        format: {
            request: {
                id: Number,
            },
            response: {
                interviewType: [],
                targetAgencyList: [],
                targetAgencyListForHk: [],
                targetAgencyListForMo: [],
                targetAgencyListForTw: [],
                targetAgencyListForCn: [],
                targetAgencyListForMy: [],
                targetAgencyListForOm: [],
                targetAgencyListForQa: [],
                targetAgencyListForSa: [],
            },
        },
    },
    contract_jobStatus_edit: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/updateJobStatus',
        format: {
            request: {
                helperId: Number,
                id: Number,
                availableDate: Number,
                interviewType: [String],
                opened: Number,
                helperType: Number,
                currentSalary: Number,
                anytimeValid: Number,
                releasePaperPicture: String,
                requestSeparateRoom: Number,
                requestHoliday: Number,
                requestPrivateToilet: Number,
                amountLoan: Number,
                loanPeriodRestDay: Number,
                compensationPerDay: Number,
                monthlyDeduction: Number,
                restDay: Number,
                expectSalaryMin: Number,
                monthOfDeduction: Number,
                amountPayableDuringPeriod: Number,
                amountPayableAfterPeriod: Number,
                loanDetail: String,
                otherPersonalLoan: {
                    amount: Number,
                    desc: String,
                },
            },
        },
    },
    helper_jobStatus_edit: {            // 修改helper的Job Status
        method: 'POST',
        url: '/peanut/manage/helper/updateJobStatus',
        format: {
            request: {
                helperId: Number,
                id: Number,
                availableDate: Number,
                interviewType: [String],
                opened: Number,
                helperType: Number,
                currentSalary: Number,
                anytimeValid: Number,
                releasePaperPicture: String,
                requestSeparateRoom: Number,
                requestHoliday: Number,
                requestPrivateToilet: Number,

                amountLoan: Number,
                loanPeriodRestDay: Number,
                compensationPerDay: Number,
                monthlyDeduction: Number,
                restDay: Number,
                expectSalaryMin: Number,
                monthOfDeduction: Number,
                amountPayableDuringPeriod: Number,
                amountPayableAfterPeriod: Number,
                loanDetail: String,
                otherPersonalLoan: {
                    amount: Number,
                    desc: String,
                },
            },
        },
    },
    helper_directHire_edit: {           // 设置helper是否可以被直聘
        method: 'GET',
        url: '/peanut/manage/helper/updateDirectHire/{id}/{directHire}',
        format: {
            request: {
                id: Number,
                directHire: Number,
            },
        },
    },
    helper_setting_detail: {            // 查询helper的Account Settings
        method: 'GET',
        url: '/peanut/manage/helper/viewAccountInfo',
        format: {
            request: {
                id: Number,
            },
            response: {
                emergencyContactList: [],
            },
        },
    },
    helper_settings_edit: {             // 修改helper的Account Settings
        method: 'POST',
        url: '/peanut/manage/helper/updateAccountInfo',
        format: {
            request: {
                id: Number,
                phoneNumber: String,
                accountCreateBy: String,
                dataSource: String,
                agency: Number,
                agencyCode: String,
                currentStatus: Number,
                fbAccount: String,
                whatsApp: String,
            },
        },
    },
    helper_EA_cost_detail: {
        method: 'GET',
        url: '/peanut/manage/helper/eaNote/viewEaNoteCost',
        format: {
            request: {
                id: Number,
            },
            response: {
                otherFees: [],
            },
        },
    },
    helper_EA_note_detail: {            // 查询helper的EA Note
        method: 'GET',
        url: '/peanut/manage/helper/eaNote/viewEaNoteEAInterview',
        format: {
            request: {
                id: Number,
            },
            response: {
                originRemark: [],
            },
        },
    },
    helper_cost_note_save: {
        method: 'POST',
        url: '/peanut/manage/helper/eaNote/updateEaNoteCost',
        format: {
            request: {
                id: Number,
                supplierFee: Number,
                escort: Number,
                ticket: Number,
                otherFees: Array,
                remark: String,
            },
        },
    },
    helper_EA_note_edit: {              // 修改helper的EA Note
        method: 'POST',
        url: '/peanut/manage/helper/eaNote/updateEaNoteEAInterview',
        format: {
            request: {
                id: Number,
            },
        },
    },
    helper_creator_list: {                  // 查询helper的创建者列表
        method: 'GET',
        url: '/peanut/manage/helper/getAllCreator',
        format: {
            response: [],
        },
    },
    helper_creatorShare_list: {
        method: 'GET',
        url: '/peanut/common/getAllCreator',
        format: {
            response: [],
        },
    },
    helper_match_employer_list: {           // 查询与helper匹配的employer列表
        method: 'POST',
        url: '/peanut/manage/matchHelper/getHelperAutoMatchList/{id}',
        format: {
            response: {
                items: [{
                    simpleInfo: {
                        skill: {
                            caringSkills: [],
                            cookingSkills: [],
                            languageSkills: [],
                            otherSkills: [],
                        },
                    },
                    remarkList: [],
                }],
            },
        },
    },
    helper_id_info: {                       // 查询helper的refer列表
        method: 'POST',
        url: '/peanut/manage/helper/getPeanutIdInfo',
        format: {
            request: {
                size: Number,
                page: Number,
                id: Number,
            },
            response: {
                referredFriend: {
                    items: [],
                },
                referral: {},
            },
        },
    },
    helper_refer_delete: {                  // 删除helper的refer
        method: 'POST',
        url: '/peanut/manage/helper/deletePeanutIdInfo',
        format: {
            request: {
                id: Number,
            },
        },
    },
    helper_refer_edit: {                    // 编辑helper的refer
        method: 'POST',
        url: '/peanut/manage/helper/updatePeanutIdInfo',
        format: {
            request: {
                id: Number,
                peanutId: Number,
            },
        },
    },
    notification_helper_get: {
        method: 'POST',
        url: '/peanut/manage/company/getSyncNotificationList',
    },
    bio_data_detail: {          // 查询helper biod data数据
        method: 'GET',
        url: '/peanut/common/helper/getHelperInfo/{id}',
        format: {
            response: {
                workExInfo: [{
                    workTime: '',
                }],
                skill: {
                    otherSkills: [],
                    cookingSkills: [],
                    caringSkills: [],
                    languageSkills: [],
                },
                eaRemark: '',
                loanDetail: '',
                agencyUserInfo: {},
                anyOtherRemarkList: [],
                childAges: [],
            },
        },
    },
    /** ********* helper end ********* */


    /** ********* contract begin ********* */
    contract_list: {                       // 查询contract列表
        method: 'POST',
        url: '/peanut/manage/contract/getContractList',
        format: {
            request: {
                size: Number,
                page: Number,
                sort: String,
                sortType: String,
                info: String,
                employerSource: [],
                helperSource: [],
                caseType: [],
                salesPerson: [],
                caseStatus: [],
            },
            response: {
                items: [],
            },
        },
    },
    contract_check_password: {
        method: 'GET',
        url: '/peanut/common/checkPassword/{password}/{code}',
    },
    contract_create: {
        method: 'POST',
        url: '/peanut/manage/contract/createContract',
        format: {
            request: {
                confirmationDate: Number,
                expectedDeploymentDate: Number,
                expectedDeploymentAsap: Boolean,
                caseType: Number,
                employerId: Number,
                employerPeanutId: String,
                helperId: Number,
                helperPeanutId: String,
                helperType: Number,
            },
        },
    },
    contract_check_employer: {
        method: 'GET',
        url: '/peanut/manage/contract/getEmployerLastContract/{employerId}',
    },
    contract_fee_list: {
        method: 'GET',
        url: '/peanut/manage/agency/feeTemplate/viewFeeTemplateList',
        format: {
            response: [{
                scenario: [],
            }],
        },
    },
    contract_fee_add: {
        method: 'POST',
        url: '/peanut/manage/agency/feeTemplate/addFeeTemplate',
    },
    contract_fee_edit: {
        method: 'POST',
        url: '/peanut/manage/agency/feeTemplate/updateFeeTemplate',
    },
    contract_fee_sort: {
        method: 'POST',
        url: '/peanut/manage/agency/feeTemplate/sortFeeTemplate',
    },
    contract_fee_delete: {
        method: 'GET',
        url: '/peanut/manage/agency/feeTemplate/deleteFeeTemplate/{id}',
    },
    contract_fee_editDelete: {
        method: 'GET',
        url: '/peanut/manage/agency/feeTemplate/deleteFeeTemplateScenario/{feeId}/{id}',
    },
    contract_remark_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateRemark',
    },
    contract_remark_get: {
        method: 'GET',
        url: '/peanut/manage/contract/viewRemark/{id}',
        format: {
            request: {
                id: Number,
            },
            response: [],
        },
    },
    contract_reopen: {
        method: 'POST',
        url: '/peanut/manage/contract/reopenContract',
    },
    contract_confirm_cancel: {
        method: 'POST',
        url: '/peanut/manage/contract/cancelContract',
    },
    contract_confirm_case: {
        method: 'POST',
        url: '/peanut/manage/contract/preCancelContract',
    },
    contract_close: {
        method: 'POST',
        url: '/peanut/manage/contract/closeContract',
    },
    contract_status_set: {
        method: 'GET',
        url: '/peanut/manage/contract/updateContractStatus/{id}/{status}',
        format: {
            request: {
                id: Number,
                status: Number,
            },
        },
    },
    contract_main_get: {
        method: 'POST',
        url: '/peanut/manage/contract/getContractMainInfo',
        format: {
            request: {
                refNo: String,
            },
            response: {},
        },
    },
    contract_sign_ready: {
        method: 'POST',
        url: '/peanut/manage/contract/checkAuthorizationSign',
    },
    contract_timeline_all: {
        method: 'POST',
        url: '/peanut/manage/contract/viewTimeLineInfo',
        format: {
            response: {
                stepInfo: {
                    confirmation: {
                        data: {
                            insuranceAddOns: [],
                        },
                        itemShowStatus: {},
                    },
                    ipaApplication: {
                        data: {},
                        itemShowStatus: {},
                    },
                    ipaApproval: {
                        data: {},
                        itemShowStatus: {},
                    },
                    securityBond: {
                        data: {},
                        itemShowStatus: {},
                    },
                    preArrival: {
                        data: {},
                        itemShowStatus: {},
                    },
                    shn: {
                        data: {},
                        itemShowStatus: {},
                    },
                    preDeployment: {
                        data: {
                        },
                        itemShowStatus: {},
                    },
                    arrival: {
                        data: {},
                        itemShowStatus: {},
                    },
                    deployment: {
                        data: {
                            // belongThing: [],
                            // belongThingImg: [],
                        },
                        itemShowStatus: {},
                    },
                    oecProcessing: {
                        data: {
                            ecVerifiedDate: 'formatUTC+8',
                        },
                    },
                },
            },
        },
    },
    contract_signingAgreement_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateSigningAgreement',
    },
    contract_reachArrival_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateArrival',
    },
    contract_ipaApplication_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateIPAApplication',
    },
    contract_ipaApproval_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateIPAArrival',
    },
    contract_ipaApprovalPdf_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateFile',
    },
    contract_fdwArrival_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updatePreArrival',
    },
    contract_medical_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updatePreDeployment',
    },
    contract_shn_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateShn',
    },
    contract_termination_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewTermination',
        format: {
            request: {
                refNo: String,
            },
        },
    },
    contract_termination_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateTermination',
    },
    contract_submission_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateSecurityBond',
    },
    contract_verbalConfirmation_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateConfirmation',
    },
    contract_deployment_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateDeployment',
    },
    contract_basicInfo_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewCaseBasicInfo',
        format: {
            request: {
                refNo: String,
            },
            response: {},
        },
    },
    contract_basicInfo_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateCaseBasicInfo',
        format: {
            request: {
                refNo: String,
                id: Number,
                contractEmployerId: Number,
                contractHelperId: Number,
                caseType: Number,
                salesPerson: String,
                expectedDeploymentDate: Number,
                expectedDeploymentAsap: Boolean,
                supplierCode: String,
                employerName: String,
                employerSource: String,
                helperName: String,
                helperSource: String,
            },
        },
    },
    contract_application_sponsor1Info: {
        method: 'POST',
        url: '/peanut/manage/contract/viewJointSponsorSelfInfo',
        format: {
            response: {},
        },
    },
    contract_application_sponsor1SpouseInfo: {
        method: 'POST',
        url: '/peanut/manage/contract/viewJointSponsorSpouseInfo',
        format: {
            response: {},
        },
    },
    contract_sponsor1Info_set: {
        method: 'POST',
        url: '/peanut/manage/contract/addOrUpdateJointSponsorInfo',
    },
    supplier_sponsor1Info_set: {
        method: 'POST',
        url: '/peanut/manage/contract/addOrUpdateJointSponsorInfo/forSupplier',
    },
    contract_sponsor1SpouseInfo_set: {
        method: 'POST',
        url: '/peanut/manage/contract/addOrUpdateJointSponsorSpouseInfo',
    },
    contract_jobOffer_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewJobOffer',
        format: {
            request: {
                refNo: String,
            },
            response: {
                infantAges: [],
                childAges: [],
            },
        },
    },
    contract_jobOffer_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateJobOffer',
        format: {
            request: {
                refNo: String,
                id: Number,
                basicSalary: Number,
                compensationPerOffDay: Number,
                amountLoan: Number,
                monthlySalaryDeduction: Number,
                loanPeriodRestDay: Number,
                restDayAfterLoan: Number,
                amountPayableAfterPeriod: Number,
                amountPayableDuringPeriod: Number,

                accommodationProvided: String,
                houseType: Number,
                roomCount: Number,
                bathroomCount: Number,
                peopleCount: Number,
                childCount: Number,
                childAges: Array,
                constantCare: Number,
                cleaningTypeWindow: Number,

                housework: Boolean,
                cooking: Boolean,
                clotheWashing: Boolean,
                careChild: Boolean,
                fetchChildrenSchool: Boolean,
                bedriddenPatient: Boolean,
                careElderly: Boolean,
                carPet: Boolean,
                washCar: Boolean,
                garden: Boolean,
                others: String,
            },
        },
    },
    contract_fee_basic_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateFBP',
        format: {
            request: {
                refNo: String,
                id: Number,
                agreementDate: Number,
                deploymentDate: Number,
                insurancePlan: Number,
                paymentFirst: Number,
                sbTransmissionNo: String,
                insurancePayment: Boolean,
                embassyBond: String,
            },
        },
    },
    contract_fee_breakDown_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewFBPFB',
        format: {
            request: {
                refNo: String,
            },
            response: {
                contractFeeDetailDTOList: [],
            },
        },
    },
    contract_fee_insurance: {
        method: 'POST',
        url: '/peanut/manage/contract/viewInsurance',
        format: {
            response: {
                insuranceAddOns: [],
            },
        },
    },
    contract_insurance_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateInsurance',
    },
    contract_fee_payment_save: {
        method: 'POST',
        url: '/peanut/manage/contract/savePaymentHistory',
    },
    contract_fee_breakDown_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateFBPFB',
        format: {
            request: {
                refNo: String,
                id: Number,
                agencyFee: Number,
                momApplication: Number,
                momIssuance: Number,
                medical: Number,
                sip: Number,
                transportation: Number,
                airTicket: Number,
                escort: Number,
                embassyContract: Number,
                basicInsurancePlan: Number,
                waierIndemnity: Number,
                phBondK2: Number,
                phBondK8: Number,
                others: Array,
                remark: String,
                totalPlacementFee: Number,
                agencyFeeFdw: Number,
            },
        },
    },
    contract_fee_payment_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewFBPPaymentHistory',
        format: {
            request: {
                refNo: String,
            },
            response: {
                payment: [],
            },
        },
    },
    contract_fee_payment_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateFBPPaymentHistory',
        format: {
            request: {
                refNo: String,
                payment: [{
                    payDate: Number,
                    amount: Number,
                    paymentMethod: Number,
                    remark: String,
                }],
            },
        },
    },
    contract_fee_payment_delete: {
        method: 'POST',
        url: '/peanut/manage/contract/deletePaymentHistory',
    },
    contract_receipt_get: {
        method: 'POST',
        url: '/peanut/common/contract/getReceiptInfo',
        format: {
            response: {},
        },
    },
    contract_receiptPDF_get: {
        method: 'POST',
        url: '/peanut/manage/contract/getGenerateReceiptInfo',
        format: {
            response: {},
        },
    },
    contract_application_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewBasicInfoOfApplication',
        format: {
            request: {
                refNo: String,
            },
            response: {},
        },
    },
    supplier_application_get: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/query/employerApplicationBasicInfo',
        format: {
            response: {},
        },
    },
    contract_application_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateBasicInfoOfApplication',
        format: {
            request: {
                refNo: String,
                id: Number,
                applicationType: Number,
                applicationTo: Number,
                incomeUse: Number,
                replaceHelperName: String,
            },
        },
    },
    supplier_application_set: {
        method: 'PUT',
        url: '/peanut/manage/supplier/contract/edit/employerApplicationBasicInfo',
    },
    contract_helperInfo_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewContractHelperInfo',
        format: {
            request: {
                refNo: String,
            },
            response: {
                helperBirthday: 'formatUTC+8',
            },
        },
    },
    contract_helperInfo_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateContractHelperInfo',
        format: {
            request: {
                id: Number,
                refNo: String,
                helperName: String,
                helperType: Number,
                workPermitNumber: String,
                finNumber: String,
                helperPassportNumber: String,
                helperPassportExpiry: Number,
                helperBirthday: 'formatUTC+8',
                religion: Number,
                educationLevel: Number,
                helperMaritalStatus: Number,
                helperNationalityId: Number,
                salaryBasic: Number,
                offDay: Number,
                agencyFeeFdw: Number,
            },
        },
    },
    contract_employerInfo_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewContractEmployerInfo',
        format: {
            request: {
                refNo: String,
            },
            response: {
                employerBirthday: 'formatUTC+8',
                spouseBirthday: 'formatUTC+8',
                currentHelperInfo: [],
            },
        },
    },
    supplier_employerInfo_get: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/query/employerInfo',
        format: {
            request: {
                refNo: String,
            },
            response: {
                employerBirthday: 'formatUTC+8',
                spouseBirthday: 'formatUTC+8',
            },
        },
    },
    contract_employerInfo_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateContractEmployerInfo',
        format: {
            request: {
                id: Number,
                refNo: String,
                employerName: String,
                gender: Number,
                employerNationalityId: Number,
                nricFin: String,
                residential: Number,
                employerPassportNumber: String,
                employerPassportExpiry: Number,
                employerMaritalStatus: String,
                residentialAddress: String,
                emailAddress: String,
                employerPhoneNumber: String,
                incomeSupportingDocs: Number,
                monthSalaryMax: Number,
                monthSalaryMin: Number,
                employerBirthday: 'formatUTC+8',
                spouseBirthday: 'formatUTC+8',
                familyMembers: [{
                    birthday: 'formatUTC+8',
                }],
            },
        },
    },
    supplier_employerInfo_set: {
        method: 'PUT',
        url: '/peanut/manage/supplier/contract/edit/employerInfo',
        format: {
            request: {
                employerBirthday: 'formatUTC+8',
                spouseBirthday: 'formatUTC+8',
                familyMembers: [{
                    birthday: 'formatUTC+8',
                }],
            },
        },
    },
    contract_employerSpouse_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewContractEmployerSpouseInfo',
        format: {
            request: {
                refNo: String,
            },
            response: {},
        },
    },
    contract_employerSpouse_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateContractEmployerSpouseInfo',
        format: {
            request: {
                id: Number,
                refNo: String,
                spouseName: String,
                spouseGender: Number,
                spouseBirthday: Number,
                spouseNationalityId: Number,
                spouseNricFin: String,
                spouseResidential: Number,
                spousePassportNumber: String,
                spousePassportExpiry: Number,
            },
        },
    },
    contract_employerFamily_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewEmployerFamilyMemberList',
        format: {
            response: [{
                birthday: 'formatUTC+8',
            }],
        },
    },
    contract_employerFamily_set: {
        method: 'POST',
        url: '/peanut/manage/contract/saveEmployerFamilyMemberList',
        format: {
            request: {
                employerId: Number,
                list: [{
                    id: Number,
                    name: String,
                    relationship: Number,
                    idNo: String,
                    idType: Number,
                    birthday: Number,
                }],
            },
        },
    },
    contract_member_edit: {
        method: 'POST',
        url: '/peanut/manage/contract/updateEmployerFamilyMember',
    },
    contract_employerFamily_delete: {
        method: 'POST',
        url: '/peanut/manage/contract/deleteEmployerFamilyMember',
    },
    contract_member_add: {
        method: 'POST',
        url: '/peanut/manage/contract/saveEmployerFamilyMember',
    },
    contract_mom_update: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/uploadOldMom',
    },
    contract_momNew_update: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/uploadNewMom',
    },
    contract_declaration_update: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/uploadDeclarationForm',
    },
    supplierContract_declaration_update: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/update/declarationForm',
    },
    contract_customized_update: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/uploadCustomizedForm',
    },
    contract_pdf_get: {
        method: 'POST',
        url: '/peanut/manage/contract/getContractPDFName',
        format: {
            response: [],
        },
    },
    contract_pdf_sign_progress: {
        method: 'POST',
        url: '/peanut/manage/contract/signProgress',
        format: {
            request: {
                refNo: String,
                pdfName: [],
            },
            response: [],
        },
    },
    contract_pdf_sign_ays: {
        method: 'POST',
        url: '/peanut/manage/contract/getContractParseResult',
    },
    contract_pdf_sign_renew: {
        method: 'POST',
        url: '/peanut//manage/contract/renewSignInfo',
        format: {
            request: {
                refNo: String,
                pdfNames: String,
            },
        },
    },
    contract_document_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewContractFileInfo',
        format: {
            request: {
                refNo: String,
            },
            response: [],
        },
    },
    contract_service_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateServiceAgreementDetail',
    },
    contract_service_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewServiceAgreementDetail',
        format: {
            response: {},
        },
    },
    contract_employmentContract_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateEmploymentContractDetail',
    },
    contract_employmentContract_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewEmploymentContractDetail',
        format: {
            response: {},
        },
    },
    supplier_employmentContract_get: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/query/POEAEmploymentContractSetting',
        format: {
            response: {
                extraRecruitmentAgency: '',
                extraHelperAddress: '',
                extraHelperContactNos: '',
                extraLicenseNo: '',
                philippineRecruitmentAgency: '',
                helperAddress: '',
                helperContactNos: '',
                minimumSalary: 0,
            },
        },
    },
    supplier_employmentContract_set: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/save/POEAEmploymentContractSetting',
    },
    contract_signed_doc_get: {
        method: 'POST',
        url: '/peanut/manage/contract/viewContractFileSignDocInfo',
        format: {
            request: {
                refNo: String,
            },
            response: [{
                list: [],
            }],
        },
    },
    contract_document_add: {
        method: 'POST',
        url: '/peanut/manage/contract/addContractFile',
        format: {
            request: {
                fileName: String,
                filePath: String,
                fileType: Number,
                refNo: String,
            },
        },
    },
    contract_document_delete: {
        method: 'POST',
        url: '/peanut/manage/contract/deleteContractFile',
        format: {
            request: {
                refNo: String,
                id: Number,
            },
        },
    },

    contract_pdf_data: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/getPdfInfo',
        format: {
            request: {
                refNo: String,
                pdfNames: String,
            },
            response: {
                pdfName: [],
                jobOffer: {
                    accommodationProvided: '',
                    remark: '',
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        sign_proxy_agency: {},
                        firstTime: '',
                    },
                    signTime: {},
                },
                authorisationLetter: {
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        firstTime: '',
                    },
                    signTime: {},
                },
                PDPA: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                    },
                },
                applicationForm: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                    },
                },
                sponsorDetails: {
                    signTime: {},
                    signatureImgPath: {
                        sign_sponsor_1: {},
                        sign_sponsor_2: {},
                    },
                    sponsor1: {},
                    sponsor2: {},
                },
                jointApplicant: {
                    signTime: {},
                    signatureImgPath: {
                        sign_joint: {},
                    },
                },
                incomeTaxDeclaration: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_spouse: {},
                    },
                },
                MOMAuthorisationForm: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                MOMAuthorisationFormForCancellationOfHelperReplaced: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                    },
                },
                MOMAuthorisationFormRenewal: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                offDayAgreement: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                    },
                },
                incomeTaxDeclarationSponsorship: {
                    signTime: {},
                    signatureImgPath: {
                        sign_sponsor_1: {},
                        sign_sponsor_2: {},
                    },
                },
                incomeTaxDeclarationJointApplication: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_joint: {},
                    },
                },
                handingOverForm: {
                    signTime: {},
                    signatureImgPath: {
                        firstTime: '',
                        sign_employer: {},
                        sign_helper: {},
                    },
                },
                serviceAgreementOrdinary: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                packageFeeOrdinary: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                    },
                },
                packageFeeReplacement: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                    },
                },
                packageFeeAdmin: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                    },
                },
                newEQProposalForm: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                    },
                },
                domesticMaidProposalForm: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                    },
                },
                acknowledgementOfAdditionalMoneyDeduction: {
                    signTime: {},
                    signatureImgPath: {
                        sign_helper: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                salarySchedule: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        firstTime: '',
                    },
                    salaryScheduleList: [],
                },
                FDWOrientationChecklist: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        firstTime: '',
                    },
                },
                formA: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                formB: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                formC: {
                    signTime: {},
                    signatureImgPath: {
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        firstTime: '',
                    },
                },
                MOMEmploymentHistoryNew: {
                    signTime: {},
                    signPosition: {
                        pageIndexList: [],
                    },
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                    },
                    bo: {},
                },
                MOMEmploymentHistoryOld: {
                    signTime: {},
                    signPosition: {
                        pageIndexList: [],
                    },
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                    },
                    bo: {},
                },
                securityBond: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        firstTime: '',
                    },
                },
                declarationForm: {
                    signTime: {},
                    signPosition: {
                        pageIndexList: [],
                    },
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        sign_proxy_agency: {},
                        firstTime: '',
                    },
                },
                customized: {
                    signTime: {},
                    signPosition: {
                        pageIndexList: [],
                    },
                    signatureImgPath: {
                        sign_employer: {},
                        firstTime: '',
                    },
                },
                PoeaEmploymentContract: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_proxy_agency: {},
                        firstTime: '',
                    },
                },
                PoeaUndertakingOfEmployer: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        firstTime: '',
                    },
                },
                safetyAgreementMyanmar: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                    },
                },
                safetyAgreementIndonesian: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                    },
                },
                safetyAgreementPhilippines: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                    },
                },
                safetyAgreementIndian: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                    },
                },
                employmentContract: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                    },
                },
                FDWPersonalBelongingsChecklist: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                overlappingLetter: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        firstTime: '',
                    },
                },
                renewalDeclarationForm: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                    },
                },
                bioData: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                    },
                    workExInfo: [{
                        workTime: '',
                    }],
                    skill: {
                        otherSkills: [],
                        cookingSkills: [],
                        caringSkills: [],
                        languageSkills: [],
                    },
                    eaRemark: '',
                    loanDetail: '',
                    agencyUserInfo: {},
                    anyOtherRemarkList: [],
                },
            },
        },
    },
    contract_pdf_code: {    // 获取pdf的code
        method: 'POST',
        url: '/peanut/manage/contract/pdf/link_code',
        format: {
            request: {
                refNo: String,
                pdfName: [String],
            },
            response: {},
        },
    },
    contract_pdf_data_code: {       // 根据code获取pdf数据
        method: 'POST',
        url: '/peanut/common/pdf',
        format: {
            request: {
                code: String,
                password: String,
                flag: String,
            },
            response: {
                pdfName: [],
                jobOffer: {
                    signTime: {},
                    accommodationProvided: '',
                    remark: '',
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        sign_proxy_agency: {},
                    },
                },
                authorisationLetter: {
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        firstTime: '',
                    },
                    signTime: {},
                },
                applicationForm: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                    },
                },
                sponsorDetails: {
                    signTime: {},
                    signatureImgPath: {
                        sign_sponsor_1: {},
                        sign_sponsor_2: {},
                    },
                    sponsor1: {},
                    sponsor2: {},
                },
                jointApplicant: {
                    signTime: {},
                    signatureImgPath: {
                        sign_joint: {},
                    },
                },
                incomeTaxDeclaration: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_spouse: {},
                    },
                },
                incomeTaxDeclarationSponsorship: {
                    signTime: {},
                    signatureImgPath: {
                        sign_sponsor_1: {},
                        sign_sponsor_2: {},
                    },
                },
                incomeTaxDeclarationJointApplication: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_joint: {},
                    },
                },
                serviceAgreementOrdinary: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                handingOverForm: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                    },
                },
                PDPA: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                    },
                },
                packageFeeOrdinary: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                    },
                },
                packageFeeReplacement: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                    },
                },
                packageFeeAdmin: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                    },
                },
                MOMAuthorisationForm: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                MOMAuthorisationFormForCancellationOfHelperReplaced: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                    },
                },
                MOMAuthorisationFormRenewal: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                newEQProposalForm: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                    },
                },
                domesticMaidProposalForm: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                    },
                },
                securityBond: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        firstTime: '',
                    },
                },
                declarationForm: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        sign_proxy_agency: {},
                        firstTime: '',
                        contractFilePath: '',
                    },
                },

                customized: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        firstTime: '',
                        contractFilePath: '',
                    },
                },
                PoeaEmploymentContract: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_proxy_agency: {},
                        firstTime: '',
                    },
                },
                PoeaUndertakingOfEmployer: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        firstTime: '',
                    },
                },
                safetyAgreementMyanmar: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                    },
                },
                safetyAgreementIndonesian: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                    },
                },
                safetyAgreementPhilippines: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                    },
                },
                safetyAgreementIndian: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                    },
                },
                employmentContract: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                    },
                },
                FDWPersonalBelongingsChecklist: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                offDayAgreement: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                    },
                },
                acknowledgementOfAdditionalMoneyDeduction: {
                    signTime: {},
                    signatureImgPath: {
                        sign_helper: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                salarySchedule: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        firstTime: '',
                    },
                    salaryScheduleList: [],
                },
                formA: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                formB: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_agency: {},
                        firstTime: '',
                    },
                },
                formC: {
                    signTime: {},
                    signatureImgPath: {
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        firstTime: '',
                    },
                },
                overlappingLetter: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        firstTime: '',
                    },
                },
                renewalDeclarationForm: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                    },
                },
                MOMEmploymentHistoryNew: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        contractFilePath: '',
                    },
                },
                MOMEmploymentHistoryOld: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        contractFilePath: '',
                    },
                },
                bioData: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                    },
                    skill: {
                        caringSkills: [],
                        cookingSkills: [],
                        languageSkills: [],
                        otherSkills: [],
                    },
                },
                FDWOrientationChecklist: {
                    signTime: {},
                    signatureImgPath: {
                        sign_employer: {},
                        sign_helper: {},
                        sign_agency: {},
                        sign_ipa_agency: {},
                        firstTime: '',
                    },
                },
            },
        },
    },
    contract_company_info_code: {       // 根据code获取公司信息
        method: 'GET',
        url: '/peanut/common/agencyInfo/{code}',
        format: {
            response: {
            },
        },
    },
    contract_update_set: {
        method: 'POST',
        url: '/peanut/manage/contract/confirm/copyFormSupplier',
    },
    contract_pdf_sign_data_set: {   // 根据code保存pdf签名数据
        method: 'POST',
        url: '/peanut/common/pdf/saveSignInfo',
    },
    contract_pdf_sign: {            // 生成pdf
        method: 'POST',
        url: '/century/peanut/manager/pdf/generateContractPdf',
    },
    insurance_pdf_sign: {            // 生成insurance pdf
        method: 'POST',
        url: '/century/peanut/manager/pdf/generateInsuranceContractPdf',
    },
    contract_pdf_download: {            // 生成pdf
        method: 'POST',
        url: '/century/peanut/manager/pdf/downloadPdf',
    },
    insurance_pdf_download: {            // 下载 insurance pdf
        method: 'POST',
        url: '/century/peanut/manager/pdf/downloadInsurancePdf',
    },
    invoice_pdf_download: {            // 生成pdf
        method: 'POST',
        url: '/century/peanut/manager/pdf/downloadInvoice',
    },
    biodata_pdf_download: {            // 生成pdf
        method: 'POST',
        url: '/century/peanut/manager/pdf/generatePdfByUrl',
    },
    contract_pdf_sign_save: {
        method: 'POST',
        url: '/peanut/common/pdf/savePdfPath',
    },
    contract_pdf_sign_code_valid: {
        method: 'GET',
        url: '/peanut/common/pdf/codeValid/{code}',
    },
    /** ********* contract end ********* */


    /** ********* interview begin ********* */
    interview_list: {                       // 查询interview列表
        method: 'POST',
        url: '/peanut/manage/interview/agency/queryInterviewList',
        format: {
            request: {
                size: Number,
                page: Number,
                sort: String,
                sortType: String,
                info: String,
                interviewStatus: [Number],
                interviewCreateBy: [String],
                interviewResult: [Number],
            },
            response: {
                items: [],
            },
        },
    },
    supplier_interview_list: {
        method: 'POST',
        url: '/peanut/manage/interview/supplier/queryInterviewList',
        format: {
            response: {
                items: [],
            },
        },
    },
    interview_delete: {                     // 删除interview
        method: 'GET',
        url: '/peanut/manage/interview/deleteInterview',
        format: {
            request: {
                id: Number,
            },
        },
    },
    interview_time_change: {                // 修改interview时间
        method: 'POST',
        url: '/peanut/manage/interview/changeInterviewTime',
        format: {
            request: {
                id: Number,
                interviewTime: Number,
            },
        },
    },
    interview_status_change: {              // 修改interview状态
        method: 'GET',
        url: '/peanut/manage/interview/changeInterviewStatus/{id}/{interviewStatus}',
        format: {
            request: {
                id: Number,
                interviewStatus: Number,
            },
        },
    },
    interview_result_change: {              // 修改interview结果
        method: 'GET',
        url: '/peanut/manage/interview/changeInterviewResult/{id}',
    },
    interview_channel_change: {              // 修改interview channel
        method: 'GET',
        url: '/peanut/manage/interview/changeInterviewChannel',
    },
    interview_conductedBy_change: {
        method: 'GET',
        url: '/peanut/manage/interview/updateConductedBy',
    },
    interview_remark_update: {              // 修改interview remark
        method: 'POST',
        url: '/peanut/manage/interview/updateInterviewRemark',
        format: {
            request: {
                id: Number,
                interviewRemark: String,
            },
        },
    },
    interview_create: {                     // 创建interview
        method: 'POST',
        url: '/peanut/manage/interview/createInterview',
        format: {
            request: {
                employerId: Number,
                helperInfo: {
                    helperId: Number,
                },
                interviewTime: Number,
            },
        },
    },
    interview_update: {                     // 创建interview
        method: 'POST',
        url: '/peanut/manage/interview/editInterview',
        format: {
            request: {
                employerId: Number,
                helperInfo: {
                    helperId: Number,
                },
                interviewTime: Number,
            },
        },
    },
    interview_creator_list: {               // 查询interview创建者列表
        method: 'GET',
        url: '/peanut/manage/interview/getInterviewCreator',
        format: {
            response: [],
        },
    },
    /** ********* interview end ********* */


    /** ********* feed begin ********* */
    feed_list: {            // 查询feed列表
        method: 'POST',
        url: '/peanut/manage/feed/queryFeedList',
        format: {
            request: {
                size: Number,
                page: Number,
                sort: String,
                sortType: String,
                info: String,
            },
            response: {
                items: [],
            },
        },
    },
    feed_likes_list: {      // 查询feed like列表
        method: 'GET',
        url: '/peanut/manage/feed/viewLikeInfo/{id}',
        format: {
            request: {
                id: Number,
            },
            response: [],
        },
    },
    feed_delete: {          // 删除feed
        method: 'GET',
        url: '/peanut/manage/feed/deleteFeed/{id}',
        format: {
            request: {
                id: Number,
            },
        },
    },
    feed_status_change: {   // 修改feed状态
        method: 'GET',
        url: '/peanut/manage/feed/changeOnlineOffline/{id}/{status}',
        format: {
            request: {
                id: Number,
                status: Number,
            },
        },
    },
    feed_detail: {          // 查询feed详情
        method: 'GET',
        url: '/peanut/manage/feed/viewFeedArticle/{id}',
        format: {
            request: {
                id: Number,
            },
            response: {},
        },
    },
    feed_save_draft: {      // 保存feed
        method: 'POST',
        url: '/peanut/manage/feed/saveDraftFeedArticle',
        format: {
            request: {
                id: Number,
                title: String,
                summary: String,
                feedContent: String,
                imageSummary: String,
            },
        },
    },
    feed_save_online: {     // 保存feed并且上线
        method: 'POST',
        url: '/peanut/manage/feed/saveOnlineFeedArticle',
        format: {
            request: {
                id: Number,
                title: String,
                summary: String,
                feedContent: String,
                imageSummary: String,
            },
        },
    },
    /** ********* feed end ********* */


    /** ********* article begin ********* */
    article_list: {         // 查询article列表
        method: 'POST',
        url: '/peanut/manage/article/queryList',
        format: {
            request: {
                size: Number,
                page: Number,
                sort: String,
                sortType: String,
                info: String,
                language: String,
            },
            response: {
                items: [],
            },
        },
    },
    article_companyStatus_change: {
        method: 'POST',
        url: '/peanut/manage/article/changeVisibleAgency',
    },
    article_delete: {       // 删除article
        method: 'GET',
        url: '/peanut/manage/article/deleteArticle/{id}',
        format: {
            request: {
                id: Number,
            },
        },
    },
    article_status_change: {    // 修改article状态
        method: 'GET',
        url: '/peanut/manage/article/requestOnlineOrOffline/{id}/{status}',
        format: {
            request: {
                id: Number,
                status: Number,
            },
        },
    },
    article_detail: {           // 查询article详情
        method: 'GET',
        url: '/peanut/manage/article/viewArticle/{id}',
        format: {
            request: {
                id: Number,
            },
            response: {},
        },
    },
    article_edit: {             // 修改article
        method: 'POST',
        url: '/peanut/manage/article/addOrUpdateArticle',
        format: {
            request: {
                id: Number,
                title: String,
                summary: String,
                articleKeyWord: String,
                articleContent: String,
                imageSummary: String,
                onlineState: Number,
                orderSort: Number,
            },
        },
    },
    article_max_sequence: {             // 获取article最大sequence
        method: 'GET',
        url: '/peanut/manage/article/getMaxSortNum',
    },
    article_sequence_set: {             // 修改article的sequence
        method: 'GET',
        url: '/peanut/manage/article/updateOrderSort/{id}/{order}',
    },
    /** ********* article begin ********* */


    /** ********* log begin ********* */
    log_list: {                 // 查询日志列表
        method: 'POST',
        url: '/peanut/manage/log/viewLogList',
        format: {
            request: {
                page: Number,
                size: Number,
                sort: String,
                sortType: String,
                info: String,
            },
            response: {
                items: [],
            },
        },
    },
    log_filter_map: {           // 查询log过滤参数map
        method: 'GET',
        url: '/peanut/manage/log/getCondition',
        format: {
            response: {
                Helper: [],
                Employer: [],
                operationType: [],
                objectType: [],
            },
        },
    },
    /** ********* feed end ********* */


    /** ********* dictionary begin ********* */
    dictionary_list: {
        method: 'GET',
        url: '/peanut/manage/dictionary/getAllDicInfo',
        format: {
            response: [{
                child: [{
                    otherMessage: {},
                }],
            }],
        },
    },
    dictionary_single_get: {
        method: 'GET',
        url: '/peanut/manage/dictionary/getInfoByParentName',
        format: {
            response: {
                child: [],
            },
        },
    },
    dictionary_add: {
        method: 'POST',
        url: '/peanut/manage/dictionary/addNewChildDictionary',
        format: {
            request: {

            },
        },
    },
    dictionary_edit: {
        method: 'POST',
        url: '/peanut/manage/dictionary/updateChildInfo',
        format: {
            request: {

            },
        },
    },
    dictionary_sort: {
        method: 'POST',
        url: '/peanut/manage/dictionary/sortDictionary',
        format: {
            request: {
                sort: [Number],
            },
        },
    },

    company_dictionary_list: {
        method: 'GET',
        url: '/peanut/manage/agency/dictionary/viewDictionary',
        format: {
            response: [{
                child: [],
            }],
        },
    },
    company_dictionary_single_get: {
        method: 'GET',
        url: '/peanut/manage/agency/dictionary/getInfoByParentName',
        format: {
            response: {
                child: [],
            },
        },
    },
    company_dictionary_add: {
        method: 'POST',
        url: '/peanut/manage/agency/dictionary/addDictionary',
        format: {
            request: {

            },
        },
    },
    company_dictionary_edit: {
        method: 'POST',
        url: '/peanut/manage/agency/dictionary/updateDictionary',
        format: {
            request: {

            },
        },
    },
    company_dictionary_sort: {
        method: 'POST',
        url: '/peanut/manage/agency/dictionary/sortDictionary',
        format: {
            request: {
                sort: [Number],
            },
        },
    },
    /** ********* dictionary end ********* */

    /** ********* company info begin ********* */
    company_account_list: {
        method: 'GET',
        url: '/peanut/manage/agency/getAllAgencyManager',
        format: {
            response: {
                mainAccount: {},
                managers: [],
            },
        },
    },
    company_account_change_pwd: {
        method: 'POST',
        url: '/peanut/manage/agency/updatePassword',
        format: {
            request: {
                password: String,
            },
        },
    },
    company_service_get: {
        method: 'GET',
        url: '/peanut/manage/agency/viewContractAgreementInfo',
        format: {
            response: {},
        },
    },
    company_employmentContract_get: {
        method: 'GET',
        url: '/peanut/manage/agency/viewEmploymentContractInfo',
        format: {
            response: {},
        },
    },
    company_employmentContract_set: {
        method: 'POST',
        url: '/peanut/manage/agency/saveEmploymentContractInfo',
    },
    company_service_set: {
        method: 'POST',
        url: '/peanut/manage/agency/saveContractAgreementInfo',
    },
    company_main_account_update: {
        method: 'POST',
        url: '/peanut/manage/company/editCompanyInfo',
        format: {
            request: {
                id: Number,
                logo: String,
                name: String,
            },
        },
    },
    company_dashboard_detail: {
        method: 'GET',
        url: '/peanut/manage/agency/getDashBoardInfo',
        format: {
            response: {},
        },
    },
    get_dashboard_dormitory_calendar: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/dormitory/calendar',
        format: {
            response: [],
        },
    },
    get_dashboard_detail: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/getChartInfo',
        format: {
            response: {
                statisticalNodes: [],
            },
        },
    },
    get_dashboard_config: {
        method: 'GET',
        url: '/peanut/manage/dashBoard/getConfig',
        format: {
            response: {
                oecProcessingPersonList: [],
            },
        },
    },
    get_supplier_dashboard_config: {
        method: 'GET',
        url: '/peanut/manage/dashBoard/getSupplierDashboardConfig',
    },
    get_flight_list: {
        method: 'GET',
        url: '/peanut/manage/dictionary/getDicByParentName',
        format: {
            response: [],
        },
    },
    company_dashboard_interview: {
        method: 'POST',
        url: '/peanut/manage/agency/getDashBoardInterviewInfo',
        format: {
            request: {
                startDate: Number,
                endDate: Number,
            },
            response: [],
        },
    },
    company_dashboard_contract: {
        method: 'POST',
        url: '/peanut/manage/agency/getDashBoardContractInfo',
        format: {
            request: {
                startDate: Number,
                endDate: Number,
            },
            response: [],
        },
    },
    company_auto_skill_enable: {
        method: 'GET',
        url: '/peanut/manage/agency/updateSkillAutoInfo',
        format: {
            request: {
                isOpen: Boolean,
            },
        },
    },
    company_account_enable: {
        method: 'GET',
        url: '/peanut/manage/agency/updateAgencyAccountStatus/{userId}/{status}',
    },
    company_status_change: {
        method: 'GET',
        url: '/peanut/manage/company/changeUserStatus',
    },
    supplier_bind_status: {
        method: 'GET',
        url: '/peanut/manage/supplier/agencyChangeSyncSwitch',
    },
    agency_bind_status: {
        method: 'GET',
        url: '/peanut/manage/supplier/supplierChangeSyncSwitch',
    },
    company_status_supplier: {
        method: 'GET',
        url: '/peanut/manage/supplier/changeSupplierStatus/{id}/{status}',
    },
    company_source_add: {
        method: 'POST',
        url: '/peanut/manage/agency/self/dic/createItem',
    },
    company_source_edit: {
        method: 'POST',
        url: '/peanut/manage/agency/self/dic/updateItem',
    },
    company_status_employer: {
        method: 'POST',
        url: '/peanut/manage/agency/self/dic/changeStatus/{id}/{status}',
    },
    company_info: {                     // 查询当前登录账号主要中介信息
        method: 'GET',
        url: '/peanut/manage/agency/getAgencyInfoAfterLogin',
        format: {
            response: {},
        },
    },
    get_user_agencyInfo: {
        method: 'GET',
        url: '/peanut/manage/contract/supplier/getUserAgencyInfoByRefNo',
        format: {
            response: {},
        },
    },
    supplier_company_info: {
        method: 'GET',
        url: '/peanut/manage/company/queryCompanyInfo',
        format: {
            response: {},
        },
    },
    company_account_detail: {                     // 查询账号信息
        method: 'GET',
        url: '/peanut/manage/agency/viewAgencyAccount/{agencyId}/{userId}',
        format: {
            response: {},
        },
    },
    company_logo_change: {                     // 修改logo
        method: 'POST',
        url: '/peanut/manage/agency/changeLogo',
        format: {
            response: {
            },
        },
    },
    company_account_edit: {                     // 修改账号信息
        method: 'POST',
        url: '/peanut/manage/agency/updateAgencyAccount',
        format: {
            response: {
                id: Number,
                agencyId: Number,
                asSalesPerson: Boolean,
                email: String,
                phoneNumber: String,
                registrationNo: String,
                userName: String,
            },
        },
    },
    company_account_create: {                    // 创建agency子账号
        method: 'POST',
        url: '/peanut/manage/agency/addAccount',
        format: {
            request: {
                agencyId: Number,
                asSalesPerson: Boolean,
                email: String,
                password: String,
                phoneNumber: String,
                registrationNo: String,
                userName: String,
            },
        },
    },
    company_supplier_list: {                    // 获取supplier list
        method: 'POST',
        url: '/peanut/manage/supplier/getAgencySupplierList',
        format: {
            response: [],
        },
    },
    company_supplier_sort: {                    // 保存supplier排序
        method: 'POST',
        url: '/peanut/manage/supplier/sortAgencySupplier',
        format: {
            request: {
                sort: [],
            },
        },
    },
    company_employer_sort: {
        method: 'POST',
        url: '/peanut/manage/agency/self/dic/sortItems',
        format: {
            request: {
                sort: [],
            },
        },
    },
    company_supplier_create: {                    // 创建supplier
        method: 'POST',
        url: '/peanut/manage/supplier/addAgencySupplierSupplier',
        format: {
            request: {
                address: String,
                contactPerson: String,
                companyName: String,
                country: Number,
                email: String,
                name: String,
                phone: String,
                remark: String,
            },
        },
    },

    company_supplier_edit: {                    // 修改supplier
        method: 'POST',
        url: '/peanut/manage/supplier/updateAgencySupplierSupplier',
        format: {
            request: {
                id: Number,
                address: String,
                contactPerson: String,
                companyName: String,
                country: Number,
                email: String,
                name: String,
                phone: String,
                remark: String,
            },
        },
    },

    company_supplier_detail: {                    // 查单个supplier详情
        method: 'GET',
        url: '/peanut/manage/supplier/viewAgencySupplierSupplier/{id}/{value}',
    },


    /** ********* company info end ********* */


    /** ********* adm begin ********* */
    adm_agency_list: {                          // 查询中介列表
        method: 'POST',
        url: '/peanut/adm/queryAgencyList',
        format: {
            request: {
                page: Number,
                size: Number,
                info: String,
                sort: String,
                sortType: String,
            },
            response: {
                items: [],
            },
        },
    },
    country_list_get: {
        method: 'GET',
        url: '/peanut/manage/dictionary/getSupplierCountryAreaList',
        format: {
            response: [],
        },
    },
    adm_supplier_list: {
        method: 'POST',
        url: '/peanut/adm/querySupplierList',
        format: {
            request: {
                page: Number,
                size: Number,
                info: String,
                sort: String,
                sortType: String,
            },
            response: {
                items: [],
            },
        },
    },
    adm_agency_create: {                          // 创建agency
        method: 'POST',
        url: '/peanut/adm/addAgency',
        format: {
            request: {
                address: String,
                contactName: String,
                email: String,
                licenseNo: String,
                logo: String,
                name: String,
                phoneNumber: String,
                uen: String,
                password: String,
            },
        },
    },
    adm_agency_edit: {                          // 修改agency
        method: 'POST',
        url: '/peanut/adm/admEditCompanyInfo',
    },
    get_canCreate_contract: {
        method: 'GET',
        url: '/peanut/manage/company/checkAgencyInfoCompleted',
    },
    company_create_set: {
        method: 'POST',
        url: '/peanut/adm/createCompany',
    },
    adm_agency_account_create: {                    // 创建agency子账号
        method: 'POST',
        url: '/peanut/adm/addAccount',
        format: {
            request: {
                agencyId: Number,
                asSalesPerson: Boolean,
                email: String,
                password: String,
                phoneNumber: String,
                registrationNo: String,
                userName: String,
            },
        },
    },
    adm_agency_account_edit: {                    // 修改agency子账号
        method: 'POST',
        url: '/peanut/adm/updateAgencyAccount',
        format: {
            request: {
                id: Number,
                agencyId: Number,
                asSalesPerson: Boolean,
                email: String,
                phoneNumber: String,
                registrationNo: String,
                userName: String,
            },
        },
    },
    adm_account_list: {                    // 查询admin用户list
        method: 'GET',
        url: '/peanut/adm/getAdmInfo',
        format: {
            response: {
                list: [],
            },
        },
    },
    adm_zeal_account_list: {                    // 查询zeal用户list
        method: 'GET',
        url: '/peanut/adm/getZealCareInfo',
        format: {
            response: {
                list: [],
            },
        },
    },
    adm_dh_account_list: {                    // 查询dh用户list
        method: 'GET',
        url: '/peanut/adm/getPeanutJobInfo',
        format: {
            response: {
                list: [],
            },
        },
    },
    adm_agency_account_list: {                    // 查询中介用户list
        method: 'GET',
        url: '/peanut/adm/getOtherAgencyInfo',
        format: {
            response: [{
                list: [],
            }],
        },
    },
    adm_account_enable: {                    // 账户禁用启用
        method: 'POST',
        url: '/peanut/adm/updateAccountStatus',
        format: {
            request: {
                agencyId: Number,
                status: Number,
                userId: Number,
                userName: String,
            },
        },
    },
    adm_sub_account_detail: {       // 获取子账号详情
        method: 'GET',
        url: '/peanut/adm/viewAgencyAccount/{agencyId}/{userId}',
        format: {
            response: {},
        },
    },
    adm_main_account_detail: {       // 获取主账号详情
        method: 'GET',
        url: '/peanut/adm/viewAgency/{agencyId}',
        format: {
            response: {},
        },
    },
    /** ********* adm end ********* */


    /** ********* release end ********* */

    releae_list: {
        method: 'POST',
        url: '/peanut/manage/releasePaper/queryList',
        format: {
            response: {},
        },
    },

    release_pdf_detail: {       // 根据code获取release详情
        method: 'GET',
        url: '/peanut/common/release/getReleasePaperInfoByCode/{code}',
        format: {
            response: {},
        },
    },
    release_status_set: {
        method: 'GET',
        url: '/peanut/manage/releasePaper/updatePassStatus/{id}/{status}',
    },
    /** ********* release end ********* */
    continue_gmail_set: {
        method: 'GET',
        url: '/peanut/manage/thirdparty/gmail/bind',
    },
    get_unread_num: {
        method: 'GET',
        url: '/peanut/manage/notification/unreadCount',
    },
    get_unread_list: {
        method: 'POST',
        url: '/peanut/manage/notification/pageList',
        format: {
            response: {
                items: [],
            },
        },
    },
    read_notification_one: {
        method: 'POST',
        url: '/peanut/manage/notification/mark',
    },
    read_notification_all: {
        method: 'POST',
        url: '/peanut/manage/notification/markAll',
    },
    is_authorize_get: {
        method: 'GET',
        url: '/peanut/manage/thirdparty/gmail/checkAuthValid',
    },
    is_disabled_get: {
        method: 'GET',
        url: '/peanut/manage/agency/queryUserEnableStatus',
    },
    password_modify_set: {
        method: 'POST',
        url: '/peanut/manage/agency/modifyPassword',
    },
    get_user_smsCode: {             // 获取手机验证码 图片验证
        method: 'POST',
        url: '/peanut/common/sms/sendSmsCode',
    },
    phone_code_get: {
        method: 'GET',
        url: '/peanut/common/sms/agency/smsCode',
    },
    user_code_check: {
        method: 'POST',
        url: '/peanut/common/agency/resetPassword',
    },
    account_check_code: {
        method: 'POST',
        url: '/peanut/common/agency/checkAccount',
    },
    company_account_check: {
        method: 'POST',
        url: '/peanut/common/agency/registerMainAccount',
    },
    change_mobile_set: {
        method: 'POST',
        url: '/peanut/manage/company/changePhoneNumber',
    },
    check_mobile_exit: {
        method: 'GET',
        url: '/peanut/manage/agency/isPasswordNull',
    },
    company_invite_get: {
        method: 'GET',
        url: '/peanut/manage/agency/invite/todoList',
        format: {
            response: [],
        },
    },
    is_accept_company: {
        method: 'GET',
        url: '/peanut/manage/agency/invite/dispose',
    },
    is_accept_invitation: {
        method: 'GET',
        url: '/peanut/manage/supplier/disposeBindInvite',
    },
    create_company_post: {
        method: 'POST',
        url: '/peanut/manage/agency/createCompany',
    },
    create_account_sign: {
        method: 'POST',
        url: '/peanut/common/agency/createAccount',
    },
    get_user_name: {
        method: 'GET',
        url: '/peanut/common/agency/queryLoginUser',
    },
    get_contract_info: {
        method: 'GET',
        url: '/peanut/manage/thirdparty/gmail/queryGmailBinding',
    },
    change_password_set: {
        method: 'POST',
        url: '/peanut/manage/agency/updatePassword',
    },
    contract_sync_start: {
        method: 'GET',
        url: '/peanut/manage/thirdparty/gmail/startSyncToContract',
    },
    contract_sync_deactivate: {
        method: 'GET',
        url: '/peanut/manage/thirdparty/gmail/deactivate',
    },
    get_insurance_list: {
        method: 'GET',
        url: '/peanut/manage/agency/insuranceTemplate/viewInsuranceTemplateList',
        format: {
            response: [],
        },
    },
    edit_insurance_list: {
        method: 'POST',
        url: '/peanut/manage/agency/insuranceTemplate/editInsuranceTemplate',
    },
    delete_insurance_list: {
        method: 'GET',
        url: '/peanut/manage/agency/insuranceTemplate/deleteInsuranceTemplate/{id}',
    },
    contract_sync_close: {
        method: 'GET',
        url: '/peanut/manage/thirdparty/gmail/stopSyncToContract',
    },
    supplier_logo_upload: {
        method: 'POST',
        url: '/peanut/manage/company/uploadCompanyLogo/{id}',
    },
    supplier_get_list: {
        method: 'GET',
        url: '/peanut/manage/company/queryAgencyManagerList',
        format: {
            response: [{
                roleNames: '',
            }],
        },
    },
    delete_company_account: {
        method: 'GET',
        url: '/peanut/manage/company/deleteInactivatedSubAccount',
    },
    create_sub_account: {
        method: 'POST',
        url: '/peanut/manage/company/createSubAccount',
    },
    get_account_info: {
        method: 'GET',
        url: '/peanut/manage/company/viewAccountInfo',
        format: {
            response: {
                birthday: 'formatUTC+8',
            },
        },
    },
    account_info_save: {
        method: 'POST',
        url: '/peanut/manage/company/updateAccountInfo',
        format: {
            request: {
                birthday: 'formatUTC+8',
            },
        },
    },
    account_completed_get: {
        method: 'GET',
        url: '/peanut/manage/company/checkAccountInfoCompleted',
    },
    helper_supplier_list: {
        method: 'POST',
        url: '/peanut/manage/helper/pageQueryFriendReferral',
        format: {
            response: {
                items: [],
            },
        },
    },
    helper_supplier_condition: {
        method: 'GET',
        url: '/peanut/manage/helper/queryFriendReferralCondition',
        format: {
            response: {
                friendLevelList: [],
                helperTypeList: [],
                caseStatusList: [],
            },
        },
    },
    helper_get_amount: {
        method: 'GET',
        url: '/peanut/manage/helper/getAccount',
        format: {
            response: {
                balance: 0,
                total: 0,
                onTheWay: 0,
            },
        },
    },
    helper_supplier_history: {
        method: 'GET',
        url: '/peanut/manage/helper/getTransactionHistory',
        format: {
            response: [],
        },
    },
    helper_referred_info: {
        method: 'GET',
        url: '/peanut/manage/helper/getHelperWhoReferredMe',
        format: {
            response: {
                helperName: '',
                peanutId: '',
            },
        },
    },
    employer_source_get: {
        method: 'GET',
        url: '/peanut/manage/agency/self/dic/getDictionaryList/{type}',
        format: {
            response: [],
        },
    },
    get_order_detail: {
        method: 'GET',
        url: '/peanut/manage/order/viewOrderDetail',
        format: {
            response: {},
        },
    },
    get_licence_query: {
        method: 'GET',
        url: '/peanut/manage/order/getAgencyListByAgencyName',
        format: {
            response: [],
        },
    },
    export_order_list: {
        method: 'POST',
        url: '/peanut/manage/common/agency/exportOrder',
    },
    order_list: {
        method: 'POST',
        url: '/peanut/manage/order/agency/pageQueryOrder',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_contract_query: {
        method: 'GET',
        url: '/peanut/manage/contract/getContractListByContractNoOrName',
        format: {
            response: [],
        },
    },
    get_contractById_info: {
        method: 'POST',
        url: '/peanut/manage/contract/getContractDetailByContractNo',
        format: {
            response: {},
        },
    },
    save_transport_order: {
        method: 'POST',
        url: '/peanut/manage/order/createOrder',
    },
    accept_order_set: {
        method: 'POST',
        url: '/peanut/manage/order/dealOrder',
    },
    get_common_address: {
        method: 'GET',
        url: '/peanut/manage/order/setting/viewAddressManagement',
        format: {
            response: [],
        },
    },
    save_SIP_centre_address: {
        method: 'POST',
        url: '/peanut/manage/order/setting/setDefaultAddress',
    },
    pj_agency_list: {
        method: 'POST',
        url: '/peanut/manage/order/transportQueryAgencyList',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_drop_address: {
        method: 'POST',
        url: '/peanut/manage/order/getAddressList',
        format: {
            response: [],
        },
    },
    get_agency_query: {
        method: 'GET',
        url: '/peanut/manage/order/getAgencyListByName',
        format: {
            response: [],
        },
    },
    parse_pdf_ipaLetter: {
        method: 'POST',
        url: '/peanut/manage/order/parseIpaLetter',
    },
    order_pj_list: {
        method: 'POST',
        url: '/peanut/manage/order/pjservice/pageQueryOrder',
        format: {
            response: {
                itmes: [],
            },
        },
    },
    order_schedule_list: {
        method: 'POST',
        url: '/peanut/manage/order/schedule/pageQueryPjService',
        format: {
            response: {
                itmes: [],
            },
        },
    },
    confirm_completion_set: {
        method: 'POST',
        url: '/peanut/manage/order/schedule/completeTask',
    },
    modify_task_set: {
        method: 'POST',
        url: '/peanut/manage/order/pjservice/task/modify',
    },
    export_pj_order: {
        method: 'POST',
        url: '/peanut/manage/common/pj/exportOrder',
    },
    get_terminal_list: {
        method: 'GET',
        url: '/peanut/manage/order/getCommonAddressById',
        format: {
            response: [],
        },
    },
    get_order_step: {
        method: 'GET',
        url: '/peanut/manage/order/queryOrderLogsByOrderId',
        format: {
            response: [],
        },
    },
    save_arrival_order: {
        method: 'POST',
        url: '/peanut/manage/order/editOrderDetailForArrival',
    },
    save_thumbprint_order: {
        method: 'POST',
        url: '/peanut/manage/order/editOrderDetailForThumbPrint',
    },
    save_amount_order: {
        method: 'POST',
        url: '/peanut/manage/order/editOrderDetailForAmount',
    },
    save_insurance_amount_order: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/editOrderDetailForAmount',
    },
    cancel_order_set: {
        method: 'POST',
        url: '/peanut/manage/order/cancelOrder',
    },
    get_pjService_detail: {
        method: 'GET',
        url: '/peanut/manage/order/queryPjServiceByOrderId',
        format: {
            response: {},
        },
    },
    set_arrival_service: {
        method: 'POST',
        url: '/peanut/manage/order/pjservice/arrivalMedicalSip/save',
    },
    set_thumbprint_service: {
        method: 'POST',
        url: '/peanut/manage/order/pjservice/thumbprint/save',
    },
    send_notification_get: {
        method: 'GET',
        url: '/peanut/manage/order/pjservice/thumbprint/notifyPickUpTime',
    },
    parse_appointment_pdf: {
        method: 'GET',
        url: '/peanut/manage/order/parseAppointmentLetter',
    },
    add_update_agency: {
        method: 'POST',
        url: '/peanut/manage/order/transportAddOrUpdateAgency',
    },
    getPJAgencyDetail: {
        method: 'GET',
        url: '/peanut/manage/order/queryAgencyConfigById',
        format: {
            response: {
                addressList: [],
            },
        },
    },
    delete_agency: {
        method: 'GET',
        url: '/peanut/manage/order/transportDeleteAddressList',
    },
    update_orderList_remark: {
        method: 'POST',
        url: '/peanut/manage/order/editRemark',
    },
    get_amount_detail: {
        method: 'GET',
        url: '/peanut/manage/order/viewOrderAmount',
        format: {
            response: {
                amountList: [],
            },
        },
    },
    get_pj_note: {
        method: 'GET',
        url: '/peanut/manage/order/getPjNote',
        format: {
            response: {},
        },
    },
    edit_pj_note: {
        method: 'POST',
        url: '/peanut/manage/order/editPjNote',
    },
    valid_contract_repeat: {
        method: 'POST',
        url: '/peanut/manage/order/checkBeforeCreateOrder',
    },
    get_schedule_all: {
        method: 'GET',
        url: '/peanut/manage/order/schedule/getScheduleList',
        format: {
            response: {
                arrivalList: [],
                thumbprintList: [],
                addHocList: [],
                adHocServiceList: [],
                homeLeaveList: [],
                passportRenewalList: [],
                chinaVisaApplicationList: [],
                repatriationList: [],
                sixMeList: [],
                embassyContractList: [],
                lodgingServiceList: [],
            },
        },
    },
    get_location_change: {
        method: 'POST',
        url: '/peanut/manage/order/schedule/getInfoByLocation',
    },
    save_common_task: {
        method: 'POST',
        url: '/peanut/manage/order/pjservice/taskList/save',
    },
    delete_task_hoc: {
        method: 'POST',
        url: '/peanut/manage/order/schedule/deleteSheet',
    },
    redo_task_get: {
        method: 'GET',
        url: '/peanut/manage/order/schedule/undoTask',
    },
    add_sheet_set: {
        method: 'POST',
        url: '/peanut/manage/order/schedule/addSheet',
    },
    parse_pdf_temporaryLetter: {
        method: 'POST',
        url: '/peanut/manage/order/parseTemporaryWorkPermit',
    },
    edit_order_detail_for_employer: {
        method: 'POST',
        url: '/peanut/manage/order/editOrderDetailForEmployer',
    },
    get_agency_helper_status_list: {
        method: 'GET',
        url: '/peanut/manage/agency/self/dic/getBindDictionaryList/{type}',
        format: {
            response: [],
        },
    },
    edit_order_verified: {
        method: 'POST',
        url: '/peanut/manage/order/editOrderVerified',
    },
    reopen_order: {
        method: 'GET',
        url: '/peanut/manage/order/reopenOrder',
    },
    save_order_address: {
        method: 'POST',
        url: '/peanut/manage/order/saveOrderAddress',
    },
    save_order_task_remark: {
        method: 'POST',
        url: '/peanut/manage/order/updateTaskRemark',
    },
    get_address_byId: {
        method: 'POST',
        url: '/peanut/manage/order/getAddressById',
        format: {
            response: {},
        },
    },
    get_poeaEmployment_contractInfo: {
        method: 'GET',
        url: '/peanut/manage/agency/viewPoeaEmploymentContractInfo',
        format: {
            response: {},
        },
    },
    get_supplierPoeaEmployment_contractInfo: {
        method: 'GET',
        url: '/peanut/manage/supplier/setting/query/POEAEmploymentContractSetting',
        format: {
            response: {
                extraRecruitmentAgency: '',
                extraHelperAddress: '',
                extraHelperContactNos: '',
                extraLicenseNo: '',
                philippineRecruitmentAgency: '',
                helperAddress: '',
                helperContactNos: '',
                minimumSalary: 0,
            },
        },
    },
    get_supplierDelaration_info: {
        method: 'GET',
        url: '/peanut/manage/supplier/setting/query/eaPersonnelSetting',
        format: {
            response: {
                eaPersonnelName: '',
                eaPersonnelRegistrationNo: '',
            },
        },
    },
    set_supplierDelaration_info: {
        method: 'POST',
        url: '/peanut/manage/supplier/setting/save/eaPersonnelSetting',
    },
    edit_poeaEmployment_contractInfo: {
        method: 'POST',
        url: '/peanut/manage/agency/savePoeaEmploymentContractInfo',
    },
    eidt_supplierPoeaEmployment_contractInfo: {
        method: 'POST',
        url: '/peanut/manage/supplier/setting/save/POEAEmploymentContractSetting',
    },
    get_poeaEmployment_contractDetail: {
        method: 'POST',
        url: '/peanut/manage/contract/viewPoeaEmploymentContractDetail',
        format: {
            response: {},
        },
    },
    edit_poeaEmployment_contractDetail: {
        method: 'POST',
        url: '/peanut/manage/contract/updatePoeaEmploymentContractDetail',
    },
    get_location_taskCode: {
        method: 'GET',
        url: '/peanut/manage/order/getAddressListByTaskCode',
        format: {
            response: [],
        },
    },
    isNeed_password_get: {
        method: 'GET',
        url: '/peanut/manage/common/needPdfPassword',
    },
    save_pdf_password: {
        method: 'GET',
        url: '/peanut/manage/common/eraseOrderPdfPassword',
    },
    erase_pdf_password: {
        method: 'POST',
        url: '/peanut/manage/common/batch/erase/pdfFile/password',
    },
    isNeedContract_password_get: {
        method: 'GET',
        url: '/peanut/manage/contract/needPdfPassword',
    },
    get_taskCodeList: {
        method: 'GET',
        url: '/peanut/manage/order/getTaskCodeList',
        format: {
            response: [],
        },
    },
    get_LocationList: {
        method: 'GET',
        url: '/peanut/manage/order/getLocationList',
        format: {
            response: [],
        },
    },
    confirmBy_supplier_time: {
        method: 'GET',
        url: '/peanut/manage/interview/updateConfirmedBySupplier',
    },
    get_contractNotification_list: {
        method: 'GET',
        url: '/peanut/manage/contract/notification/getPendingCount',
        format: {
            response: {},
        },
    },
    send_supplierContract: {
        method: 'POST',
        url: '/peanut/manage/contract/notification/send',
    },
    update_supplierContract_info: {
        method: 'POST',
        url: '/peanut/manage/contract/updateInternalInfo',
    },
    supplier_contract_edit_pic_list: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/editPicList',
    },
    supplier_contract_list: {
        method: 'POST',
        url: '/peanut/manage/contract/supplierPageQuery',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_supplierContractAgencyList: {
        method: 'GET',
        url: '/peanut/manage/supplier/queryBindAgencyList',
        format: {
            response: [],
        },
    },
    supplier_remark_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateSupplierRemark',
    },
    notification_contract_get: {
        method: 'POST',
        url: '/peanut/manage/contract/notification/getPageList',
        format: {
            response: {
                items: [],
            },
        },
    },
    sync_contract_set: {
        method: 'POST',
        url: '/peanut/manage/contract/notification/operate',
    },
    ignore_contract_notification: {
        method: 'POST',
        url: '/peanut/manage/contract/notification/ignore',
    },
    get_supplierHelperId: {
        method: 'GET',
        url: '/peanut/manage/helper/getHelperIdOfSupplier',
    },
    real_helper_get: {
        method: 'GET',
        url: '/peanut/manage/helper/getHelperIdOfSupplier',
    },
    get_finance_list: {
        method: 'POST',
        url: '/peanut/manage/contract/pageQueryContractPayment',
        format: {
            response: {
                items: [],
            },
        },
    },
    create_user: {
        method: 'GET',
        url: '/peanut/manage/dev/createUser',
    },
    batch_create_user: {
        method: 'GET',
        url: '/peanut/manage/dev/batchCreateUser',
    },
    upload_twp: {
        method: 'POST',
        url: '/peanut/manage/order/uploadTemporaryWorkPermit',
    },
    update_thumb_address: {
        method: 'POST',
        url: '/peanut/manage/order/updateThumbAddress',
    },
    get_pj_remark: {
        method: 'GET',
        url: '/peanut/manage/order/viewRemark',
        format: {
            response: [],
        },
    },
    pj_remark_set: {
        method: 'POST',
        url: '/peanut/manage/order/updateRemark',
    },
    get_pickupAddress_pj: {
        method: 'GET',
        url: '/peanut/manage/order/getAddressListFromAgencyOrEmployer',
        format: {
            response: [],
        },
    },
    get_terminal_arrival: {
        method: 'GET',
        url: '/peanut/manage/order/getAddressByCommonAddressTypeIdList',
        format: {
            response: [],
        },
    },
    get_sales_person_list: { // 查询已启用的账号，不包含禁用的账号, 不传参数就不区分角色
        method: 'GET',
        url: '/peanut/manage/employer/getResponsibleSalesWithId',
        format: {
            response: [],
        },
    },
    get_sales_person_list_include_current_id: {
        method: 'GET',
        url: '/peanut/manage/contract/afterSales/list/refPerson',
        format: {
            response: [],
        },
    },
    get_interview_chart: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/getInterviewInfo',
        format: {
            response: [],
        },
    },
    get_contract_chart: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/getContractInfo',
        format: {
            response: [],
        },
    },
    check_same_interviewTime: {
        method: 'POST',
        url: '/peanut/manage/interview/checkExistInterviewTime',
    },
    check_interview_same: {
        method: 'POST',
        url: '/peanut/manage/interview/getLatestInterview',
    },
    get_trainer_list: { // 查询所有账号，包含禁用的账号
        method: 'GET',
        url: '/peanut/manage/employer/getAllTrainers',
        format: {
            response: [],
        },
    },
    getLog_contract_update: {
        method: 'GET',
        url: '/peanut/manage/contract/operationLog/queryByContractNo',
        format: {
            response: [],
        },
    },
    get_adminId_list: {
        method: 'GET',
        url: '/peanut/manage/employer/getResponsibleSalesWithId',
        format: {
            response: [],
        },
    },
    get_conducted_list: {
        method: 'GET',
        url: '/peanut/manage/interview/queryConductedByListWithId',
        format: {
            response: [],
        },
    },
    add_to_helper_list: {
        method: 'POST',
        url: '/peanut/manage/helper/agency/addToHelperList',
    },
    add_to_my_helper_list: {
        method: 'POST',
        url: '/peanut/manage/helper/agency/addHelperFromSupplier',
    },
    send_invite_to_supplier: {
        method: 'POST',
        url: '/peanut/manage/supplier/agencySendInvitation',
    },
    confirm_withdraw_post: {
        method: 'POST',
        url: '/peanut/manage/helper/confirmTransfer',
    },
    get_transferred_count: {
        method: 'GET',
        url: '/peanut/manage/helper/getPendingTransferCount',
    },
    get_withdraw_list: {
        method: 'POST',
        url: '/peanut/manage/helper/getTransferList',
        format: {
            response: {
                items: [],
            },
        },
    },
    skip_task: {
        method: 'GET',
        url: '/peanut/manage/order/schedule/skipTask',
    },
    pj_orderList_upload_pjNote: {
        method: 'POST',
        url: '/peanut/manage/order/upLoad/pjNote',
    },
    restore_contract: {
        method: 'POST',
        url: '/peanut/manage/contract/restoreContract',
    },
    getArrivalDate: {
        method: 'GET',
        url: '/peanut/manage/contract/viewPreArrival',
        format: {
            response: {},
        },
    },
    get_sip_info: {
        method: 'GET',
        url: '/peanut/manage/order/info/for/sip',
        format: {
            response: {},
        },
    },
    reset_Schedule: {
        method: 'GET',
        url: '/peanut/manage/order/schedule/resetSchedule',
    },
    split_Task: {
        method: 'POST',
        url: '/peanut/manage/order/schedule/splitTask',
    },
    merge_Task: {
        method: 'POST',
        url: '/peanut/manage/order/schedule/mergeTask',
    },
    get_DriverList: {
        method: 'GET',
        url: '/peanut/manage/order/getDriverList',
        format: {
            response: [],
        },
    },
    getEditLock: {
        method: 'GET',
        url: '/peanut/manage/order/list/getEditLock',
        format: {
            response: {},
        },
    },
    updateListTask: {
        method: 'POST',
        url: '/peanut/manage/order/list/updateTask',
    },
    insertListTask: {
        method: 'POST',
        url: '/peanut/manage/order/list/insertTask',
    },
    deleteListTask: {
        method: 'POST',
        url: '/peanut/manage/order/list/deleteTask',
    },
    mergeListTask: {
        method: 'POST',
        url: '/peanut/manage/order/list/mergeTask',
    },
    splitListTask: {
        method: 'POST',
        url: '/peanut/manage/order/list/splitTask',
    },
    drag_taskList: {
        method: 'POST',
        url: '/peanut/manage/order/list/dragTaskList',
    },
    get_schedule_list: {
        method: 'POST',
        url: '/peanut/manage/order/schedule/queryPjService',
        format: {
            response: [],
        },
    },
    get_task_count: {
        method: 'POST',
        url: '/peanut/manage/order/schedule/getTaskCount',
    },
    get_statistics_info: {
        method: 'GET',
        url: '/peanut/manage/helper/statistics',
        format: {
            response: {},
        },
    },
    get_caseStatus_dashboard: {
        method: 'GET',
        url: '/peanut/manage/dashBoard/contract/staffRef/info',
        format: {
            response: [],
        },
    },
    checkEditLock: {
        method: 'GET',
        url: '/peanut/manage/order/schedule/checkEditLock',
    },
    unlockEditLock: {
        method: 'GET',
        url: '/peanut/manage/order/list/unlockEditLock',
    },
    checkoutSendToDriver: {
        method: 'POST',
        url: '/peanut/manage/order/checkBeforeSendToDriver',
    },
    sendToDriver: {
        method: 'POST',
        url: '/peanut/manage/order/sendToDriver',
    },
    getTaskPhotos: {
        method: 'GET',
        url: '/peanut/manage/order/getTaskFilesByTaskId',
        format: {
            response: {},
        },
    },
    updateTaskPhotos: {
        method: 'POST',
        url: '/peanut/manage/order/updateTaskFiles',
    },
    get_driver_task_list: {
        method: 'POST',
        url: '/peanut/manage/driver/task/list',
        format: {
            response: [],
        },
    },
    downloadAllFiles: {
        method: 'POST',
        url: '/peanut/manage/driver/download/zipFile',
    },
    createSupplierContract: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/create',
    },
    createSupplierInterview: {
        method: 'POST',
        url: '/peanut/manage/supplier/interview/createInterview',
    },
    supplierReopenContract: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/reopenContract',
    },
    supplierCloseContract: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/closeContract',
    },
    supplierCancelContract: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/cancelContract',
    },
    supplier_OnAllHelper: {
        method: 'GET',
        url: '/peanut/manage/helper/sync/supplierOnAllHelper',
    },
    supplier_link_code: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/generate/jobOffer/linkCode',
    },
    supplier_submit_post: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/edit/jobOffer/forLink',
    },
    get_supplier_info: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/jobOfferInfo/forLink',
        format: {
            response: {
                infantAges: [],
                childAges: [],
            },
        },
    },
    supplier_code_check: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/get/jobOfferLinkCode/status',
    },
    save_supplier_upload: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/save/file',
    },
    supplier_jobOffer_get: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/jobOfferInfo',
        format: {
            request: {
                refNo: String,
            },
            response: {
                infantAges: [],
                childAges: [],
            },
        },
    },
    supplier_basicInfo_set: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/edit/jobOffer',
    },
    supplier_jobOffer_set: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/edit/jobOffer',
    },
    check_code_confirm: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/generate/jobOffer/linkCode/preCheck',
    },
    // 财务
    createOrEdit_Supplier: {
        method: 'POST',
        url: '/peanut/manage/company/supplier/createOrEditSupplier',
    },
    pageQuery_CompanySupplier: {
        method: 'POST',
        url: '/peanut/manage/company/supplier/pageQueryCompanySupplier',
        format: {
            response: {
                items: [],
            },
        },
    },
    pageQuery_trial: {
        method: 'POST',
        url: '/finance/report/trial/query',
        format: {
            response: {
                grandTotalDetail: [],
            },
        },
    },
    pageQuery_pl: {
        method: 'POST',
        url: '/finance/report/pl/query',
        format: {
            response: {
                accountItemList: [],
            },
        },
    },
    // 当前Easy账号登陆的公司下的所有账号，
    get_base_users: {
        method: 'GET',
        url: '/finance/base/user',
        format: {
            response: [],
        },
    },
    get_all_subject: {
        method: 'GET',
        url: '/finance/account/fuzzy',
        format: {
            response: [],
        },
    },
    get_users_by_roles: {
        method: 'GET',
        url: '/finance/base/role',
        format: {
            response: [],
        },
    },
    query_voucher_page: {
        method: 'POST',
        url: '/finance/voucher/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    submit_vorcher: {
        method: 'POST',
        url: '/finance/voucher/submit',
    },
    create_voucher: {
        method: 'POST',
        url: '/finance/voucher/create',
    },
    edit_voucher: {
        method: 'POST',
        url: '/finance/voucher/edit',
    },
    cancel_voucher: {
        method: 'POST',
        url: '/finance/voucher/cancel',
    },
    get_voucher_detail: {
        method: 'GET',
        url: '/finance/voucher/{id}',
        format: {
            response: {
                detailList: [],
                refVoucherList: [],
            },
        },
    },
    get_account_timezone: {
        method: 'GET',
        url: '/peanut/manage/timeZone',
    },
    get_whatsApp_info: {
        method: 'GET',
        url: '/peanut/manage/order/schedule/queryTaskWhatsappInfo',
    },
    get_scheduleTime_line: {
        method: 'GET',
        url: '/peanut/manage/order/schedule/queryTaskTimeLine',
        format: {
            response: [],
        },
    },
    get_whatsAppOrder_info: {
        method: 'GET',
        url: '/peanut/manage/order/query/whatsappInfo',
    },
    reopen_check_amount: {
        method: 'POST',
        url: '/peanut/manage/order/reopenOrder',
    },
    email_send_file: {
        method: 'GET',
        url: '/peanut/manage/contract/query/nsSendFiles',
    },
    confirm_send_email: {
        method: 'POST',
        url: '/peanut/manage/contract/send/nsSendFiles',
    },
    get_supplier_timeline: {
        method: 'POST',
        url: '/peanut/manage/contract/supplier/viewTimeLineInfo',
        format: {
            response: {
                nodeList: [],
            },
        },
    },
    update_IPA_Approval: {
        method: 'POST',
        url: '/peanut/manage/contract/supplier/updateIPAApproval',
    },
    update_Oec_Processing: {
        method: 'POST',
        url: '/peanut/manage/contract/supplier/updateOecProcessing',
    },
    update_Oec_Release: {
        method: 'POST',
        url: '/peanut/manage/contract/supplier/updateOecRelease',
    },
    update_PreDeparture: {
        method: 'POST',
        url: '/peanut/manage/contract/supplier/updatePreDeparture',
    },
    update_Departure: {
        method: 'POST',
        url: '/peanut/manage/contract/supplier/updateDeparture',
    },
    edit_PersonInfo: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/editPersonInfo',
    },
    edit_Helper_TabInfo: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/editHelperTabInfo',
        format: {
            request: {
                helperBirthday: 'formatUTC+8',
            },
        },
    },
    update_OECProcessing: {
        method: 'POST',
        url: '/peanut/manage/contract/updateOECProcessing',
        format: {
            request: {
                ecVerifiedDate: 'formatUTC+8-12',
            },
        },
    },
    update_Pending_OECRelease: {
        method: 'POST',
        url: '/peanut/manage/contract/updatePendingOECRelease',
    },
    new_ContractInfo: {
        method: 'GET',
        url: '/peanut/manage/contract/notification/newContractInfo',
    },
    get_notification_all: {
        method: 'POST',
        url: '/peanut/manage/notification/list/forPop',
        format: {
            response: [],
        },
    },
    check_schedule_refresh: {
        method: 'GET',
        url: '/peanut/manage/interaction/exist',
    },
    get_reporting_status: {
        method: 'GET',
        url: '/peanut/manage/common/list/reportStatus',
        format: {
            response: [],
        },
    },
    get_reporting_status_no_auth: {
        method: 'GET',
        url: '/peanut/common/list/reportStatus',
        format: {
            response: [],
        },
    },
    get_passport_status: {
        method: 'GET',
        url: '/peanut/manage/common/list/passportStatus',
        format: {
            response: [],
        },
    },
    get_dormitory_list: {
        method: 'POST',
        url: '/peanut/manage/helper/dormitory/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_dormitory_transport_list: {
        method: 'POST',
        url: '/peanut/manage/helper/dormitory/transport/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_dailyReport_list: {
        method: 'POST',
        url: '/peanut/manage/helper/dormitory/dailyReport/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_dailyReport_statistic_num: {
        method: 'POST',
        url: '/peanut/manage/helper/dormitory/dailyReport/statistic',
        format: {
            response: [],
        },
    },
    get_bedManagement_list: {
        method: 'POST',
        url: '/peanut/manage/helper/dormitory/bedManagement/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_report_data: {
        method: 'GET',
        url: '/peanut/manage/helper/dormitory/record/forHelper',
        format: {
            response: {},
        },
    },
    get_dormitory_status: {
        method: 'GET',
        url: '/peanut/common/dic/list/dormitory/status',
        format: {
            response: [],
        },
    },
    compeleted_dormitory_status: {
        method: 'POST',
        url: '/peanut/manage/helper/dormitory/complete',
    },
    undo_dormitory_status: {
        method: 'POST',
        url: '/peanut/manage/helper/dormitory/undo',
    },
    update_schedule_set: {
        method: 'POST',
        url: '/peanut/manage/helper/dormitory/update/schedule',
    },
    contract_cost_list: {
        method: 'GET',
        url: '/peanut/manage/expense/getAllBase/forContract',
        format: {
            response: [],
        },
    },
    contract_cost_add: {
        method: 'POST',
        url: '/peanut/manage/expense/add/contract/base',
    },
    get_expense_data: {
        method: 'GET',
        url: '/peanut/manage/expense/getBizOrder/claim',
        format: {
            response: {
                presetExpenseList: [],
                otherExpenseList: [],
            },
        },
    },
    save_contractExpense_set: {
        method: 'POST',
        url: '/peanut/manage/expense/save/bizOrderItem',
    },
    get_expenseTemplate_data: {
        method: 'GET',
        url: '/finance/expenseClaimTemplate/detail',
        format: {
            response: {},
        },
    },
    get_expenseClaim_template_list: {
        method: 'POST',
        url: '/finance/expenseClaimTemplate/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_valid_expense: {
        method: 'GET',
        url: '/peanut/manage/expense/list/valid/claimTemplateName',
        format: {
            response: [],
        },
    },
    cost_preset_edit: {
        method: 'POST',
        url: '/peanut/manage/expense/edit/contract/base',
    },
    cost_delete_preset: {
        method: 'DELETE',
        url: '/peanut/manage/expense/del/base',
    },
    get_bankInfo_setting: {
        method: 'GET',
        url: '/peanut/manage/bankInfo/user/query',
        format: {
            response: {},
        },
    },
    save_bankInfo_setting: {
        method: 'POST',
        url: '/peanut/manage/bankInfo/user/save',
    },
    get_agencyManage_list: {
        method: 'POST',
        url: '/peanut/manage/contract/list/forClaim',
        format: {
            response: [],
        },
    },
    get_supplierManage_list: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/list/forClaim',
        format: {
            response: [],
        },
    },
    get_transportManage_list: {
        method: 'POST',
        url: '/peanut/manage/order/list/forClaim',
        format: {
            response: [],
        },
    },
    get_expenseClaim_list: {
        method: 'POST',
        url: '/finance/expenseClaim/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    save_expenseClaim: {
        method: 'POST',
        url: '/finance/expenseClaim/save',
        format: {
            request: {
                expenseClaimItemList: [{
                    validDate: 'formatUTC+8',
                }],
                apVoucherAccountList: [{
                    voucherDate: 'formatUTC+8',
                }],
            },
        },
    },
    get_expenseClaim_detail: {
        method: 'GET',
        url: '/finance/expenseClaim/detail',
        format: {
            response: {
                expenseClaimItemList: [{
                    validDate: 'formatUTC+8',
                }],
                apVoucherAccountList: [{
                    voucherDate: 'formatUTC+8',
                }],
                paymentOrderAndVoucherLis: [],
            },
        },
    },
    update_expenseClaim_updateInvoicePicture: {
        method: 'POST',
        url: '/finance/expenseClaim/updateInvoicePicture',
    },
    get_bankInfo: {
        method: 'POST',
        url: '/peanut/manage/bankInfo/query/forFinance',
        format: {
            response: {},
        },
    },
    cancel_expenseClaim: {
        method: 'PUT',
        url: '/finance/expenseClaim/cancel/{id}',
    },
    submit_expenseClaim: {
        method: 'PUT',
        url: '/finance/expenseClaim/submit/{id}',
    },
    verify_expenseClaim: {
        method: 'PUT',
        url: '/finance/expenseClaim/verify/{id}',
    },
    recall_expenseClaim: {
        method: 'PUT',
        url: '/finance/expenseClaim/recall/{id}',
    },
    reject_expenseClaim: {
        method: 'PUT',
        url: '/finance/expenseClaim/reject/{id}',
    },
    approval_expenseClaim: {
        method: 'PUT',
        url: '/finance/expenseClaim/approval/{id}',
    },
    get_expenseClaim_uniqueExpenseName: {
        method: 'GET',
        url: '/finance/expenseClaim/uniqueExpenseName',
        format: {
            response: [],
        },
    },
    get_expenseClaim_uniqueCreateName: {
        method: 'GET',
        url: '/finance/expenseClaim/uniqueCreateName',
        format: {
            response: [],
        },
    },
    get_expenseClaim_uniqueSubmitName: {
        method: 'GET',
        url: '/finance/expenseClaim/uniqueSubmitName',
        format: {
            response: [],
        },
    },
    get_paymentAccount_list: {
        method: 'GET',
        url: '/finance/account/listFiveLevelByChannel',
        format: {
            response: [],
        },
    },
    get_payableOrder_list: {
        method: 'POST',
        url: '/finance/payableOrder/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_payableOrder_Detail: {
        method: 'GET',
        url: '/finance/payableOrder/detail',
        format: {
            response: {},
        },
    },
    settle_payableOrder: {
        method: 'POST',
        url: '/finance/payableOrder/batchSettlement',
    },
    settle_payableOrder_pre: {
        method: 'POST',
        url: '/finance/payableOrder/batchSettlement/pre',
    },
    get_payableOrder_selectAll: {
        method: 'POST',
        url: '/finance/payableOrder/selectAll',
        format: {
            response: [],
        },
    },
    get_paymentOrder_list: {
        method: 'POST',
        url: '/finance/paymentOrder/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_paymentOrder_Detail: {
        method: 'GET',
        url: '/finance/paymentOrder/detail',
        format: {
            response: {},
        },
    },
    expense_template_switch: {
        method: 'GET',
        url: '/finance/expenseClaimTemplate/enableOrDisable',
    },
    get_expenseName_remote: {
        method: 'GET',
        url: '/finance/expenseClaimTemplate/nameLike',
        format: {
            response: [],
        },
    },
    save_expense_template: {
        method: 'POST',
        url: '/finance/expenseClaimTemplate/save',
    },
    get_dicNew_data: {
        method: 'POST',
        url: '/peanut/common/dic/list/commonEnum',
        format: {
            response: {},
        },
    },
    get_medical_type_list: {
        method: 'GET',
        url: '/peanut/manage/charge/getMedicalItemList',
        format: {
            response: [],
        },
    },
    query_order_arMainInfo: {
        method: 'POST',
        url: '/peanut/manage/ar/queryOrderArMainInfo',
        format: {
            response: {
                feeTypeList: [],
            },
        },
    },
    query_orderATList: {
        method: 'POST',
        url: '/peanut/manage/ar/queryOrderATList',
        format: {
            response: [],
        },
    },
    query_orderArDetail: {
        method: 'POST',
        url: '/peanut/manage/ar/queryOrderArDetail',
        format: {
            response: {
                arInfo: [],
                feeDetail: [],
            },
        },
    },
    update_orderArDetail: {
        method: 'POST',
        url: '/peanut/manage/ar/updateOrderArDetail',
    },
    get_receivable_list: {
        method: 'POST',
        url: '/finance/ar/receivableOrder/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_receivable_detail: {
        method: 'GET',
        url: '/finance/ar/receivableOrder/{id}',
        format: {
            response: {
                receivedDetailList: [],
            },
        },
    },
    get_received_list: {
        method: 'POST',
        url: '/finance/ar/receivedOrder/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_received_detail: {
        method: 'GET',
        url: '/finance/ar/receivedOrder/{id}',
        format: {
            response: {
                receivableDetailList: [],
                receivableContractDetailList: [],
            },
        },
    },
    receivableSelectAll: {
        method: 'POST',
        url: '/finance/ar/receivableOrder/selectAll',
    },
    undo_received: {
        method: 'POST',
        url: '/finance/ar/receivedOrder/undo',
    },
    edit_received_info: {
        method: 'POST',
        url: '/finance/ar/receivedOrder/edit',
    },
    get_base_expense: {
        method: 'GET',
        url: '/peanut/manage/expense/listName/ofBase',
        format: {
            response: [],
        },
    },
    ar_receivePayment: {
        method: 'POST',
        url: '/finance/ar/receivableOrder/receivePayment',
    },
    get_receivableAmount: {
        method: 'POST',
        url: '/finance/ar/receivableOrder/receivableAmount',
    },
    get_sales_invoice_list: {
        method: 'POST',
        url: '/finance/ar/invoice/page',
        format: {
            response: {
                items: [{
                    remark: [],
                }],
            },
        },
    },
    set_sales_invoice_remark: {
        method: 'POST',
        url: '/finance/ar/invoice/updateRemark',
    },
    get_sales_invoice_detail: {
        method: 'GET',
        url: '/finance/ar/invoice/{id}',
        format: {
            response: {},
        },
    },
    get_sales_invoice_detail_by_ticket: {
        method: 'GET',
        url: '/finance/ar/invoice/detailForPdf',
        format: {
            response: {},
        },
    },
    edit_sales_invoice: {
        method: 'POST',
        url: '/finance/ar/invoice/edit',
    },
    marked_play_status: {
        method: 'POST',
        url: '/peanut/manage/notification/markDisplayedById',
    },
    invoice_print: {
        method: 'POST',
        url: '/finance/ar/invoice/print',
    },
    invoice_generate: {
        method: 'POST',
        url: '/finance/ar/receivableOrder/generateInvoice',
    },
    receipt_print: {
        method: 'POST',
        url: '/finance/ar/receivedOrder/print',
    },
    received_sellectAll: {
        method: 'POST',
        url: '/finance/ar/receivedOrder/selectAll',
    },
    invoice_sellectAll: {
        method: 'POST',
        url: '/finance/ar/invoice/selectAll',
    },
    get_PaymentSchedule: {
        method: 'POST',
        url: '/peanut/manage/contract/viewPaymentSchedule',
        format: {
            response: {
                paymentScheduleList: [],
            },
        },
    },
    save_PaymentSchedule: {
        method: 'POST',
        url: '/peanut/manage/contract/updatePaymentSchedule',
    },
    generate_invoce_precheck: {
        method: 'POST',
        url: '/finance/ar/receivableOrder/generateInvoice/preCheck',
    },
    search_eta_sort: {
        method: 'POST',
        url: '/peanut/manage/order/schedule/sortTaskAndSave',
    },
    get_passport_reporting_status: {
        method: 'GET',
        url: '/peanut/manage/dashBoard/getPassportAndReportingStatusStatistics',
    },
    get_employment_status: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/getEmploymentStatusStatistics',
        format: {
            response: [],
        },
    },
    get_employment_status_track: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/getEmploymentStatusTrackStatistics',
        format: {
            response: [],
        },
    },
    get_contract_statistics: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/getContractStatistics',
        format: {
            response: [],
        },
    },
    get_calender_status: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/getCalenderStatistics',
        format: {
            response: [],
        },
    },
    get_cask_status: {
        method: 'GET',
        url: '/peanut/manage/dashBoard/getCaseStatusStatistics',
        format: {
            response: [],
        },
    },
    get_dashboard_supplier_config: {
        method: 'GET',
        url: '/peanut/manage/dashBoard/getSupplierDashboardConfig',
        format: {
            response: {},
        },
    },
    get_receive_payment_preview: {
        method: 'POST',
        url: '/finance/ar/receivableOrder/contract/receivePayment/preview',
        format: {
            response: {
                feeTypeItemList: [],
                otherContractList: [],
            },
        },
    },
    deal_receive_payment: {
        method: 'POST',
        url: '/finance/ar/receivableOrder/contract/receivePayment',
    },
    agency_complete: {
        method: 'POST',
        url: '/peanut/manage/contract/completeDeploymentDate',
    },
    supplier_complete: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/completeDepartureDate',
    },
    agency_undo: {
        method: 'POST',
        url: '/peanut/manage/contract/undoDeploymentDate',
    },
    supplier_undo: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/undoDepartureDate',
    },
    check_helper_unique_contract: {
        method: 'POST',
        url: '/peanut/manage/contract/getHelperOpenContract',
    },
    check_supplier_unique_contract: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/checkHelper/existOpen',
    },
    check_informTask: {
        method: 'GET',
        url: '/peanut/manage/order/schedule/informTask',
    },
    recalculate_task_info: {
        method: 'POST',
        url: '/peanut/manage/order/recalculate/taskInfo',
    },
    add_schedule_task: {
        method: 'GET',
        url: '/peanut/manage/order/schedule/addTask',
    },
    get_handoverDate: {
        method: 'POST',
        url: '/peanut/manage/order/preQuery/handoverDate',
    },
    pre_check_dele_task: {
        method: 'GET',
        url: '/peanut/manage/order/delTask/preCheck',
    },
    get_additionalLodging: {
        method: 'POST',
        url: '/peanut/manage/order/query/additionalLodging',
    },
    get_sales_byUserId: {
        method: 'GET',
        url: '/peanut/manage/agency/getUserInfo',
        format: {
            response: {},
        },
    },
    get_nationality_code: {
        method: 'GET',
        url: '/peanut/common/getNationalityCode',
    },
    get_general_data: {
        method: 'GET',
        url: '/peanut/manage/helper/getSupplementaryQuestions',
        format: {
            response: [],
        },
    },
    set_general_data: {
        method: 'POST',
        url: '/peanut/manage/helper/updateSupplementaryQuestions',
    },
    set_thumbprintSchedule: {
        method: 'POST',
        url: '/peanut/manage/order/reset/thumbprintSchedule',
    },
    get_helper_country: {
        method: 'GET',
        url: '/peanut/manage/order/list/helperCountryArea/forApproval',
        format: {
            response: [],
        },
    },
    add_recurring_tasks: {
        method: 'POST',
        url: '/peanut/manage/order/schedule/addRecurringTasks',
    },
    edit_OrderDetailForArrival: {
        method: 'POST',
        url: '/peanut/manage/order/preCheck/editOrderDetailForArrival',
    },
    get_table_filters_config: {
        method: 'GET',
        url: '/peanut/manage/tableFilter/detail/{filterTableName}',
    },
    save_table_filters_config: {
        method: 'POST',
        url: '/peanut/manage/tableFilter/save',
    },
    get_unfinish_date: {
        method: 'GET',
        url: '/peanut/manage/order/query/taskEarliest/unFinishDate',
    },
    contract_afterSales_save: {
        method: 'POST',
        url: '/peanut/manage/contract/afterSales/apply',
    },
    afterSales_status_update: {
        method: 'POST',
        url: '/peanut/manage/contract/afterSales/editStatus',
    },
    get_afterSale_detail: {
        method: 'POST',
        url: '/peanut/manage/contract/afterSales/viewFeeDetail',
        format: {
            response: {
                feeTypeList: [],
            },
        },
    },
    save_afterSale_detail: {
        method: 'POST',
        url: '/peanut/manage/contract/afterSales/updateFeeDetail',
    },
    get_afterSale_basic: {
        method: 'GET',
        url: '/peanut/manage/contract/afterSales/getBasicInfo',
        format: {
            response: {},
        },
    },
    get_refund_fee: {
        method: 'POST',
        url: '/peanut/manage/contract/afterSales/getRefundFeeItemList',
        format: {
            response: {},
        },
    },
    contract_afterSales_list: {
        method: 'POST',
        url: '/peanut/manage/contract/afterSales/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    create_after_sale: {
        method: 'POST',
        url: '/peanut/manage/contract/afterSales/apply',
    },
    contract_afterDetail_save: {
        method: 'PUT',
        url: '/peanut/manage/contract/afterSales/edit',
    },
    get_contract_afterSales: {
        method: 'GET',
        url: '/peanut/manage/contract/afterSales/list/forContractDetail',
        format: {
            response: [],
        },
    },
    get_afterSale_contract: {
        method: 'POST',
        url: '/peanut/manage/contract/afterSales/listContract',
        format: {
            response: [],
        },
    },
    get_bankStatement_list: {
        method: 'POST',
        url: '/finance/bank/bankStatement/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_bank_account_list: {
        method: 'GET',
        url: '/finance/bank/account/list',
        format: {
            response: [],
        },
    },
    edit_bankStatement_list: {
        method: 'POST',
        url: '/finance/bank/bankStatement/edit',
    },
    delete_bank_statement: {
        method: 'POST',
        url: '/finance/bank/bankStatement/delete',
    },
    delete_bank_account: {
        method: 'POST',
        url: '/finance/bank/account/delete',
    },
    edit_bank_account: {
        method: 'POST',
        url: '/finance/bank/account/edit',
    },
    create_bank_account: {
        method: 'POST',
        url: '/finance/bank/account/create',
    },
    bind_bank_statement: {
        method: 'POST',
        url: '/finance/bank/bankStatement/bind',
    },
    unbind_bank_statement: {
        method: 'POST',
        url: '/finance/bank/bankStatement/unbind',
    },
    check_bind_bank_date: {
        method: 'POST',
        url: '/finance/bank/bankStatement/checkDate/receivedOrder',
    },
    check_bind_bank_bank: {
        method: 'POST',
        url: '/finance/bank/bankStatement/checkAccount/receivedOrder',
    },
    bind_payment_bank_statement: {
        method: 'POST',
        url: '/finance/bank/bankStatement/bind/paymentOrder',
    },
    unbind_payment_bank_statement: {
        method: 'POST',
        url: '/finance/bank/bankStatement/unbind/paymentOrder',
    },
    check_payment_bind_bank_date: {
        method: 'POST',
        url: '/finance/bank/bankStatement/checkDate/paymentOrder',
    },
    check_payment_bind_bank_bank: {
        method: 'POST',
        url: '/finance/bank/bankStatement/checkAccount/paymentOrder',
    },
    get_bankAccount_subject: {
        method: 'GET',
        url: '/finance/account/listBankAccount',
        format: {
            response: [],
        },
    },
    turbo_task_import: {
        method: 'POST',
        url: '/turbo/task/import',
    },
    turbo_task_page: {
        method: 'POST',
        url: '/turbo/task/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_transport_management: {
        method: 'GET',
        url: '/peanut/manage/charge/listByAgency',
        format: {
            response: [],
        },
    },
    get_transport_detail: {
        method: 'GET',
        url: '/peanut/manage/charge/detail',
        format: {
            response: [],
        },
    },
    save_transport_management: {
        method: 'POST',
        url: '/peanut/manage/charge/confirm',
    },
    create_transport_management: {
        method: 'POST',
        url: '/peanut/manage/charge/create',
    },
    update_subAccount: {
        method: 'POST',
        url: '/peanut/manage/company/updateSubAccount',
    },
    finance_receivePayment_preview: {
        method: 'POST',
        url: '/finance/ar/receivableOrder/receivePayment/preview',
        format: {
            response: {
                feeTypeItemList: [],
                otherContractList: [],
            },
        },
    },
    finance_receivePayment_manual: {
        method: 'POST',
        url: '/finance/ar/receivableOrder/receivePayment/manual',
    },
    get_share_detail: {
        method: 'POST',
        url: '/peanut/manage/company/query/shareHelperDetail',
        format: {
            response: {
                basicInfo: {
                    firstInterviewVideoList: [],
                },
                skillWillingInfoList: [],
            },
        },
    },
    get_supplier_helper_detail: {
        method: 'GET',
        url: '/peanut/manage/company/query/newHelperDetail',
        format: {
            response: {
                basicInfo: {
                    firstInterviewVideoList: [],
                },
                skillWillingInfoList: [],
            },
        },
    },
    get_viewAccountInfo: {
        method: 'GET',
        url: '/peanut/manage/dev/viewAccountInfo',
        format: {
            response: {
                relatedCompanyList: [],
            },
        },
    },
    create_relateCompany: {
        method: 'GET',
        url: '/peanut/manage/dev/createRelateCompany',
    },
    complete_transaction: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/oec/transaction/complete',
    },
    undo_transaction: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/oec/transaction/undo',
    },
    get_supplierDashbord_timeline: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/contract/oecProcessing',
        format: {
            response: {
                nodeEdgeList: [],
                nodeList: [],
                totalDelayInfo: {
                    detailList: [],
                },
            },
        },
    },
    get_agecny_dashbord_timeline: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/agency/contract/transactionProcessing',
        format: {
            response: {
                nodeList: [],
                totalDelayInfo: {
                    detailList: [],
                },
            },
        },
    },
    get_agecny_contract_timeline: {
        method: 'GET',
        url: '/peanut/manage/contract/query/transactionOverviewDraw',
        format: {
            response: {
                transactionList: [],
            },
        },
    },
    check_undoTransaction: {
        method: 'GET',
        url: '/peanut/manage/contract/notification/supplier/checkUndoTransaction',
    },
    edit_NoteForInvoice: {
        method: 'POST',
        url: '/peanut/manage/company/editNoteForInvoice',
    },
    sync_point_put: {
        method: 'PUT',
        url: '/peanut/manage/contract/update/syncPoint',
    },
    check_template_info: {
        method: 'GET',
        url: '/peanut/manage/contract/check/OriginDocumentExist',
    },
    confirm_sync_type: {
        method: 'PUT',
        url: '/peanut/manage/contract/update/syncType',
    },
    helperSync_point_put: {
        method: 'PUT',
        url: '/peanut/manage/helper/update/syncPoint',
    },
    read_contractSync_auto: {
        method: 'POST',
        url: '/peanut/manage/contract/notification/update/unReadAutoSyncNotificationToRead',
    },
    get_helper_timelineInfo: {
        method: 'POST',
        url: '/peanut/manage/helper/event/viewTimeLineInfo',
        format: {
            response: [],
        },
    },
    createOrUpdateEvent: {
        method: 'POST',
        url: '/peanut/manage/helper/event/createOrUpdateEvent',
    },
    get_shareLinkCode: {
        method: 'POST',
        url: '/peanut/manage/company/generate/shareLinkCode',
    },
    get_supplier_contractLinkCode: {
        method: 'POST',
        url: '/peanut/manage/contract/share/supplier/generateLinkCode',
    },
    get_shareParam: {
        method: 'GET',
        url: '/peanut/manage/company/getShareParam/byCode',
    },
    get_shareParam_contractShare: {
        method: 'GET',
        url: '/peanut/manage/contract/share/supplier/getLinkByCode',
    },
    get_delayList: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/page/delayStep',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_oecSteps: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/getOecStepList',
        format: {
            response: [],
        },
    },
    get_enquiry_list: {
        method: 'POST',
        url: '/peanut/manage/employer/enquiryInfo/page',
        format: {
            response: {
                items: [{
                    requirementSystemParsed: {},
                }],
            },
        },
    },
    confirm_transform_employer: {
        method: 'POST',
        url: '/peanut/manage/helper/editPlatformOnlineStatus',
    },
    set_peanutJob_status: {
        method: 'POST',
        url: '/peanut/manage/helper/editPlatformOnlineStatus',
    },
    enquiry_remark_set: {
        method: 'POST',
        url: '/peanut/manage/employer/enquiryInfo/editRemark',
    },
    operation_enquiry_status: {
        method: 'POST',
        url: '/peanut/manage/employer/enquiryInfo/editEnquiryInfoStatus',
    },
    enquiry_detail_get: {
        method: 'GET',
        url: '/peanut/manage/employer/enquiryInfo/detail/{id}',
        format: {
            response: {
                mainDutyIdList: [],
                preferNationalityIdList: [],
                remarkList: [],
                employerAccountSettingVO: {
                    picture: '',
                },
                jobEmployerInfo: {},
                jobRequirement: {},
                mainInfo: {},
                requirementSystemParsed: {},
                requirementUser: {},
            },
        },
    },
    enquiry_remark_get: {
        method: 'GET',
        url: '/peanut/manage/employer/enquiryInfo/viewRemark/{id}',
        format: {
            response: [],
        },
    },
    platform_setting_get: {
        method: 'GET',
        url: '/peanut/manage/agency/platformSetting/detail',
        format: {
            response: {
                companyBranches: [],
            },
        },
    },
    platform_setting_set: {
        method: 'POST',
        url: '/peanut/manage/agency/editPlatformSetting',
    },
    set_platform_status: {
        method: 'GET',
        url: '/peanut/manage/article/editPlatformOnlineStatus/{id}',
    },
    exit_article_type: {
        method: 'GET',
        url: '/peanut/manage/article/checkArticleType',
    },
    helper_import_add: {
        method: 'POST',
        url: '/peanut/manage/helper/import/pre',
    },
    import_helper_confirm: {
        method: 'POST',
        url: '/peanut/manage/helper/import',
    },
    get_orderEstimated_charge: {
        method: 'POST',
        url: '/peanut/manage/order/getOrderEstimatedCharge',
        format: {
            response: {
                amountList: [],
            },
        },
    },
    get_orderVerify_typeList: {
        method: 'GET',
        url: '/peanut/manage/order/getOrderVerifyTypeList',
        format: {
            response: [],
        },
    },
    get_nextFollowUp_date: {
        method: 'GET',
        url: '/peanut/manage/helper/event/get/nextFollowUpDate',
    },
    confirm_event_online: {
        method: 'POST',
        url: '/peanut/manage/helper/event/saveEvent/andOnlineHelper',
    },
    get_event_data: {
        method: 'GET',
        url: '/peanut/manage/helper/event/getTimeLine/byId',
        format: {
            response: {},
        },
    },
    create_specify_address: {
        method: 'POST',
        url: '/peanut/manage/order/createSpecifyAddress',
    },
    get_dormitory_location_list: {
        method: 'GET',
        url: '/peanut/manage/helper/dormitory/transport/getLocationList',
        format: {
            response: [],
        },
    },
    get_dormitory_bed_statistic: {
        method: 'GET',
        url: '/peanut/manage/helper/dormitory/transport/getBedManagementStatistic',
        format: {
            response: [],
        },
    },
    create_mediation_post: {
        method: 'POST',
        url: '/peanut/manage/contract/followup/create',
    },
    reopen_mediation_post: {
        method: 'PUT',
        url: '/peanut/manage/contract/followup/reopen',
    },
    edit_followUp_date: {
        method: 'PUT',
        url: '/peanut/manage/contract/followup/edit',
    },
    confirm_record_edit: {
        method: 'POST',
        url: '/peanut/manage/contract/followup/edit/record',
    },
    get_contract_relations: {
        method: 'GET',
        url: '/peanut/manage/contract/followup/get/info',
        format: {
            response: [],
        },
    },
    add_record_relation: {
        method: 'POST',
        url: '/peanut/manage/contract/followup/create/record',
    },
    get_contactor_list: {
        method: 'GET',
        url: '/peanut/manage/contract/followup/getContactorList',
        format: {
            response: [],
        },
    },
    get_contacted_name: {
        method: 'GET',
        url: '/peanut/manage/contract/followup/getContactedNameList',
        format: {
            response: [],
        },
    },
    get_contract_count: {
        method: 'GET',
        url: '/peanut/manage/contract/statistics/count',
        format: {
            response: {},
        },
    },
    get_record_list: {
        method: 'POST',
        url: '/peanut/manage/mileage/page/record',
        format: {
            response: {
                items: [],
            },
        },
    },
    edit_mileage: {
        method: 'PUT',
        url: '/peanut/manage/mileage/edit',
    },
    get_flightList_byDate: {
        method: 'GET',
        url: '/peanut/manage/order/listFlightByDate',
        format: {
            response: [],
        },
    },
    admin_create_agenc: {
        method: 'POST',
        url: '/peanut/adm/createAgency',
    },
    get_company_support_countryArea: {
        method: 'GET',
        url: '/peanut/common/dic/getCompanySupportCountryArea',
        format: {
            response: [],
        },
    },
    check_company_exists: {
        method: 'GET',
        url: '/peanut/adm/checkCompanyExists',
    },
    get_admin_agency_contactList: {
        method: 'POST',
        url: '/peanut/adm/contactInfo/contact/getAgencyInfo',
        format: {
            response: [{
                businessCardImageList: [],
            }],
        },
    },
    add_update_admin_contactInfo: {
        method: 'POST',
        url: '/peanut/adm/contactInfo/contact/addOrUpdate',
    },
    dele_admin_contactInfo: {
        method: 'POST',
        url: '/peanut/adm/contactInfo/contact/delete',
    },
    get_admin_agency_addressList: {
        method: 'POST',
        url: '/peanut/adm/contactInfo/address/getAgencyInfo',
        format: {
            response: [],
        },
    },
    add_update_admin_addressInfo: {
        method: 'POST',
        url: '/peanut/adm/contactInfo/address/addOrUpdate',
    },
    dele_admin_addressInfo: {
        method: 'POST',
        url: '/peanut/adm/contactInfo/address/delete',
    },
    get_admin_platform_info: {
        method: 'POST',
        url: '/peanut/adm/agency/platform/getInfo',
        format: {
            response: {},
        },
    },
    edit_admin_platform_info: {
        method: 'POST',
        url: '/peanut/adm/agency/platform/editInfo',
    },
    view_admin_agency_transport: {
        method: 'GET',
        url: '/peanut/adm/viewAgencyTransport/{agencyId}',
        format: {
            response: {},
        },
    },
    view_admin_agency_mom: {
        method: 'GET',
        url: '/peanut/adm/agency/mom/detail',
        format: {
            response: {},
        },
    },
    view_admin_agency_supply: {
        method: 'GET',
        url: '/peanut/adm/agency/supplyOn/detail',
        format: {
            response: {},
        },
    },
    update_signedAgreement: {
        method: 'POST',
        url: '/peanut/adm/agency/supplyOn/updateSignedAgreement',
    },
    get_supplier_helper: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/get/helperInfo',
        format: {
            response: {
                helperBirthday: 'formatUTC+8',
            },
        },
    },
    track_event: {
        method: 'POST',
        url: '/peanut/common/eventData/save',
    },
    download_latestVersion: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/download/latestVersion',
    },
    get_contract_print_latestVersion: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/download/latestVersion/preset/print',
    },
    query_Should_ShowAd: {
        method: 'GET',
        url: '/peanut/manage/advertisement/queryShouldShow',
    },
    view_ad_info: {
        method: 'GET',
        url: '/peanut/manage/advertisement/view',
        format: {
            response: [],
        },
    },
    check_contractLink_cancel: {
        method: 'POST',
        url: '/peanut/manage/contract/share/checkContractStatus',
    },
    get_contractLink_basic: {
        method: 'POST',
        url: '/peanut/manage/contract/share/query/basicInfo',
        format: {
            response: {},
        },
    },
    get_contractLink_payment: {
        method: 'POST',
        url: '/peanut/common/contract/share/query/agencyAr',
        format: {
            response: {},
        },
    },
    get_contractLink_timeline: {
        method: 'POST',
        url: '/peanut/manage/contract/share/query/timeLine',
        format: {
            response: {},
        },
    },
    get_contractLink_other: {
        method: 'POST',
        url: '/peanut/manage/contract/share/query/otherOpenContracts',
        format: {
            response: [{
                transactionList: [{
                    stepList: [],
                }],
            }],
        },
    },
    check_timeline_salary: {
        method: 'GET',
        url: '/peanut/manage/contract/check/generateHelperSalarySchedule',
    },
    get_timeline_salary: {
        method: 'GET',
        url: '/peanut/manage/contract/getHelperSalaryScheduleInfo',
        format: {
            response: {},
        },
    },
    computing_experience_set: {
        method: 'POST',
        url: '/peanut/manage/helper/skill/reset',
    },
    computing_experience_contract_set: {
        method: 'POST',
        url: '/peanut/manage/contract/skill/reset',
    },
    get_otherRequired_list: {
        method: 'GET',
        url: '/peanut/manage/helper/getOtherRequirementList',
        format: {
            response: [],
        },
    },
    get_skill_template: {
        method: 'GET',
        url: '/peanut/manage/helper/getHelperSkillShowList',
        format: {
            response: [],
        },
    },
    get_current_charge: {
        method: 'GET',
        url: '/peanut/manage/order/getCurrentCharge',
        format: {
            response: {},
        },
    },
    query_overview_draw: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/query/transactionOverviewDraw',
        format: {
            response: {
                transactionList: [],
                nodeEdgeList: [],
            },
        },
    },
    undo_transaction_step: {
        method: 'POST',
        url: '/peanut/manage/contract/undoTransactionStep',
    },
    complete_transaction_step: {
        method: 'POST',
        url: '/peanut/manage/contract/completeTransactionStep',
        format: {
            response: {
                ecShipmentDate: 'formatUTC+8',
                confirmedTime: 'formatUTC+8',
            },
        },
    },
    update_transaction_step: {
        method: 'POST',
        url: '/peanut/manage/contract/updateTransactionStep',
    },
    precheck_update_transaction_step: {
        method: 'POST',
        url: '/peanut/manage/contract/updateTransactionStep/preCheck',
    },
    get_quickMessage_list: {
        method: 'POST',
        url: '/peanut/manage/agency/setting/quickMsg/view',
        format: {
            response: {
                items: [],
            },
        },
    },
    delete_quickMessage_list: {
        method: 'POST',
        url: '/peanut/manage/agency/setting/quickMsg/delete',
    },
    get_quickTag_indentify: {
        method: 'POST',
        url: '/peanut/manage/agency/setting/quickMsg/getIdentifierList',
        format: {
            response: [],
        },
    },
    set_quickMessage_post: {
        method: 'POST',
        url: '/peanut/manage/agency/setting/quickMsg/addOrUpdate',
    },
    quickMessage_render_get: {
        method: 'POST',
        url: '/peanut/manage/common/quickMsg/render',
        format: {
            response: [],
        },
    },
    get_task_type: {
        method: 'POST',
        url: '/peanut/manage/common/list/taskTypeByOrderTypes',
        format: {
            response: [],
        },
    },
    get_allTask_type: {
        method: 'GET',
        url: '/peanut/manage/common/list/taskType',
        format: {
            response: [],
        },
    },
    check_case_type: {
        method: 'POST',
        url: '/peanut/manage/contract/createContract/checkCaseType',
    },
    check_supplierCase_type: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/createContract/checkCaseType',
    },
    getDefaultTrainerIdInSupplierOn: {
        method: 'GET',
        url: '/peanut/manage/helper/getDefaultTrainerIdInSupplierOn',
    },
    update_expenseClaim_attachment: {
        method: 'POST',
        url: '/finance/expenseClaim/update/item/attachment',
    },
    get_followUp_person: {
        method: 'GET',
        url: '/peanut/manage/agency/getEnableUserList',
        format: {
            response: [],
        },
    },
    get_overdue_supplier: {
        method: 'GET',
        url: '/peanut/manage/dashBoard/supplier/todo/getOverdue',
        format: {
            response: [],
        },
    },
    get_helper_bio_info: {
        method: 'GET',
        url: '/peanut/manage/company/query/bioHelperDetail',
        format: {
            response: {
                basicInfo: {},
                familyBackgroundInfo: {
                    childAges: [],
                },
                jobRequestInfo: {},
                experienceInfoList: [],
                languageInfoList: [],
                otherInformationInfoList: [],
                preEmployerInfoList: [],
                skillWillingInfoList: [],
            },
        },
    },
    signPdf_draft_get: {
        method: 'GET',
        url: '/peanut/manage/contract/pdf/getDraftFilePath',
    },
    set_visit_record: {
        method: 'POST',
        url: '/peanut/adm/agency/visited/addOrUpdate',
    },
    del_visit_record: {
        method: 'POST',
        url: '/peanut/adm/agency/visited/delete',
    },
    get_visit_record_list: {
        method: 'POST',
        url: '/peanut/adm/agency/visited/getAgencyInfo',
        format: {
            response: [],
        },
    },
    share_helper_extra: {
        method: 'GET',
        url: '/peanut/manage/company/query/shareHelperExtra',
    },
    save_experienceInfo_precheck: {
        method: 'POST',
        url: '/peanut/manage/helper/saveHelperExperienceInfo/preCheck',
    },
    get_interviewSuccess_data: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/supplier/interviewSuccessRate',
        format: {
            response: {
                staffDataList: [],
            },
        },
    },
    get_contractValidity_data: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/supplier/contractValidityRate',
        format: {
            response: {
                staffDataList: [],
            },
        },
    },
    get_supplier_internal_agency_list: {
        method: 'GET',
        url: '/peanut/manage/company/queryInternalAgencyIdListForSupplier',
        format: {
            response: [],
        },
    },
    get_helperOnline_data: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/supplier/trainerId/getOverdue',
        format: {
            response: [],
        },
    },
    get_helperSource_overdue: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/supplier/helperSource/getOverdue',
        format: {
            response: [],
        },
    },
    get_reportingPassport_status: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/supplier/reportingPassportStatus/getOverdue',
        format: {
            response: [],
        },
    },
    get_category_list: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/supplier/categoryOne/pageHelperList',
        format: {
            response: {
                items: [],
            },
        },
    },
    get_hk_document: {
        method: 'POST',
        url: '/peanut/manage/contract/documents/list',
        format: {
            response: [],
        },
    },
    contractHK_document_add: {
        method: 'POST',
        url: '/peanut/manage/contract/documents/add',
    },
    contractHK_document_delete: {
        method: 'POST',
        url: '/peanut/manage/contract/documents/delete',
    },
    contractHK_timeline_basic: {
        method: 'GET',
        url: '/peanut/manage/contract/viewTimelineHead',
        format: {
            response: {},
        },
    },
    contractHK_timeline_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateTimelineHead',
    },
    contractHK_application_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateVisaApplication',
        format: {
            response: {
                immigrationAcknowledgementLetterDate: 'formatUTC+8',
                visaApplicationSubmittedDate: 'formatUTC+8',
                visaApprovedDate: 'formatUTC+8',
                visaReceivedDate: 'formatUTC+8',
                visaExpiryDate: 'formatUTC+8',
            },
        },
    },
    contractHK_pdf_parse: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/parseAcknowledgementLetter',
    },
    contractHK_ec_set: {
        method: 'POST',
        url: '/peanut/manage/contract/updateEcVerification',
        format: {
            response: {
                embassyContractSubmissionDate: 'formatUTC+8',
                ecPlannedReleaseDate: 'formatUTC+8',
                ecVerifiedDate: 'formatUTC+8',
                ecShipmentDate: 'formatUTC+8',
                ecDeliveryDate: 'formatUTC+8',
            },
        },
    },
    contractHK_calculate_date: {
        method: 'POST',
        url: '/peanut/common/util/calculateDate',
    },
    get_insurance_page: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/page',
        format: {
            response: {
                items: [],
            },
        },
    },
    create_InsuranceOrder: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/createInsuranceOrder',
    },
    parse_IpaLetter: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/parseIpaLetter',
    },
    get_insuranceOrderBasicInfo: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/viewOrderBasicInfo',
        format: {
            response: {},
        },
    },
    save_insuranceOrderBasicInfo: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/editOrderBasicInfo',
    },
    get_insuranceOrderInsuranceInfo: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/viewOrderInsuranceInfo',
        format: {
            response: {
                securityBondDischargeDate: 'formatUTC+8',
            },
        },
    },
    save_insuranceOrderInsuranceInfo: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/editOrderInsuranceInfo',
        format: {
            request: {
                securityBondDischargeDate: 'formatUTC+8',
            },
        },
    },
    query_OrderLogsByOrderId: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/queryOrderLogsByOrderId',
        format: {
            response: [],
        },
    },
    terminate_insuranceOrder: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/terminateOrder',
    },
    confirm_terminate_insuranceOrder: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/confirmTerminateOrder',
        format: {
            request: {
                securityBondDischargeDate: 'formatUTC+8',
            },
        },
    },
    confirm_cancel_insuranceOrder: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/confirmCancelOrder',
        format: {
            request: {
                securityBondDischargeDate: 'formatUTC+8',
            },
        },
    },
    cancel_insuranceOrder: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/cancelOrder',
    },
    get_listAgencyWithInsurance: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/listAgencyWithInsurance',
        format: {
            response: [],
        },
    },
    get_listInsuranceProductWithInsurance: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/listInsuranceProductWithInsurance',
        format: {
            response: [],
        },
    },
    viewInsuranceOrderAmount: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/viewOrderAmount',
        format: {
            response: {
                amountList: [],
            },
        },
    },
    insurance_addOrDeleteFile: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/addOrDeleteFile',
    },
    insurance_agency_list: {
        method: 'POST',
        url: '/peanut/manage/insurance/agency/insuranceQueryAgencyList',
        format: {
            response: {
                items: [],
            },
        },
    },
    add_insurance_agency: {
        method: 'POST',
        url: '/peanut/manage/insurance/agency/createAgency',
    },
    get_licence_insurance: {
        method: 'GET',
        url: '/peanut/manage/insurance/agency/searchAgencyList',
        format: {
            response: [],
        },
    },
    get_insurance_basic: {
        method: 'POST',
        url: '/peanut/manage/insurance/agency/viewAgencyInfo',
        format: {
            response: {
                bankInfo: {
                    taxId: '',
                    bankAccountName: '',
                    bankName: '',
                    bankAccountNo: '',
                    swiftNo: '',
                },
            },
        },
    },
    get_insurance_setting: {
        method: 'POST',
        url: '/peanut/manage/insurance/agency/viewInsuranceInfo',
        format: {
            response: [],
        },
    },
    set_insurance_basic: {
        method: 'POST',
        url: '/peanut/manage/insurance/agency/editAgencyInformation',
    },
    set_insurance_bank: {
        method: 'POST',
        url: '/peanut/manage/insurance/agency/editAgencyBankInfo',
    },
    set_insurance_setting: {
        method: 'POST',
        url: '/peanut/manage/insurance/agency/editInsuranceInfo',
    },
    view_insurance_signHistory: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/viewSignHistory',
        format: {
            response: [],
        },
    },
    generate_insuranceSignLink: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/generateSignLink',
    },
    insurance_signCodeValid: {
        method: 'GET',
        url: '/peanut/common/insurance/signCodeValid/{code}',
    },
    insurance_checkPassword: {
        method: 'GET',
        url: '/peanut/common/insurance/checkPassword/{password}/{code}',
    },
    helper_calculate_level: {
        method: 'GET',
        url: '/peanut/manage/helper/calculate/skillLevel',
    },
    contract_calculate_level: {
        method: 'GET',
        url: '/peanut/manage/contract/calculate/skillLevel',
    },
    get_ContractFeedbackBeforeSubmit: {
        method: 'POST',
        url: '/peanut/common/feedback/getContractFeedbackBeforeSubmit',
        format: {
            response: {},
        },
    },
    submit_contractFeedback: {
        method: 'POST',
        url: '/peanut/common/feedback/contractFeedback',
    },
    get_feedbackInfoByRefId: {
        method: 'GET',
        url: '/peanut/manage/contract/feedback/getInfoByRefId',
    },
    get_surveyOverdue: {
        method: 'GET',
        url: '/peanut/manage/dashBoard/agency/contract/employerSatisfactionSurvey/getOverdue',
        format: {
            response: [],
        },
    },
    update_EmployerSatisfactionSurvey: {
        method: 'POST',
        url: '/peanut/manage/contract/feedback/updateEmployerSatisfactionSurvey',
    },
    get_permission_mune: {
        method: 'GET',
        url: '/peanut/common/listMenuByAgency',
        format: {
            response: [],
        },
    },
    get_supplier_invoice: {
        method: 'GET',
        url: '/peanut/manage/company/getInvoiceInfo',
        format: {
            response: {},
        },
    },
    get_agency_guide: {
        method: 'GET',
        url: '/peanut/manage/common/agency/getGuideConfig',
        format: {
            response: [],
        },
    },
    complete_agency_guide: {
        method: 'POST',
        url: '/peanut/manage/common/agency/completeGuideConfig',
    },
    get_transport_info: {
        method: 'GET',
        url: '/peanut/manage/order/agency/getTransportInfo',
        format: {
            response: {},
        },
    },
    timeline_parse_check: {
        method: 'POST',
        url: '/peanut/manage/contract/parseIncomplete/forUpdateFile',
    },
    get_insurance_permission: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/agency/checkBeforeCreateInsurance',
    },
    createInsurance_contract_info: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/getInsuranceInfoByContractId',
    },
    get_contractInsurance_info: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/agency/listContractNoWithInsurance',
        format: {
            response: [],
        },
    },
    get_InsuranceSignFileData: {
        method: 'POST',
        url: '/peanut/common/insurance/getSignFileData',
        format: {
            response: {},
        },
    },
    saveInsurance_SignImgInfo: {
        method: 'POST',
        url: '/peanut/common/insurance/saveSignImgInfo',
    },
    preview_insuranceSignFileData: {
        method: 'POST',
        url: '/peanut/manage/insurance/getSignFileData',
        format: {
            response: {
                insuranceAddOnsList: [],
            },
        },
    },
    restore_insuranceOrder: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/restoreOrder',
    },
    agency_getInsurance_info: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/agency/getLastInsuranceByRefNo',
        format: {
            response: {},
        },
    },
    get_listInsuranceCompany: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/listInsuranceCompany',
        format: {
            response: [],
        },
    },
    get_listInsuranceProduct: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/listInsuranceProduct',
        format: {
            response: {
                insuranceCoveragePeriodList: [],
                insurancePlanList: [],
            },
        },
    },
    get_listInsuranceCompanyProduct: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/listInsuranceProductAddons',
        format: {
            response: [],
        },
    },
    get_insurance_claim: {
        method: 'POST',
        url: '/peanut/manage/insurance/order/list/forClaim',
        format: {
            response: [],
        },
    },
    search_order_insurance: {
        method: 'GET',
        url: '/peanut/manage/insurance/order/listNo/forClaim',
        format: {
            response: [],
        },
    },
    get_template_group_list: {
        method: 'GET',
        url: '/peanut/manage/setting/contract/sign/template/groupQuery',
        format: {
            response: [{
                templateList: [],
            }],
        },
    },
    get_template_single_group: {
        method: 'GET',
        url: '/peanut/manage/setting/contract/sign/template/queryOneGroup',
        format: {
            response: [],
        },
    },
    create_template: {
        method: 'POST',
        url: '/peanut/manage/setting/contract/sign/template/create/customize',
    },
    update_template: {
        method: 'PUT',
        url: '/peanut/manage/setting/contract/sign/template/edit/basicInfo',
    },
    update_template_status: {
        method: 'PUT',
        url: '/peanut/manage/setting/contract/sign/template/enableOrDisable',
    },
    delete_template: {
        method: 'PUT',
        url: '/peanut/manage/setting/contract/sign/template/del',
    },
    get_template_detail: {
        method: 'GET',
        url: '/peanut/manage/setting/contract/sign/template/detail',
        format: {
            response: {},
        },
    },
    update_template_detail: {
        method: 'PUT',
        url: '/peanut/manage/setting/contract/sign/template/edit/customizeInfo',
    },
    get_contract_sign_pdf_list: {
        method: 'GET',
        url: '/peanut/manage/contract/getContractSignFileList',
        format: {
            response: [{
                signatureCompletion: [],
                linkHistory: [],
                sendFilePathList: [],
            }],
        },
    },
    get_contract_sign_pdf_history: {
        method: 'GET',
        url: '/peanut/manage/contract/getSignHistory',
        format: {
            response: {
                linkHistory: [],
                sendFilePathList: [],
            },
        },
    },
    get_contract_sign_template_name: {
        method: 'GET',
        url: '/peanut/common/contract/getTemplateContractName',
        format: {
            response: [],
        },
    },
    get_contract_add_template_list: {
        method: 'GET',
        url: '/peanut/manage/contract/pdf/listSignTemplate/forSelect',
        format: {
            response: [],
        },
    },
    add_contract_template: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/add/signTemplate',
    },
    delete_contract_template: {
        method: 'PUT',
        url: '/peanut/manage/contract/pdf/del/signTemplate',
    },
    delete_contract_template_precheck: {
        method: 'PUT',
        url: '/peanut/manage/contract/pdf/del/signTemplate/check',
        format: {
            response: [],
        },
    },
    get_contract_template_detail: {
        method: 'GET',
        url: '/peanut/manage/contract/pdf/detail/singTemplate',
        format: {
            response: {},
        },
    },
    update_contract_template_detail: {
        method: 'PUT',
        url: '/peanut/manage/contract/pdf/edit/singTemplate',
    },
    update_contract_template_detail_precheck: {
        method: 'PUT',
        url: '/peanut/manage/contract/pdf/edit/singTemplate/check',
    },
    contractBio_video_set: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/updateContractHelperVideo',
    },
    getEmployerAddressParseInfo: {
        method: 'GET',
        url: '/peanut/manage/order/query/employerAddressParseInfo',
        format: {
            response: {},
        },
    },

    parse_twp_timeline: {
        method: 'POST',
        url: '/peanut/manage/contract/agency/parseTemporaryWorkPermit',
    },
    set_timeline_workDate: {
        method: 'POST',
        url: '/peanut/manage/contract/updateWorkPermitExpiryDateByParse',
    },
    get_agencyHelper_timelineInfo: {
        method: 'POST',
        url: '/peanut/manage/helper/event/agency/viewTimeLineInfo',
        format: {
            response: [],
        },
    },
    get_employer_status: {
        method: 'GET',
        url: '/peanut/manage/common/agency/afterSales/listEmploymentStatus',
        format: {
            response: [],
        },
    },
    get_contractCount_data: {
        method: 'GET',
        url: '/peanut/manage/helper/listContractByHelperId',
        format: {
            response: [],
        },
    },
    get_supplier_postDeployment: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/postDeployment/getInfo',
        format: {
            response: {},
        },
    },
    set_supplier_postDeployment: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/postDeployment/updateInfo',
    },
    get_agency_postDeployment: {
        method: 'POST',
        url: '/peanut/manage/contract/afterSales/agency/postDeployment/getInfo',
        format: {
            response: {},
        },
    },
    set_agency_postDeployment: {
        method: 'POST',
        url: '/peanut/manage/contract/afterSales/agency/postDeployment/updateInfo',
    },
    get_renew_contract: {
        method: 'GET',
        url: '/peanut/manage/contract/listCanRenewContract',
        format: {
            response: [],
        },
    },
    terminal_post_afterSale: {
        method: 'POST',
        url: '/peanut/manage/contract/afterSales/terminateEmploymentStatus',
    },
    get_helperOutCome_list: {
        method: 'GET',
        url: '/peanut/manage/common/agency/afterSales/listHelperOutcome',
        format: {
            response: [],
        },
    },
    get_employerTerminateIntention_list: {
        method: 'GET',
        url: '/peanut/manage/common/agency/afterSales/listEmployerTerminateIntention',
        format: {
            response: [],
        },
    },
    get_renew_data: {
        method: 'GET',
        url: '/peanut/manage/contract/getInfoForRenew',
        format: {
            response: {},
        },
    },
    getBioHelperCache: {
        method: 'GET',
        url: '/peanut/manage/company/query/bioHelperDetail/pdf',
    },
    saveBioHelperPdf: {
        method: 'PUT',
        url: '/peanut/manage/company/save/bioHelperDetail/pdf',
    },
    change_locale_lang: {
        method: 'PUT',
        url: '/peanut/manage/company/editLangCode',
    },
    create_meetting: {
        method: 'POST',
        url: '/peanut/manage/meeting/zoom/create',
    },
    get_setting_template_font: {
        method: 'GET',
        url: '/peanut/manage/setting/contract/sign/template/query/fontSetting',
    },
    set_setting_template_font: {
        method: 'PUT',
        url: '/peanut/manage/setting/contract/sign/template/edit/fontSetting',
    },
    get_contract_template_font: {
        method: 'GET',
        url: '/peanut/manage/contract/pdf/query/singTemplate/fontSetting',
    },
    set_contract_template_font: {
        method: 'PUT',
        url: '/peanut/manage/contract/pdf/edit/singTemplate/fontSetting',
    },
    create_contract_template: {
        method: 'POST',
        url: '/peanut/manage/contract/pdf/addNew/signTemplate',
    },
    update_enable_template_detail: {
        method: 'PUT',
        url: '/peanut/manage/setting/contract/sign/template/edit/customizeInfo/andEnable',
    },
    get_contract_insurance_plan_list: {
        method: 'GET',
        url: '/peanut/common/dic/list/allInsuranceCompany/planChose',
        format: {
            response: [],
        },
    },
    get_contract_insurance_add_ons_list: {
        method: 'GET',
        url: '/peanut/common/dic/list/allInsuranceCompany/addOns',
        format: {
            response: [],
        },
    },
    searchForCopyHelper: {
        method: 'POST',
        url: '/peanut/manage/helper/searchHelperForCopyHelper',
        format: {
            response: [],
        },
    },
    copy_OtherAgencyHelper: {
        method: 'POST',
        url: '/peanut/manage/helper/copyOtherAgencyHelper',
    },
    edit_payment_slip: {
        method: 'POST',
        url: '/finance/paymentOrder/updatePaymentSlip',
    },
    query_contract_fee: {
        method: 'GET',
        url: '/peanut/manage/ar/queryContractArByGeneralFeeType',
        format: {
            response: {},
        },
    },
    get_employer_timelineInfo: {
        method: 'GET',
        url: '/peanut/manage/employer/event/viewTimeLineInfo',
        format: {
            response: [],
        },
    },
    update_employer_timelineInfo: {
        method: 'POST',
        url: '/peanut/manage/employer/event/createOrUpdateEvent',
    },
    get_contract_info_collection_list: {
        method: 'GET',
        url: '/peanut/manage/contract/queryApplicableCollectLinks',
    },
    precheck_contract_info_collection_link: {
        method: 'GET',
        url: '/peanut/manage/contract/checkBeforeCopyCollectLinks',
    },
    generate_contract_info_collection_link: {
        method: 'GET',
        url: '/peanut/manage/contract/copyCollectLinks',
    },
    get_contract_collect_employer_info: {
        method: 'GET',
        url: '/peanut/common/collect/viewContractEmployerInfo',
        format: {
            response: {
                employerIdCardAttachList: [],
                currentHelperInfo: [],
            },
        },
    },
    get_contract_collect_employer_family: {
        method: 'GET',
        url: '/peanut/common/collect/viewEmployerFamilyMemberList',
    },
    get_contract_collect_employer_basic: {
        method: 'GET',
        url: '/peanut/common/collect/viewBasicInfoOfApplication',
    },
    save_contract_collect_employer_info: {
        method: 'POST',
        url: '/peanut/common/collect/saveContractEmployerInfo',
    },
    submit_contract_collect_employer_info: {
        method: 'POST',
        url: '/peanut/common/collect/submitContractEmployerInfo',
    },
    get_contract_collect_sponsor_joint_info: {
        method: 'GET',
        url: '/peanut/common/collect/viewJointSponsorSelfInfo',
    },
    save_contract_collect_sponsor_joint_info: {
        method: 'POST',
        url: '/peanut/common/collect/saveJointSponsorSelfInfo',
    },
    submit_contract_collect_sponsor_joint_info: {
        method: 'POST',
        url: '/peanut/common/collect/submitJointSponsorSelfInfo',
    },
    get_contract_collect_jobOffer_info: {
        method: 'GET',
        url: '/peanut/common/collect/viewJobOffer',
        format: {
            response: {
                childAges: [],
                infantAges: [],
            },
        },
    },
    save_contract_collect_jobOffer_info: {
        method: 'POST',
        url: '/peanut/common/collect/saveJobOffer',
    },
    submit_contract_collect_jobOffer_info: {
        method: 'POST',
        url: '/peanut/common/collect/submitJobOffer',
    },
    save_hk_contract_collect_employer_info: {
        method: 'POST',
        url: '/peanut/common/collect/saveContractEmployerInfo/hk',
    },
    submit_hk_contract_collect_employer_info: {
        method: 'POST',
        url: '/peanut/common/collect/submitContractEmployerInfo/hk',
    },
    save_hk_contract_collect_jobOffer_info: {
        method: 'POST',
        url: '/peanut/common/collect/saveJobOffer/hk',
    },
    submit_hk_contract_collect_jobOffer_info: {
        method: 'POST',
        url: '/peanut/common/collect/submitJobOffer/hk',
    },
    save_hk_sales_contract_collect_employer_info: {
        method: 'POST',
        url: '/peanut/common/collect/saveContractEmployerInfo/hk/salesContract',
    },
    submit_hk_sales_contract_collect_employer_info: {
        method: 'POST',
        url: '/peanut/common/collect/submitContractEmployerInfo/hk/salesContract',
    },
    save_hk_sales_contract_collect_jobOffer_info: {
        method: 'POST',
        url: '/peanut/common/collect/saveJobOffer/hk/salesContract',
    },
    submit_hk_sales_contract_collect_jobOffer_info: {
        method: 'POST',
        url: '/peanut/common/collect/submitJobOffer/hk/salesContract',
    },
    get_contract_collect_contract_info: {
        method: 'GET',
        url: '/peanut/common/collect/getContractMainInfo',
    },
    get_supplier_contract_collect_employer_info: {
        method: 'GET',
        url: '/peanut/common/supplier/collect/viewContractEmployerInfo',
        format: {
            response: {
                employerIdCardAttachList: [],
            },
        },
    },
    get_supplier_contract_collect_employer_family: {
        method: 'GET',
        url: '/peanut/common/supplier/collect/viewEmployerFamilyMemberList',
    },
    get_supplier_contract_collect_employer_basic: {
        method: 'GET',
        url: '/peanut/common/supplier/collect/viewBasicInfoOfApplication',
    },
    save_supplier_contract_collect_employer_info: {
        method: 'POST',
        url: '/peanut/common/supplier/collect/saveContractEmployerInfo',
    },
    submit_supplier_contract_collect_employer_info: {
        method: 'POST',
        url: '/peanut/common/supplier/collect/submitContractEmployerInfo',
    },
    get_supplier_contract_collect_jobOffer_info: {
        method: 'GET',
        url: '/peanut/common/supplier/collect/viewJobOffer',
        format: {
            response: {
                childAges: [],
                infantAges: [],
            },
        },
    },
    save_supplier_contract_collect_jobOffer_info: {
        method: 'POST',
        url: '/peanut/common/supplier/collect/saveJobOffer',
    },
    submit_supplier_contract_collect_jobOffer_info: {
        method: 'POST',
        url: '/peanut/common/supplier/collect/submitJobOffer',
    },
    get_helper_refer_contract: {
        method: 'POST',
        url: '/peanut/manage/helper/queryFriendReferralHasContract',
    },
    add_helper_refer_manual_transaction: {
        method: 'POST',
        url: '/peanut/manage/helper/manualTransaction',
    },
    get_course_tree: {
        method: 'GET',
        url: '/peanut/manage/helper/train/getCourseList',
        format: {
            response: [],
        },
    },
    save_course_record: {
        method: 'POST',
        url: '/peanut/manage/helper/train/uploadTrainRecord',
    },
    get_helper_course_record: {
        method: 'GET',
        url: '/peanut/manage/helper/train/getTrainRecords',
        format: {
            response: [{
                fileList: [],
                lessonList: [{
                    fileList: [],
                    moduleList: [{
                        fileList: [],
                    }],
                }],
            }],
        },
    },
    get_helper_share_course_record: {
        method: 'GET',
        url: '/peanut/common/share/train/getTrainRecords',
        format: {
            response: [{
                fileList: [],
                lessonList: [{
                    fileList: [],
                    moduleList: [{
                        fileList: [],
                    }],
                }],
            }],
        },
    },
    get_contract_helper_course_share_code: {
        method: 'GET',
        url: '/peanut/manage/contract/share/signContractLink',
    },
    get_contract_helper_course_record: {
        method: 'GET',
        url: '/peanut/manage/contract/train/getTrainRecords',
        format: {
            response: [{
                fileList: [],
                lessonList: [{
                    fileList: [],
                    moduleList: [{
                        fileList: [],
                    }],
                }],
            }],
        },
    },
    get_contract_share_helper_course_record: {
        method: 'GET',
        url: '/peanut/common/share/train/contract',
        format: {
            response: {
                trainRecords: [{
                    fileList: [],
                    lessonList: [{
                        fileList: [],
                        moduleList: [{
                            fileList: [],
                        }],
                    }],
                }],
            },
        },
    },
    get_contract_volume_detail: {
        method: 'POST',
        url: '/peanut/manage/dashBoard/contract/getPerformance',
        format: {
            response: {
                staffList: [],
                total: {},
            },
        },
    },
    get_invoice_payer_email: {
        method: 'GET',
        url: '/peanut/manage/ar/invoice/checkPayerEmail',
        format: {
            response: {
            },
        },
    },
    get_payer_id: {
        method: 'GET',
        url: '/peanut/manage/ar/getPayerInfo',
        format: {
            response: {
            },
        },
    },
    get_contract_philippine_recruitment_agency_list: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/queryPhilippineRecruitmentAgencyList',
        format: {
            response: [],
        },
    },
    update_contract_philippine_recruitment_agency: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/editPhilippineRecruitmentAgency',
    },
    get_singpass_link: {
        method: 'GET',
        url: '/peanut/common/thirdparty/singpass/auth',
    },
    get_singpass_user_info: {
        method: 'GET',
        url: '/peanut/common/thirdparty/singpass/getUserInfo',
    },
    precheck_contract_info_collection_link_no_auth: {
        method: 'GET',
        url: '/peanut/common/collect/checkBeforeCopyCollectLinks',
    },
    generate_contract_info_collection_link_no_auth: {
        method: 'GET',
        url: '/peanut/common/collect/copyCollectLinks',
    },
    get_contract_collect_employer_spouse_info: {
        method: 'GET',
        url: '/peanut/common/collect/viewContractEmployerSpouseInfo',
        format: {
            response: {},
        },
    },
    submit_contract_collect_employer_spouse_info: {
        method: 'POST',
        url: '/peanut/common/collect/submitContractEmployerSpouseInfo',
    },
    get_contract_collect_sponsor_joint_spouse_info: {
        method: 'GET',
        url: '/peanut/common/collect/viewJointSponsorSpouseInfo',
        format: {
            response: {},
        },
    },
    submit_contract_collect_sponsor_joint_spouse_info: {
        method: 'POST',
        url: '/peanut/common/collect/submitJointSponsorSpouseInfo',
    },
    update_departure_photo: {
        method: 'POST',
        url: '/peanut/manage/order/editDeparturePhotoList',
    },
    update_twp_expiry_date: {
        method: 'POST',
        url: '/peanut/manage/order/editOrderTwpExpiryDate',
    },
    change_agency_status: {
        method: 'POST',
        url: '/peanut/manage/order/changeTransportAgencyEnableStatus',
    },

    get_loan_order_list: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/pageQuery',
        format: {
            request: {
                nextFollowUpDateStart: 'formatUTC+8',
                nextFollowUpDateEnd: 'formatUTC+8',
                helperDepartureDateStart: 'formatUTC+8',
                helperDepartureDateEnd: 'formatUTC+8',
                loanStartDateStart: 'formatUTC+8',
                loanStartDateEnd: 'formatUTC+8',
            },
            response: {
                items: [{
                    helperDepartureDate: 'formatUTC+8',
                    loanStartDate: 'formatUTC+8',
                    remarkList: [{
                        createTime: 'formatUTC+8',
                    }],
                    chequeNoList: [],
                }],
            },
        },
    },
    get_loan_order_remark: {
        method: 'GET',
        url: '/peanut/manage/loan/loanOrder/viewRemark',
        format: {
            response: [{
                createTime: 'formatUTC+8',
            }],
        },
    },
    save_loan_order_remark: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/updateRemark',
    },
    get_loan_order_main_info: {
        method: 'GET',
        url: '/peanut/manage/loan/loanOrder/viewMainInfo',
        format: {
            response: {},
        },
    },
    get_loan_order_basic_info: {
        method: 'GET',
        url: '/peanut/manage/loan/loanOrder/viewInformation',
        format: {
            response: {},
        },
    },
    save_loan_order_basic_info: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/editInformation',
    },
    get_loan_order_docs: {
        method: 'GET',
        url: '/peanut/manage/loan/loanOrder/viewApplicationDocs',
        format: {
            response: {
                signatureAssessmentApplicationForm: [],
                signaturePromissoryNote: [],
                signatureDisclosureStatement: [],
                signatureWaiverConfidentialityNotice: [],
                signatureLoanReleaseSheet: [],
                signatureOthers: [],
                borrowerLatestProofOfBilling: [],
                borrowerTwoValidIds: [],
                borrowerContractOfferLetter: [],
                borrowerOec: [],
                borrowerVisa: [],
                borrowerDepartureTicket: [],
                cheque: [],
                borrowerProofOfPaymentToBorrower: [],
                borrowerProofOthers: [],
                coBorrowerProofOfRelationship: [],
                coBorrowerLatestProofOfBilling: [],
                coBorrowerTwoValidIds: [],
                coBorrowerBarangayPoliceClearance: [],
                coBorrowerProofOthers: [],
            },
        },
    },
    save_loan_order_docs: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/editApplicationDocs',
    },
    retrieve_loan_order_doc: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/retrieve/fromContract',
    },
    get_loan_order_follow_up: {
        method: 'GET',
        url: '/peanut/manage/loan/loanOrder/viewFollowUp',
        format: {
            response: [{
                operateTime: 'formatUTC+8',
                nextFollowUpDate: 'formatUTC+8',
                stageDate: 'formatUTC+8',
                canDepositChequeDate: 'formatUTC+8',
                bouncedDate: 'formatUTC+8',
                attachments: [],
                recordLog: {
                    repaymentPlanList: [{
                        salaryDate: 'formatUTC+8',
                        salaryDateChangeTo: 'formatUTC+8',
                        dueDate: 'formatUTC+8',
                        dueDateChangeTo: 'formatUTC+8',
                        nextFollowUpDate: 'formatUTC+8',
                        originalDueDateOnCheque: 'formatUTC+8',
                    }],
                },
            }],
        },
    },
    get_loan_order_loan_computation: {
        method: 'GET',
        url: '/peanut/manage/loan/loanOrder/feeBreakDown/viewLoanComputation',
        format: {
            response: {
                interestRate: 'formatPercent',
                serviceFeeRate: 'formatPercent',
            },
        },
    },
    save_loan_order_loan_computation: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/feeBreakDown/editLoanComputation',
        format: {
            request: {
                interestRate: 'formatPercent',
                serviceFeeRate: 'formatPercent',
            },
            response: {
            },
        },
    },
    get_loan_order_repayment_plan: {
        method: 'GET',
        url: '/peanut/manage/loan/loanOrder/feeBreakDown/viewRepaymentPlan',
        format: {
            response: {
                helperDepartureDate: 'formatUTC+8',
                loanStartDate: 'formatUTC+8',
                estimatedFirstSalaryDate: 'formatUTC+8',
                estimatedFirstPaymentDate: 'formatUTC+8',
                repaymentPlanList: [{
                    salaryDate: 'formatUTC+8',
                    originalDueDateOnCheque: 'formatUTC+8',
                    dueDate: 'formatUTC+8',
                    nextFollowUpDate: 'formatUTC+8',
                    stageDate: 'formatUTC+8',
                    canDepositChequeDate: 'formatUTC+8',
                    bouncedDate: 'formatUTC+8',
                    arInfo: [],
                }],
            },
        },
    },
    compute_loan_order_repayment_fee: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/feeBreakDown/computeRepaymentPlan',
        format: {
            response: {
                repaymentPlanList: [],
            },
        },
    },
    save_loan_order_repayment_plan: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/feeBreakDown/editRepaymentPlan',
        format: {
            request: {
                helperDepartureDate: 'formatUTC+8',
                loanStartDate: 'formatUTC+8',
                estimatedFirstSalaryDate: 'formatUTC+8',
                estimatedFirstPaymentDate: 'formatUTC+8',
                repauymentPlanList: [{
                    salaryDate: 'formatUTC+8',
                    originalDueDateOnCheque: 'formatUTC+8',
                }],
            },
            response: {
            },
        },
    },
    approve_loan_order: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/approve',
    },
    reset_loan_order: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/reset',
    },
    precheck_release_loan: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/releaseLoanCheck',
    },
    release_loan_order: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/releaseLoan',
        format: {
            request: {
                paymentDate: 'formatUTC+8',
            },
        },
    },
    precheck_reverse_loan: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/reverseCheck',
    },
    reverse_loan_order: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/reverse',
    },
    get_repayment_plan_list: {
        method: 'POST',
        url: '/peanut/manage/loan/repaymentPlan/pageQuery',
        format: {
            request: {
                nextFollowUpDateStart: 'formatUTC+8',
                nextFollowUpDateEnd: 'formatUTC+8',
                dueDateStart: 'formatUTC+8',
                dueDateEnd: 'formatUTC+8',
                originalDueDateOnChequeStart: 'formatUTC+8',
                originalDueDateOnChequeEnd: 'formatUTC+8',
                canDepositChequeDateStart: 'formatUTC+8',
                canDepositChequeDateEnd: 'formatUTC+8',
            },
            response: {
                items: [{
                    salaryDate: 'formatUTC+8',
                    dueDate: 'formatUTC+8',
                    originalDueDateOnCheque: 'formatUTC+8',
                    nextFollowUpDate: 'formatUTC+8',
                    stageDate: 'formatUTC+8',
                    canDepositChequeDate: 'formatUTC+8',
                    bouncedDate: 'formatUTC+8',
                    remarkList: [{
                        createTime: 'formatUTC+8',
                    }],
                    arInfo: [],
                }],
            },
        },
    },
    get_repayment_plan_remark: {
        method: 'GET',
        url: '/peanut/manage/loan/repaymentPlan/viewRemark',
        format: {
            response: [{
                createTime: 'formatUTC+8',
            }],
        },
    },
    save_repayment_plan_remark: {
        method: 'POST',
        url: '/peanut/manage/loan/repaymentPlan/updateRemark',
    },
    get_contract_loan_order_info: {
        method: 'GET',
        url: '/peanut/manage/loan/loanOrder/getByContractId',
        format: {
            response: [],
        },
    },
    record_repayment_plan_follow_up: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/createFollowUp',
        format: {
            request: {
                nextFollowUpDate: 'formatUTC+8',
                stageDate: 'formatUTC+8',
                canDepositChequeDate: 'formatUTC+8',
                bouncedDate: 'formatUTC+8',
                repaymentPlanList: [{
                    salaryDate: 'formatUTC+8',
                    salaryDateChangeTo: 'formatUTC+8',
                    dueDate: 'formatUTC+8',
                    canDepositChequeDate: 'formatUTC+8',
                    nextFollowUpDate: 'formatUTC+8',
                }],
            },
        },
    },
    update_repayment_plan_collector: {
        method: 'POST',
        url: '/peanut/manage/loan/repaymentPlan/updateCollector',
    },
    get_lending_dashboard_todo_plan_list: {
        method: 'POST',
        url: '/peanut/manage/loan/dashboard/todoList',
        format: {
            response: {
                collectorTodoBoList: [],
                remainderOneQuery: {
                    collectorIdList: [],
                    collectStageList: [],
                },
                remainderTwoQuery: {
                    collectorIdList: [],
                    collectStageList: [],
                },
                remainderThreeQuery: {
                    collectorIdList: [],
                    collectStageList: [],
                },
                demandOneQuery: {
                    collectorIdList: [],
                    collectStageList: [],
                },
                demandTwoQuery: {
                    collectorIdList: [],
                    collectStageList: [],
                },
                collectionAgencyQuery: {
                    collectorIdList: [],
                    collectStageList: [],
                },
                fileToCourtQuery: {
                    collectorIdList: [],
                    collectStageList: [],
                },
            },
        },
    },
    get_lending_dashboard_todo_order_list: {
        method: 'GET',
        url: '/peanut/manage/loan/dashboard/helperSituation',
        format: {
            response: {
                todoBoList: [],
                countQuery: {},
            },
        },
    },
    get_lending_dashboard_statistics_to_be_settled_order: {
        method: 'POST',
        url: '/peanut/manage/loan/dashboard/tobeSettleOrder',
        format: {
            response: {
                todoBoList: [],
                countQuery: {},
            },
        },
    },
    get_lending_dashboard_analytics: {
        method: 'POST',
        url: '/peanut/manage/loan/dashboard/analytics',
        format: {
            response: [],
        },
    },
    get_PH_embassy_list: {
        method: 'GET',
        url: '/peanut/manage/contract/singapore/queryReserveList',
        format: {
            response: [{
                remark: [],
                reserveList: [],
            }],
        },
    },
    add_PH_embassy_remark: {
        method: 'POST',
        url: '/peanut/manage/contract/singapore/reserve/addRemark',
    },
    get_related_training_order: {
        method: 'GET',
        url: '/peanut/manage/training/trainingOrder/queryBySupplierHelperId',
        format: {
            response: {},
        },
    },
    get_training_order_list: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/pageQuery',
        format: {
            request: {
                condition: {
                    departureDateStart: 'formatUTC+8',
                    departureDateEnd: 'formatUTC+8',
                },
            },
            response: {
                items: [{
                    remarkList: [{
                        createTime: 'formatUTC+8',
                    }],
                    paymentOptions: {},
                }],
            },
        },
    },
    complete_training_order: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/completeTraining',
    },
    close_training_order: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/close',
    },
    terminate_training_order: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/terminate',
    },
    reopen_training_order: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/reopen',
    },
    cancel_training_order: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/cancel',
    },
    reverse_training_order: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/reverse',
    },
    start_training_training_order: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/startTraining',
    },
    check_start_training_training_order: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/startTrainingCheck',
    },
    get_training_order_remark: {
        method: 'GET',
        url: '/peanut/manage/training/trainingOrder/viewRemark',
        format: {
            response: [{
                createTime: 'formatUTC+8',
            }],
        },
    },
    save_training_order_remark: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/updateRemark',
    },
    get_training_order_main_info: {
        method: 'GET',
        url: '/peanut/manage/training/trainingOrder/viewMainInfo',
        format: {
            response: {
                arInfo: [],
            },
        },
    },
    get_training_order_basic_info: {
        method: 'GET',
        url: '/peanut/manage/training/trainingOrder/viewInformation',
        format: {
            response: {
                departureDate: 'formatUTC+8',
            },
        },
    },
    save_training_order_basic_info: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/editInformation',
    },
    get_training_order_docs: {
        method: 'GET',
        url: '/peanut/manage/training/trainingOrder/viewApplicationDocs',
        format: {
            response: {
                serviceAgreement: [],
                certificateFile: [],
                otherFile: [],
            },
        },
    },
    save_training_order_docs: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/editApplicationDocs',
    },
    retrieve_training_order_doc: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/retrieve/fromContract',
    },
    get_contract_training_order_info: {
        method: 'GET',
        url: '/peanut/manage/training/trainingOrder/queryListByContractId',
        format: {
            response: [{
                paymentOptions: {},
            }],
        },
    },
    get_training_order_dashboard_pending_payment: {
        method: 'GET',
        url: '/peanut/manage/training/dashboard/pendingPayment',
        format: {
            response: [],
        },
    },
    get_training_order_ar_info: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/queryOrderArDetail',
        format: {
            response: {
                arInfo: [],
                feeDetail: [],
            },
        },
    },
    save_training_order_ar_info: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/updateOrderArDetail',
    },
    get_training_order_payment_options: {
        method: 'GET',
        url: '/peanut/manage/training/trainingOrder/viewAgreedPaymentOptions',
        format: {
            response: {},
        },
    },
    save_training_order_payment_options: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/editAgreedPaymentOptions',
    },
    get_training_order_loan_order_info: {
        method: 'GET',
        url: '/peanut/manage/loan/loanOrder/getByTrainingOrderId',
        format: {
            response: [],
        },
    },
    get_training_list_for_claim: {
        method: 'POST',
        url: '/peanut/manage/training/trainingOrder/listForClaim',
        format: {
            response: [],
        },
    },
    get_lending_list_for_claim: {
        method: 'POST',
        url: '/peanut/manage/loan/loanOrder/listForClaim',
        format: {
            response: [],
        },
    },
    get_supplier_report_status_list: {
        method: 'GET',
        url: '/peanut/manage/common/list/supplierReportStatus',
        format: {
            response: [],
        },
    },
    save_received_basic_info: {
        method: 'POST',
        url: '/finance/ar/receivedOrder/updateReceivedOrder',
    },
    save_payment_basic_info: {
        method: 'POST',
        url: '/finance/paymentOrder/updatePaymentOrder',
    },
    get_admin_agency_user_list: {
        method: 'GET',
        url: '/peanut/manage/company/queryManagerListByCompanyId',
        format: {
            response: [],
        },
    },
    get_contract_agency_info: {
        method: 'GET',
        url: '/peanut/manage/contract/getCompanyInfo',
        format: {
            response: {},
        },
    },
    get_contract_employment_agency: {
        method: 'GET',
        url: '/peanut/manage/contract/getEmploymentAgency',
        format: {
            response: {},
        },
    },
    get_ph_ipa_agency_list: {
        method: 'GET',
        url: '/peanut/manage/contract/queryContractAgencyList',
        format: {
            response: [{
                bindIdList: [],
                bindList: [],
            }],
        },
    },
    set_ipa_ph_agency: {
        method: 'POST',
        url: '/peanut/manage/contract/updateIpaAgencyPhAgency',
    },
    get_contract_ipa_agency_info_by_code: {       // 根据code获取公司信息
        method: 'GET',
        url: '/peanut/common/ipaAgencyInfo/{code}',
    },
    // 进入签字页面 根据合同获取Employment Agency信息
    get_contract_ipa_employment_agency_by_code: {
        method: 'GET',
        url: '/peanut/common/employmentAgency/{code}',
    },
    get_ipa_foreign_agency_list: {
        method: 'GET',
        url: '/peanut/manage/agency/setting/queryContractAgencyList',
        format: {
            response: [{
                eaPersonnelBirthday: 'formatUTC+8',
                bindIdList: [],
                bindList: [],
            }],
        },
    },
    create_ipa_foreign_agency: {
        method: 'POST',
        url: '/peanut/manage/agency/setting/createContractAgency',
        format: {
            request: {
                eaPersonnelBirthday: 'formatUTC+8',
            },
        },
    },
    update_ipa_foreign_agency: {
        method: 'POST',
        url: '/peanut/manage/agency/setting/editContractAgency',
        format: {
            request: {
                eaPersonnelBirthday: 'formatUTC+8',
            },
        },
    },
    change_ipa_agency_status: {
        method: 'POST',
        url: '/peanut/manage/agency/setting/editContractAgencyStatus',
    },
    set_foreign_placement_recruitment_agency: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/updateIpaAgencyPhAgency',
    },
    get_share_helper_list_link_info: {
        method: 'GET',
        url: '/peanut/common/getShareFilter/byCode',
        format: {
            response: {
                filterConfig: {},
            },
        },
    },
    change_share_helper_list_link_status: {
        method: 'POST',
        url: '/peanut/manage/supplier/setting/shareHelperLinkConfig/updateEnableStatus',
    },
    update_share_helper_list_link: {
        method: 'POST',
        url: '/peanut/manage/supplier/setting/shareHelperLinkConfig/update',
    },
    create_share_helper_list_link: {
        method: 'POST',
        url: '/peanut/manage/supplier/setting/shareHelperLinkConfig/create',
    },
    get_share_helper_list_link_list: {
        method: 'GET',
        url: '/peanut/manage/supplier/setting/shareHelperLinkConfig/queryList',
        format: {
            response: [{
                filterConfig: {
                    jobTitleList: [],
                    genderList: [],
                    nationality: [],
                    helperType: [],
                },
            }],
        },
    },
    get_search_share_helper_list_count: {
        method: 'GET',
        url: '/peanut/manage/company/query/supplierShareHelperCountInfo',
        format: {
            response: {
                onlineTypeCount: {},
                onlineNationalityCount: {},
            },
        },
    },
    search_share_helper_list: {
        method: 'POST',
        url: '/peanut/manage/company/getShareHelperList',
        format: {
            request: {
                onlineTimeStart: 'formatUTC+8',
                onlineTimeEnd: 'formatUTC+8',
                displayOnlineTimeStart: 'formatUTC+8',
                displayOnlineTimeEnd: 'formatUTC+8',
            },
            response: {
                items: [{
                    additionalInfo: {},
                }],
            },
        },
    },
    get_share_helper_detail: {
        method: 'POST',
        url: '/peanut/manage/company/query/shareHelperDetailInfo',
        format: {
            response: {
                basicInfo: {
                    firstInterviewVideoList: [],
                },
                familyBackgroundInfo: {},
                jobRequestInfo: {},
                languageInfoList: [],
                experienceInfoList: [],
                otherInformationInfoList: [],
                preEmployerInfoList: [],
                skillWillingInfoList: [],
            },
        },
    },
    get_short_share_helper_list_link: {
        method: 'GET',
        url: '/peanut/manage/company/query/exchangeNewShareLink',
        format: {
        },
    },
    get_signature_certificate: {
        method: 'GET',
        url: '/peanut/common/pdf/getSignatureCertificate',
        format: {
            response: {
                templateName: '',
                domainName: '',
                certificateId: '',
                signAuditList: [],
            },
        },
    },
    check_contract_MOM_file: {
        method: 'GET',
        url: '/peanut/manage/contract/pdf/checkMomFile',
    },
    get_helper_priority_period: {
        method: 'GET',
        url: '/peanut/manage/helper/event/queryPriorityPeriod',
        format: {
            response: [],
        },
    },
    edit_helper_priority_period: {
        method: 'POST',
        url: '/peanut/manage/helper/event/editPriorityPeriod',
    },
    update_interview_availability_status: {
        method: 'POST',
        url: '/peanut/manage/helper/update/interviewAvailability',
    },
    retrieve_from_helper: {
        method: 'POST',
        url: '/peanut/manage/contract/retrieve/fromHelper',
    },
    get_agency_by_easy_id: {
        method: 'GET',
        url: '/peanut/manage/company/queryCompanyByIdentityNo',
    },
    get_agency_side_agency_list: {
        method: 'POST',
        url: '/peanut/manage/company/agency/pageQueryAgencyList',
    },
    create_agency_side_agency: {
        method: 'POST',
        url: '/peanut/manage/company/agency/createAgency',
    },
    get_agency_side_agency_detail: {
        method: 'GET',
        url: '/peanut/manage/company/agency/viewAgencyInfo',
    },
    update_agency_side_agency: {
        method: 'POST',
        url: '/peanut/manage/company/agency/eidtAgency',
    },
    add_helper_to_shortlist: {
        method: 'POST',
        url: '/peanut/manage/helper/collect/add/{helperId}',
    },
    remove_helper_from_shortlist: {
        method: 'POST',
        url: '/peanut/manage/helper/collect/delete/{helperId}',
    },
    update_supplier_contract_ec_print_operator: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/updateEcPrintOperator',
    },
    get_helper_additional_info: {
        method: 'POST',
        url: '/peanut/common/helper/queryAdditionalInfo',
        format: {
            response: [],
        },
    },
    get_contract_timeline_payment_detail: {
        method: 'GET',
        url: '/peanut/manage/training/trainingOrder/queryOrderAndReceivedByContractId',
        format: {
            response: {
                paymentOptions: {},
                receivedOrderList: [],
            },
        },
    },
    precheck_contract_payment_not_applicable: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/step/checkBeforeNotApplicable',
    },
    contract_payment_not_applicable: {
        method: 'POST',
        url: '/peanut/manage/supplier/contract/step/notApplicable',
    },
    precheck_contract_fully_payment_complete: {
        method: 'GET',
        url: '/peanut/manage/supplier/contract/step/checkBeforeComplete',
    },
    update_helper_file: {
        method: 'POST',
        url: '/peanut/manage/helper/file/update',
    },
    update_pj_order_visa_file: {
        method: 'POST',
        url: '/peanut/manage/order/file/update',
    },
    ai_extract: {
        method: 'POST',
        url: '/peanut/manage/employer/enquiryInfo/ai/requirementExtract',
    },
    update_enquiry_requirement: {
        method: 'POST',
        url: '/peanut/manage/employer/enquiryInfo/updateRequirement',
    },
    update_employer_requirement: {
        method: 'POST',
        url: '/peanut/manage/employer/job/updateRequirement',
    },
    get_invoice_note_list: {
        method: 'GET',
        url: '/peanut/manage/company/getInvoiceNoteList',
        format: {
            response: [],
        },
    },
    update_invoice_note: {
        method: 'POST',
        url: '/peanut/manage/company/editInvoiceNote',
    },
    get_employer_request_history: {
        method: 'GET',
        url: '/peanut/manage/employer/requirement/queryExtractRecord',
        format: {
            response: [{
                parsed: {},
            }],
        },
    },
    save_employer_request: {
        method: 'POST',
        url: '/peanut/manage/employer/requirement/manual/extract',
    },
    edit_valid_employer: {
        method: 'POST',
        url: '/peanut/manage/employer/enquiryInfo/editValidEmployer',
    },

    // ==================== 公司分支 CompanyBranch ====================
    company_branch_list: {
        method: 'GET',
        url: '/peanut/manage/companyBranch/list/{companyId}',
    },
    company_branch_save: {
        method: 'POST',
        url: '/peanut/manage/companyBranch/save',
    },
    company_branch_set_head_office: {
        method: 'POST',
        url: '/peanut/manage/companyBranch/setHeadOffice',
    },
    contract_update_company_branch_id: {
        method: 'POST',
        url: '/peanut/manage/contract/updateCompanyBranchId',
    },

    // ==================== Helper 定制化信息 HelperCustomized ====================
    helper_customized_view: {
        method: 'GET',
        url: '/peanut/manage/helper/customized/view/{helperId}',
    },
    helper_customized_update_block: {
        method: 'POST',
        url: '/peanut/manage/helper/customized/updateBlock',
    },
    helper_customized_generate_sign_link: {      // 生成 helper 签字收集链接
        method: 'POST',
        url: '/peanut/manage/helper/customized/generateSignLink',
    },
    helper_customized_sign_link_valid: {         // 校验 helper 签字链接
        method: 'GET',
        url: '/peanut/common/helper/customized/signLink/{linkCode}',
    },
    helper_customized_check_password: {          // 校验 helper 签字密码（生日 ddMMyyyy）
        method: 'GET',
        url: '/peanut/common/helper/customized/checkPassword/{password}/{linkCode}',
    },
    helper_customized_save_signature: {          // 收集 helper 签字
        method: 'POST',
        url: '/peanut/common/helper/customized/saveSignature',
    },

    // ==================== Bio 模板设置 BioTemplate ====================
    bio_template_list: {
        method: 'GET',
        url: '/peanut/manage/setting/bio/template/list',
        format: {
            response: [],
        },
    },
    bio_template_detail: {
        method: 'GET',
        url: '/peanut/manage/setting/bio/template/detail',
        format: {
            response: {},
        },
    },
    bio_template_enabled: {                       // 按 companyId + agencyNo 查已启用的 Bio 模板（公开接口）
        method: 'GET',
        url: '/peanut/common/bio/template/enabled',
        format: {
            response: {},
        },
    },
    bio_template_agencies: {                     // 可分享定制化 Bio 的 Agency
        method: 'GET',
        url: '/peanut/manage/setting/bio/template/agencies',
        format: {
            response: [],
        },
    },
    bio_template_create: {
        method: 'POST',
        url: '/peanut/manage/setting/bio/template/create',
    },
    bio_template_edit_basic: {
        method: 'PUT',
        url: '/peanut/manage/setting/bio/template/edit/basicInfo',
    },
    bio_template_edit_content: {
        method: 'PUT',
        url: '/peanut/manage/setting/bio/template/edit/customizeInfo',
    },
    bio_template_enable_or_disable: {
        method: 'PUT',
        url: '/peanut/manage/setting/bio/template/enableOrDisable',
    },
    bio_template_del: {
        method: 'PUT',
        url: '/peanut/manage/setting/bio/template/del',
    },
}
